"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// .svgr-output/web/index.ts
var web_exports = {};
__export(web_exports, {
  IconActionAdd: () => IconActionAdd,
  IconActionAddAttachment: () => IconActionAddAttachment,
  IconActionAddFromSearch: () => IconActionAddFromSearch,
  IconActionAddImage: () => IconActionAddImage,
  IconActionAddNote: () => IconActionAddNote,
  IconActionArchiveItem: () => IconActionArchiveItem,
  IconActionCallSupport: () => IconActionCallSupport,
  IconActionClear: () => IconActionClear,
  IconActionCloseModal: () => IconActionCloseModal,
  IconActionClosePanel: () => IconActionClosePanel,
  IconActionCloseTable: () => IconActionCloseTable,
  IconActionCollapseSection: () => IconActionCollapseSection,
  IconActionCopy: () => IconActionCopy,
  IconActionDatePicker: () => IconActionDatePicker,
  IconActionDelete: () => IconActionDelete,
  IconActionDownloadFile: () => IconActionDownloadFile,
  IconActionDropdownExpand: () => IconActionDropdownExpand,
  IconActionEdit: () => IconActionEdit,
  IconActionExpandSection: () => IconActionExpandSection,
  IconActionFavorited: () => IconActionFavorited,
  IconActionGenerateDocument: () => IconActionGenerateDocument,
  IconActionGoBack: () => IconActionGoBack,
  IconActionGoToDetails: () => IconActionGoToDetails,
  IconActionGoToNextItems: () => IconActionGoToNextItems,
  IconActionGoToNextPage: () => IconActionGoToNextPage,
  IconActionGoToPreviousItems: () => IconActionGoToPreviousItems,
  IconActionGoToPreviousPage: () => IconActionGoToPreviousPage,
  IconActionLocationPicker: () => IconActionLocationPicker,
  IconActionLogin: () => IconActionLogin,
  IconActionLogout: () => IconActionLogout,
  IconActionMaskField: () => IconActionMaskField,
  IconActionNotifications: () => IconActionNotifications,
  IconActionNotificationsFilled: () => IconActionNotificationsFilled,
  IconActionOpenInWindow: () => IconActionOpenInWindow,
  IconActionOpenInfo: () => IconActionOpenInfo,
  IconActionOpenMessages: () => IconActionOpenMessages,
  IconActionRated: () => IconActionRated,
  IconActionReassignItem: () => IconActionReassignItem,
  IconActionRefer: () => IconActionRefer,
  IconActionRemove: () => IconActionRemove,
  IconActionReset: () => IconActionReset,
  IconActionSaveToCloud: () => IconActionSaveToCloud,
  IconActionSearch: () => IconActionSearch,
  IconActionSelectListExpand: () => IconActionSelectListExpand,
  IconActionSendMessage: () => IconActionSendMessage,
  IconActionShareLink: () => IconActionShareLink,
  IconActionShowFilters: () => IconActionShowFilters,
  IconActionShowMenu: () => IconActionShowMenu,
  IconActionShowOptions: () => IconActionShowOptions,
  IconActionShowPreview: () => IconActionShowPreview,
  IconActionStopProcess: () => IconActionStopProcess,
  IconActionUnfavorited: () => IconActionUnfavorited,
  IconActionUnmaskField: () => IconActionUnmaskField,
  IconActionUnrated: () => IconActionUnrated,
  IconActionUserAvatar: () => IconActionUserAvatar,
  IconActionViewAsCards: () => IconActionViewAsCards,
  IconActionViewAsList: () => IconActionViewAsList,
  IconActionWatchInterview: () => IconActionWatchInterview,
  IconDescriptiveActionItems: () => IconDescriptiveActionItems,
  IconDescriptiveBenefits: () => IconDescriptiveBenefits,
  IconDescriptiveBuilding: () => IconDescriptiveBuilding,
  IconDescriptiveCalendar: () => IconDescriptiveCalendar,
  IconDescriptiveClock: () => IconDescriptiveClock,
  IconDescriptiveEducation: () => IconDescriptiveEducation,
  IconDescriptiveFacility: () => IconDescriptiveFacility,
  IconDescriptiveHealthSystem: () => IconDescriptiveHealthSystem,
  IconDescriptiveLicense: () => IconDescriptiveLicense,
  IconDescriptiveLocation: () => IconDescriptiveLocation,
  IconDescriptiveMealBreak: () => IconDescriptiveMealBreak,
  IconDescriptiveNotes: () => IconDescriptiveNotes,
  IconDescriptiveOfferExtended: () => IconDescriptiveOfferExtended,
  IconDescriptivePayRate: () => IconDescriptivePayRate,
  IconDescriptivePlacementHistory: () => IconDescriptivePlacementHistory,
  IconDescriptiveQuicklySubmtted: () => IconDescriptiveQuicklySubmtted,
  IconDescriptiveReference: () => IconDescriptiveReference,
  IconDescriptiveReminder: () => IconDescriptiveReminder,
  IconDescriptiveRestBreak: () => IconDescriptiveRestBreak,
  IconDescriptiveSecuredField: () => IconDescriptiveSecuredField,
  IconDescriptiveShiftType: () => IconDescriptiveShiftType,
  IconDescriptiveShiftsList: () => IconDescriptiveShiftsList,
  IconDescriptiveSignature: () => IconDescriptiveSignature,
  IconDescriptiveStartDate: () => IconDescriptiveStartDate,
  IconDescriptiveSupport: () => IconDescriptiveSupport,
  IconDescriptiveTechnology: () => IconDescriptiveTechnology,
  IconDescriptiveToday: () => IconDescriptiveToday,
  IconDescriptiveTopMatches: () => IconDescriptiveTopMatches,
  IconDescriptiveUnworkedType: () => IconDescriptiveUnworkedType,
  IconDescriptiveWeather: () => IconDescriptiveWeather,
  IconDescriptiveWorkExperience: () => IconDescriptiveWorkExperience,
  IconDescriptiveWorkType: () => IconDescriptiveWorkType,
  IconFeature1stToApply: () => IconFeature1stToApply,
  IconFeature1stToApplyFilled: () => IconFeature1stToApplyFilled,
  IconFeatureAutoOffer: () => IconFeatureAutoOffer,
  IconFeatureAutoOfferFilled: () => IconFeatureAutoOfferFilled,
  IconFeatureBoostedCampaign: () => IconFeatureBoostedCampaign,
  IconFeatureCareerStarter: () => IconFeatureCareerStarter,
  IconFeatureCareerStarterFilled: () => IconFeatureCareerStarterFilled,
  IconFeatureClosingSoon: () => IconFeatureClosingSoon,
  IconFeatureClosingSoonFilled: () => IconFeatureClosingSoonFilled,
  IconFeatureEasyApply: () => IconFeatureEasyApply,
  IconFeatureEasyApplyFilled: () => IconFeatureEasyApplyFilled,
  IconFeatureExclusive: () => IconFeatureExclusive,
  IconFeatureExclusiveFilled: () => IconFeatureExclusiveFilled,
  IconFeatureLowCOLI: () => IconFeatureLowCOLI,
  IconFeatureLowCOLIFilled: () => IconFeatureLowCOLIFilled,
  IconFeatureNearby: () => IconFeatureNearby,
  IconFeatureNearbyFilled: () => IconFeatureNearbyFilled,
  IconFeatureNew: () => IconFeatureNew,
  IconFeatureNewItem: () => IconFeatureNewItem,
  IconFeatureNewItemFilled: () => IconFeatureNewItemFilled,
  IconFeatureOneClick: () => IconFeatureOneClick,
  IconFeatureOneClickFilled: () => IconFeatureOneClickFilled,
  IconFeaturePayRate: () => IconFeaturePayRate,
  IconFeaturePayRateFilled: () => IconFeaturePayRateFilled,
  IconFeatureQuickOffer: () => IconFeatureQuickOffer,
  IconFeatureQuickOfferFilled: () => IconFeatureQuickOfferFilled,
  IconFeatureSocialProof: () => IconFeatureSocialProof,
  IconFeatureSocialProofFilled: () => IconFeatureSocialProofFilled,
  IconFeatureTopHospital: () => IconFeatureTopHospital,
  IconFeatureTopHospitalFilled: () => IconFeatureTopHospitalFilled,
  IconFeatureTopMatch: () => IconFeatureTopMatch,
  IconFeatureTopMatchFilled: () => IconFeatureTopMatchFilled,
  IconNavigationHelp: () => IconNavigationHelp,
  IconNavigationHome: () => IconNavigationHome,
  IconNavigationHomeFilled: () => IconNavigationHomeFilled,
  IconNavigationMessages: () => IconNavigationMessages,
  IconNavigationMessagesFilled: () => IconNavigationMessagesFilled,
  IconNavigationNotes: () => IconNavigationNotes,
  IconNavigationNotesFilled: () => IconNavigationNotesFilled,
  IconNavigationSettings: () => IconNavigationSettings,
  IconNavigationSupport: () => IconNavigationSupport,
  IconNavigationTimekeeping: () => IconNavigationTimekeeping,
  IconNavigationTimekeepingFilled: () => IconNavigationTimekeepingFilled,
  IconSocialFacebook: () => IconSocialFacebook,
  IconSocialInstagram: () => IconSocialInstagram,
  IconSocialLinkedIn: () => IconSocialLinkedIn,
  IconSocialTiktok: () => IconSocialTiktok,
  IconSocialTwitter: () => IconSocialTwitter,
  IconStatusFail: () => IconStatusFail,
  IconStatusFailFilled: () => IconStatusFailFilled,
  IconStatusGeneralNotification: () => IconStatusGeneralNotification,
  IconStatusGeneralNotificationFilled: () => IconStatusGeneralNotificationFilled,
  IconStatusInfo: () => IconStatusInfo,
  IconStatusInfoFilled: () => IconStatusInfoFilled,
  IconStatusProcessComplete: () => IconStatusProcessComplete,
  IconStatusProcessInDraft: () => IconStatusProcessInDraft,
  IconStatusProcessInProgress: () => IconStatusProcessInProgress,
  IconStatusProcessIncomplete: () => IconStatusProcessIncomplete,
  IconStatusProcessNotQualified: () => IconStatusProcessNotQualified,
  IconStatusProcessNotStarted: () => IconStatusProcessNotStarted,
  IconStatusProcessPaused: () => IconStatusProcessPaused,
  IconStatusProcessProcessing: () => IconStatusProcessProcessing,
  IconStatusProcessReadyForReview: () => IconStatusProcessReadyForReview,
  IconStatusProcessWaiting: () => IconStatusProcessWaiting,
  IconStatusStepComplete: () => IconStatusStepComplete,
  IconStatusStepInDraft: () => IconStatusStepInDraft,
  IconStatusStepStarted: () => IconStatusStepStarted,
  IconStatusSuccess: () => IconStatusSuccess,
  IconStatusSuccessFilled: () => IconStatusSuccessFilled,
  IconStatusTip: () => IconStatusTip,
  IconStatusTipFilled: () => IconStatusTipFilled,
  IconStatusWarning: () => IconStatusWarning,
  IconStatusWarningFilled: () => IconStatusWarningFilled,
  IconsConfigProvider: () => IconsConfigProvider,
  useIconsConfig: () => useIconsConfig
});
module.exports = __toCommonJS(web_exports);

// .svgr-output/web/config.tsx
var React = __toESM(require("react"));
var import_jsx_runtime = require("react/jsx-runtime");
var IconsConfigContext = React.createContext(
  void 0
);
function IconsConfigProvider({
  colors,
  children
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(IconsConfigContext.Provider, { value: { colors }, children });
}
function useIconsConfig() {
  const value = React.useContext(IconsConfigContext);
  if (!value) {
    throw new Error("Icon must be wrapped in IconsConfigProvider.");
  }
  return value;
}

// .svgr-output/web/IconActionAdd.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Svgr = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 6.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionAdd(_a) {
  var _b = _a, {
    title = "Add",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes ? sizes[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    Svgr,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes.medium,
      height: resolvedSize || sizes.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionAddAttachment.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Svgr2 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("path", { fill: "currentcolor", d: "M9.1 21.8c-1.5 0-2.9-.6-4-1.7s-1.7-2.5-1.7-4 .6-2.9 1.7-4l8.6-8.6c.8-.8 1.8-1.2 2.9-1.2 1.1 0 2.1.4 2.9 1.2.8.8 1.2 1.8 1.2 2.9 0 1.1-.4 2.1-1.2 2.9l-8.6 8.6c-.9.9-2.5.9-3.4 0-.9-.9-.9-2.5 0-3.4L13 9c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-5.5 5.5c-.3.3-.3.9 0 1.3.3.3.9.3 1.3 0l8.6-8.6c.5-.5.7-1.1.7-1.8s-.4-1.5-.8-2c-1-1-2.6-1-3.6 0l-8.6 8.6c-.8.8-1.2 1.8-1.2 3s.4 2.2 1.2 3c.8.8 1.8 1.2 3 1.2s2.2-.4 3-1.2l6.3-6.3c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1.1l-6.3 6.3c-1.3 1-2.7 1.6-4.2 1.6Z" })
  ] }));
};
var sizes2 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionAddAttachment(_a) {
  var _b = _a, {
    title = "Add Attachment",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes2 ? sizes2[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    Svgr2,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes2.medium,
      height: resolvedSize || sizes2.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionAddFromSearch.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var Svgr3 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M13.663 6.112a5.221 5.221 0 1 0-7.384 7.384 5.221 5.221 0 0 0 7.384-7.384Zm-8.444-1.06a6.721 6.721 0 1 1 9.505 9.505 6.721 6.721 0 0 1-9.505-9.505Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M13.624 13.526a.75.75 0 0 1 1.06.007l5.85 5.93a.75.75 0 0 1-1.067 1.054l-5.85-5.93a.75.75 0 0 1 .007-1.06ZM7.25 10A.75.75 0 0 1 8 9.25h4a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes3 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionAddFromSearch(_a) {
  var _b = _a, {
    title = "Add From Search",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes3 ? sizes3[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    Svgr3,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes3.medium,
      height: resolvedSize || sizes3.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionAddImage.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Svgr4 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.632 10.722a1.709 1.709 0 0 1 2.418 0l4.121 4.121a.75.75 0 1 1-1.06 1.06l-4.122-4.12a.209.209 0 0 0-.296-.001l-4.122 4.122a.75.75 0 1 1-1.06-1.06l4.12-4.122Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.241 3.644a2.13 2.13 0 0 0-2.13 2.13v11.52a2.13 2.13 0 0 0 2.13 2.13h11.52a2.13 2.13 0 0 0 2.13-2.13V5.774a2.13 2.13 0 0 0-2.13-2.13H6.241Zm-3.63 2.13a3.63 3.63 0 0 1 3.63-3.63h11.52a3.63 3.63 0 0 1 3.63 3.63v11.52a3.63 3.63 0 0 1-3.63 3.63H6.241a3.63 3.63 0 0 1-3.63-3.63V5.774Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.912 13.602a1.709 1.709 0 0 1 2.418 0l6.041 6.041a.75.75 0 0 1-1.06 1.061l-6.042-6.041a.209.209 0 0 0-.296 0L4.32 19.315a.75.75 0 0 1-1.06-1.06l4.653-4.654ZM8.335 7.869a1.11 1.11 0 1 1 1.57 1.57 1.11 1.11 0 0 1-1.57-1.57Z", clipRule: "evenodd" })
  ] }));
};
var sizes4 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionAddImage(_a) {
  var _b = _a, {
    title = "Add Image",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes4 ? sizes4[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    Svgr4,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes4.medium,
      height: resolvedSize || sizes4.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionAddNote.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var Svgr5 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("path", { fill: "currentcolor", d: "M21 5.2 18.8 3c-.3-.3-.8-.5-1.2-.5-.5 0-.9.2-1.2.5L3 16.3c-.3.3-.5.8-.5 1.2v3.3c0 .4.3.8.8.8h3.3c.5 0 .9-.2 1.2-.5L21 7.7c.3-.3.5-.8.5-1.2 0-.4-.1-.9-.5-1.3ZM6.6 20s-.1.1-.2.1H4v-2.5c0-.1 0-.1.1-.2l10-10.1 2.6 2.6L6.6 20ZM20 6.6l-2.2 2.2-2.6-2.6L17.4 4h.1s.1 0 .2.1L20 6.3V6.6Z" })
  ] }));
};
var sizes5 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionAddNote(_a) {
  var _b = _a, {
    title = "Add Note",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes5 ? sizes5[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    Svgr5,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes5.medium,
      height: resolvedSize || sizes5.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionArchiveItem.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var Svgr6 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M20.529 7.998H3.47a.974.974 0 0 1-.975-.973V4.972a.974.974 0 0 1 .974-.975h17.06c.538 0 .974.436.974.974v2.053a.974.974 0 0 1-.974.974h-.001ZM17.162 20.003H6.838a2 2 0 0 1-1.994-1.834V7.999h14.312v10.17a2 2 0 0 1-1.994 1.834Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M12 16.35V12M10 14.35l2 2 2-2" })
  ] }));
};
var sizes6 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionArchiveItem(_a) {
  var _b = _a, {
    title = "Archive",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes6 ? sizes6[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    Svgr6,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes6.medium,
      height: resolvedSize || sizes6.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionCallSupport.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Svgr7 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M13 6.991A3.944 3.944 0 0 1 17.009 11M13 2.964c2.056 0 4.113.785 5.682 2.354A8.012 8.012 0 0 1 21.036 11m-2.071 5.61-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.922.922a.71.71 0 0 1-.784.158c-1.336-.585-2.656-1.472-3.833-2.649a12.645 12.645 0 0 1-2.642-3.817.733.733 0 0 1 .162-.811l.826-.826c.671-.671.671-1.62.085-2.206L7.39 5.035a2 2 0 0 0-2.828 0l-.652.651c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.449 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.829Z" })
  ] }));
};
var sizes7 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionCallSupport(_a) {
  var _b = _a, {
    title = "Call Support",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes7 ? sizes7[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
    Svgr7,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes7.medium,
      height: resolvedSize || sizes7.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionClear.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var Svgr8 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.47 7.47a.75.75 0 0 1 1.06 0l8 8a.75.75 0 1 1-1.06 1.06l-8-8a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.53 7.47a.75.75 0 0 1 0 1.06l-8 8a.75.75 0 0 1-1.06-1.06l8-8a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes8 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionClear(_a) {
  var _b = _a, {
    title = "Clear",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes8 ? sizes8[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    Svgr8,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes8.medium,
      height: resolvedSize || sizes8.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionCloseModal.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var Svgr9 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes9 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionCloseModal(_a) {
  var _b = _a, {
    title = "Close Modal",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes9 ? sizes9[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    Svgr9,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes9.medium,
      height: resolvedSize || sizes9.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionClosePanel.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var Svgr10 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes10 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionClosePanel(_a) {
  var _b = _a, {
    title = "Close Panel",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes10 ? sizes10[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
    Svgr10,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes10.medium,
      height: resolvedSize || sizes10.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionCloseTable.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var Svgr11 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.47 3.47a.75.75 0 0 1 1.06 0l16 16a.75.75 0 1 1-1.06 1.06l-16-16a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime12.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l16-16a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes11 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionCloseTable(_a) {
  var _b = _a, {
    title = "Close Table",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes11 ? sizes11[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    Svgr11,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes11.medium,
      height: resolvedSize || sizes11.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionCollapseSection.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");
var Svgr12 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime13.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.47 9.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 1 1-1.06 1.06L12 11.06l-3.47 3.47a.75.75 0 0 1-1.06-1.06l4-4Z", clipRule: "evenodd" })
  ] }));
};
var sizes12 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionCollapseSection(_a) {
  var _b = _a, {
    title = "Collapse Section",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes12 ? sizes12[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(
    Svgr12,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes12.medium,
      height: resolvedSize || sizes12.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionCopy.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");
var Svgr13 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.246 8.998a2.75 2.75 0 0 1 2.75-2.75h10.006a2.75 2.75 0 0 1 2.75 2.75v10.006a2.75 2.75 0 0 1-2.75 2.75H8.996a2.75 2.75 0 0 1-2.75-2.75V8.998Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v10.006c0 .69.56 1.25 1.25 1.25h10.006c.69 0 1.25-.56 1.25-1.25V8.998c0-.69-.56-1.25-1.25-1.25H8.996Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime14.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.997 3.747c-.69 0-1.25.56-1.25 1.25v10.005c0 .69.56 1.25 1.25 1.25h2a.75.75 0 0 1 0 1.5h-2a2.75 2.75 0 0 1-2.75-2.75V4.997a2.75 2.75 0 0 1 2.75-2.75H15a2.75 2.75 0 0 1 2.75 2.75v2.001a.75.75 0 0 1-1.5 0v-2c0-.691-.56-1.251-1.25-1.251H4.997Z", clipRule: "evenodd" })
  ] }));
};
var sizes13 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionCopy(_a) {
  var _b = _a, {
    title = "Copy",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes13 ? sizes13[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
    Svgr13,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes13.medium,
      height: resolvedSize || sizes13.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionDatePicker.tsx
var import_jsx_runtime15 = require("react/jsx-runtime");
var Svgr14 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("path", { fill: "currentcolor", d: "M19.001 4.3h-2.2V3c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.2h-6.4V3c0-.4-.3-.8-.8-.8s-.8.4-.8.8v1.2h-2.2c-1.5.1-2.8 1.3-2.8 2.8v13c0 1.5 1.2 2.8 2.8 2.8h14c1.5 0 2.8-1.2 2.8-2.8V7c0-1.5-1.3-2.7-2.8-2.7Zm-14 1.4h2.2v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.7h6.5v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.7h2.1c.7 0 1.2.6 1.2 1.2v2.2h-16.4V7c0-.7.5-1.3 1.2-1.3Zm14 15.6h-14c-.7 0-1.2-.6-1.2-1.2v-9.2h16.5v9.2c-.1.6-.6 1.2-1.3 1.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("path", { fill: "currentcolor", d: "M12.001 13c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM17.001 13c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM7.001 17c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM12.001 17c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes14 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionDatePicker(_a) {
  var _b = _a, {
    title = "Date Picker",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes14 ? sizes14[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    Svgr14,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes14.medium,
      height: resolvedSize || sizes14.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionDelete.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");
var Svgr15 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.25 6.53a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM10 10.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75ZM14 10.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.25 6.528a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 .75.75v11.739a2.955 2.955 0 0 1-2.955 2.955h-7.59a2.955 2.955 0 0 1-2.955-2.955V6.527Zm1.5.75v10.989c0 .804.651 1.455 1.455 1.455h7.59c.804 0 1.455-.651 1.455-1.455V7.277H6.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime16.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8.024 3.995A1.749 1.749 0 0 1 9.69 2.778h4.62c.76 0 1.434.492 1.666 1.215l.739 2.306a.75.75 0 1 1-1.43.458l-.737-2.305a.25.25 0 0 0-.238-.174H9.69c-.109 0-.205.07-.237.173l-.739 2.306a.75.75 0 1 1-1.428-.458l.738-2.304ZM4.25 6.53A.75.75 0 0 1 5 5.78h1a.75.75 0 1 1 0 1.5H5a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes15 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionDelete(_a) {
  var _b = _a, {
    title = "Delete",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes15 ? sizes15[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    Svgr15,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes15.medium,
      height: resolvedSize || sizes15.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionDownloadFile.tsx
var import_jsx_runtime17 = require("react/jsx-runtime");
var Svgr16 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3 16.25a.75.75 0 0 1 .75.75A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17a.75.75 0 0 1 1.5 0A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime17.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.469 11.47a.75.75 0 0 1 1.06 0L12 15.94l4.47-4.47a.75.75 0 1 1 1.061 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 0-1.061Z", clipRule: "evenodd" })
  ] }));
};
var sizes16 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionDownloadFile(_a) {
  var _b = _a, {
    title = "Download File",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes16 ? sizes16[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    Svgr16,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes16.medium,
      height: resolvedSize || sizes16.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionDropdownExpand.tsx
var import_jsx_runtime18 = require("react/jsx-runtime");
var Svgr17 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime18.jsx)("path", { fill: "currentcolor", d: "M8.528 9.066a1.02 1.02 0 0 0-1.477 0 1.09 1.09 0 0 0 0 1.504l4.21 4.364a1.02 1.02 0 0 0 1.477 0l4.21-4.364a1.09 1.09 0 0 0 0-1.504 1.02 1.02 0 0 0-1.476 0L12 12.665 8.528 9.066Z" })
  ] }));
};
var sizes17 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionDropdownExpand(_a) {
  var _b = _a, {
    title = "Expand",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes17 ? sizes17[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    Svgr17,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes17.medium,
      height: resolvedSize || sizes17.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionEdit.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
var Svgr18 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("path", { fill: "currentcolor", d: "M21 5.2 18.8 3c-.3-.3-.8-.5-1.2-.5-.5 0-.9.2-1.2.5L3 16.3c-.3.3-.5.8-.5 1.2v3.3c0 .4.3.8.8.8h3.3c.5 0 .9-.2 1.2-.5L21 7.7c.3-.3.5-.8.5-1.2 0-.4-.1-.9-.5-1.3ZM6.6 20s-.1.1-.2.1H4v-2.5c0-.1 0-.1.1-.2l10-10.1 2.6 2.6L6.6 20ZM20 6.6l-2.2 2.2-2.6-2.6L17.4 4h.1s.1 0 .2.1L20 6.3V6.6Z" })
  ] }));
};
var sizes18 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionEdit(_a) {
  var _b = _a, {
    title = "Edit",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes18 ? sizes18[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    Svgr18,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes18.medium,
      height: resolvedSize || sizes18.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionExpandSection.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
var Svgr19 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime20.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes19 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionExpandSection(_a) {
  var _b = _a, {
    title = "Expand Section",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes19 ? sizes19[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
    Svgr19,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes19.medium,
      height: resolvedSize || sizes19.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionFavorited.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
var Svgr20 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime21.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M16.5 4C19.67 4 21 6.22 21 9c0 5.63-8.84 11-9 11-.16 0-9-5.37-9-11 0-2.78 1.33-5 4.5-5 1.82 0 3.81 2.2 4.5 3 .69-.8 2.68-3 4.5-3Z", clipRule: "evenodd" })
  ] }));
};
var sizes20 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionFavorited(_a) {
  var _b = _a, {
    title = "Favorited",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes20 ? sizes20[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    Svgr20,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes20.medium,
      height: resolvedSize || sizes20.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGenerateDocument.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");
var Svgr21 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3 5.846A3.852 3.852 0 0 1 6.857 2h7.846c1.023 0 2.005.405 2.728 1.127l2.44 2.432A3.84 3.84 0 0 1 21 8.279v9.875A3.852 3.852 0 0 1 17.143 22H6.857A3.852 3.852 0 0 1 3 18.154v-.513a.77.77 0 0 1 1.543 0v.513a2.31 2.31 0 0 0 2.314 2.308h10.286a2.31 2.31 0 0 0 2.314-2.308V9.179H16.63A2.825 2.825 0 0 1 13.8 6.36v-2.82H6.857a2.311 2.311 0 0 0-2.314 2.307v3.077a.77.77 0 0 1-1.543 0V5.846Zm12.343.513v-2.73c.373.106.717.306.997.585l2.44 2.433c.279.279.48.622.587.994H16.63c-.71 0-1.286-.574-1.286-1.282Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.771 10.718h1.806c1.064 0 1.928.861 1.928 1.923a1.926 1.926 0 0 1-1.928 1.923H4.543v.616a.77.77 0 0 1-1.543 0v-3.693a.77.77 0 0 1 .771-.77Zm.772 1.538v.77h1.034a.386.386 0 0 0 .385-.385.386.386 0 0 0-.385-.385H4.543ZM8.143 11.487a.77.77 0 0 1 .771-.77h1.235a2.619 2.619 0 0 1 2.622 2.616 2.619 2.619 0 0 1-2.622 2.616H8.914a.77.77 0 0 1-.771-.77v-3.692Zm1.543 2.923h.463c.596 0 1.08-.482 1.08-1.077s-.484-1.077-1.08-1.077h-.463v2.154Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)("path", { fill: "currentcolor", d: "M14.829 12.256v.765h1.41a.77.77 0 1 1 0 1.539h-1.41v.62a.77.77 0 0 1-1.543 0v-3.693a.77.77 0 0 1 .771-.77h2.633a.77.77 0 1 1 0 1.54H14.83Z" })
  ] }));
};
var sizes21 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGenerateDocument(_a) {
  var _b = _a, {
    title = "Generate Document",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes21 ? sizes21[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(
    Svgr21,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes21.medium,
      height: resolvedSize || sizes21.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoBack.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");
var Svgr22 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime23.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.03 2.47a.75.75 0 0 1 0 1.06l-8.47 8.472 8.465 8.468a.75.75 0 1 1-1.06 1.06L6.97 12.532a.75.75 0 0 1 0-1.06l9-9.002a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes22 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoBack(_a) {
  var _b = _a, {
    title = "Go Back",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes22 ? sizes22[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(
    Svgr22,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes22.medium,
      height: resolvedSize || sizes22.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoToDetails.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
var Svgr23 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime24.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.47 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L12.94 12 9.47 8.53a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes23 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoToDetails(_a) {
  var _b = _a, {
    title = "Go To Details",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes23 ? sizes23[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    Svgr23,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes23.medium,
      height: resolvedSize || sizes23.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoToNextItems.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
var Svgr24 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime25.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.47 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L12.94 12 9.47 8.53a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes24 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoToNextItems(_a) {
  var _b = _a, {
    title = "Next Items",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes24 ? sizes24[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
    Svgr24,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes24.medium,
      height: resolvedSize || sizes24.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoToNextPage.tsx
var import_jsx_runtime26 = require("react/jsx-runtime");
var Svgr25 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime26.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.97 21.53a.75.75 0 0 1 0-1.06l8.47-8.472L6.974 3.53a.75.75 0 0 1 1.06-1.06l8.995 8.998a.75.75 0 0 1 0 1.06l-9 9.002a.75.75 0 0 1-1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes25 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoToNextPage(_a) {
  var _b = _a, {
    title = "Next Page",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes25 ? sizes25[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
    Svgr25,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes25.medium,
      height: resolvedSize || sizes25.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoToPreviousItems.tsx
var import_jsx_runtime27 = require("react/jsx-runtime");
var Svgr26 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime27.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.53 7.47a.75.75 0 0 1 0 1.06L11.06 12l3.47 3.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes26 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoToPreviousItems(_a) {
  var _b = _a, {
    title = "Previous Items",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes26 ? sizes26[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
    Svgr26,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes26.medium,
      height: resolvedSize || sizes26.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionGoToPreviousPage.tsx
var import_jsx_runtime28 = require("react/jsx-runtime");
var Svgr27 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime28.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.03 2.47a.75.75 0 0 1 0 1.06l-8.47 8.472 8.465 8.468a.75.75 0 1 1-1.06 1.06L6.97 12.532a.75.75 0 0 1 0-1.06l9-9.002a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes27 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionGoToPreviousPage(_a) {
  var _b = _a, {
    title = "Previous Page",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes27 ? sizes27[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsx)(
    Svgr27,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes27.medium,
      height: resolvedSize || sizes27.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionLocationPicker.tsx
var import_jsx_runtime29 = require("react/jsx-runtime");
var Svgr28 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes28 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionLocationPicker(_a) {
  var _b = _a, {
    title = "Location Picker",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes28 ? sizes28[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
    Svgr28,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes28.medium,
      height: resolvedSize || sizes28.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionLogin.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
var Svgr29 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes29 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionLogin(_a) {
  var _b = _a, {
    title = "Login",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes29 ? sizes29[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
    Svgr29,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes29.medium,
      height: resolvedSize || sizes29.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionLogout.tsx
var import_jsx_runtime31 = require("react/jsx-runtime");
var Svgr30 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.11 12a.75.75 0 0 1 .75-.75H20a.75.75 0 1 1 0 1.5H9.86a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime31.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.686 4.75c-.785 0-1.407.627-1.407 1.385v11.73c0 .76.627 1.389 1.414 1.385l4.168-.019a.75.75 0 0 1 .007 1.5L6.7 20.75c-1.604.008-2.92-1.28-2.92-2.885V6.135c0-1.6 1.307-2.885 2.906-2.885H11a.75.75 0 0 1 0 1.5H6.686ZM15.47 7.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L18.94 12l-3.47-3.47a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes30 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionLogout(_a) {
  var _b = _a, {
    title = "Logout",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes30 ? sizes30[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    Svgr30,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes30.medium,
      height: resolvedSize || sizes30.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionMaskField.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
var Svgr31 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime32.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime32.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.338 2.726A.768.768 0 1 0 3.25 3.814l2.61 2.614a9.907 9.907 0 0 0-3.32 3.776l-.003.005a5.215 5.215 0 0 0 0 4.609l.007.015a10.463 10.463 0 0 0 9.462 5.64c2.16.005 4.267-.633 6.058-1.826l2.623 2.628a.768.768 0 1 0 1.088-1.09l-3.067-3.07a.858.858 0 0 0-.034-.034l-3.492-3.497a.819.819 0 0 0-.03-.03L10.962 9.36a.773.773 0 0 0-.03-.031l-3.27-3.274a.77.77 0 0 0-.039-.039l-3.286-3.29ZM6.972 7.54a8.368 8.368 0 0 0-3.057 3.352 3.673 3.673 0 0 0-.003 3.236 8.925 8.925 0 0 0 8.074 4.804h.016a9.345 9.345 0 0 0 4.949-1.4l-2.26-2.263a3.845 3.845 0 0 1-6.503-2.046 3.856 3.856 0 0 1 1.06-3.403L6.973 7.54Zm3.364 3.369a2.315 2.315 0 0 0 1.229 3.906 2.308 2.308 0 0 0 2.038-.635l-3.267-3.271Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime32.jsx)("path", { fill: "currentcolor", d: "M11.992 4.554a10.463 10.463 0 0 1 9.464 5.64l.007.015a5.215 5.215 0 0 1 0 4.609c-.038.079-.08.146-.104.182v.002l-.04.063a.769.769 0 1 1-1.359-.72c.034-.064.071-.123.091-.154l.006-.01a.874.874 0 0 0 .026-.042l.001-.002a3.673 3.673 0 0 0 .004-3.24 8.925 8.925 0 0 0-8.075-4.803H12c-.122 0-.216.009-.337.02-.081.008-.174.016-.295.024a.77.77 0 0 1-.101-1.536l.161-.014c.163-.014.38-.033.564-.034Z" })
  ] }));
};
var sizes31 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionMaskField(_a) {
  var _b = _a, {
    title = "Mask Field",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes31 ? sizes31[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
    Svgr31,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes31.medium,
      height: resolvedSize || sizes31.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionNotifications.tsx
var import_jsx_runtime33 = require("react/jsx-runtime");
var Svgr32 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.292 17.593a.75.75 0 0 1 .75.75v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.542 1.542 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime33.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.094 6.407a3.78 3.78 0 0 0-3.781 3.781v2.797c0 .73-.29 1.429-.806 1.944l-.64.641a1.25 1.25 0 0 0-.367.884c0 .63.51 1.14 1.14 1.14h10.721c.63 0 1.14-.51 1.14-1.14 0-.33-.132-.65-.366-.884l-.641-.64a2.75 2.75 0 0 1-.806-1.945v-2.797a3.78 3.78 0 0 0-3.781-3.781h-1.813Zm7.094 3.781a5.28 5.28 0 0 0-5.281-5.281h-1.813a5.28 5.28 0 0 0-5.281 5.281v2.797c0 .33-.132.65-.366.884l-.641.64A2.75 2.75 0 0 0 4 16.455a2.64 2.64 0 0 0 2.64 2.64h10.721a2.64 2.64 0 0 0 2.64-2.64c0-.73-.29-1.429-.806-1.944l-.64-.641a1.25 1.25 0 0 1-.367-.884v-2.797Z", clipRule: "evenodd" })
  ] }));
};
var sizes32 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionNotifications(_a) {
  var _b = _a, {
    title = "Notifications",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes32 ? sizes32[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
    Svgr32,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes32.medium,
      height: resolvedSize || sizes32.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionNotificationsFilled.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");
var Svgr33 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m14.292 17.593.04.001a.75.75 0 0 1 .71.749v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.543 1.543 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime34.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M18.188 10.188a5.28 5.28 0 0 0-5.281-5.281h-1.813a5.28 5.28 0 0 0-5.281 5.281v2.797c0 .33-.132.65-.366.884l-.641.64A2.75 2.75 0 0 0 4 16.455a2.64 2.64 0 0 0 2.64 2.64h10.721a2.64 2.64 0 0 0 2.64-2.64c0-.73-.29-1.429-.806-1.944l-.64-.641a1.25 1.25 0 0 1-.367-.884v-2.797Z", clipRule: "evenodd" })
  ] }));
};
var sizes33 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionNotificationsFilled(_a) {
  var _b = _a, {
    title = "Notifications",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes33 ? sizes33[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
    Svgr33,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes33.medium,
      height: resolvedSize || sizes33.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionOpenInWindow.tsx
var import_jsx_runtime35 = require("react/jsx-runtime");
var Svgr34 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.25 3a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V3.75H16a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.53 2.47a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 1 1-1.06-1.06l7-7a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime35.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5 5.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-5a.75.75 0 0 1 1.5 0v5A2.75 2.75 0 0 1 17 21.75H5A2.75 2.75 0 0 1 2.25 19V7A2.75 2.75 0 0 1 5 4.25h5a.75.75 0 0 1 0 1.5H5Z", clipRule: "evenodd" })
  ] }));
};
var sizes34 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionOpenInWindow(_a) {
  var _b = _a, {
    title = "Open In Window",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes34 ? sizes34[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(
    Svgr34,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes34.medium,
      height: resolvedSize || sizes34.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionOpenInfo.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");
var Svgr35 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("path", { fill: "currentcolor", d: "M12.001 2.2c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8 9.8-4.4 9.8-9.8-4.4-9.8-9.8-9.8Zm0 18c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime36.jsx)("path", { fill: "currentcolor", d: "M12.001 11.2h-1c-.4 0-.8.3-.8.8s.3.8.8.8h.2V17c0 .4.3.8.8.8s.8-.3.8-.8v-5c0-.4-.4-.8-.8-.8ZM11.701 7.2c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes35 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionOpenInfo(_a) {
  var _b = _a, {
    title = "Open Info",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes35 ? sizes35[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
    Svgr35,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes35.medium,
      height: resolvedSize || sizes35.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionOpenMessages.tsx
var import_jsx_runtime37 = require("react/jsx-runtime");
var Svgr36 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime37.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 6A3.75 3.75 0 0 1 6 2.25h12A3.75 3.75 0 0 1 21.75 6v8A3.75 3.75 0 0 1 18 17.75h-4.737L8.47 21.586A.75.75 0 0 1 7.25 21v-3.25H6A3.75 3.75 0 0 1 2.25 14V6Zm10.477 10.301a.748.748 0 0 0-.2.117L8.75 19.44V17a.75.75 0 0 0-.75-.75H6A2.25 2.25 0 0 1 3.75 14V6A2.25 2.25 0 0 1 6 3.75h12A2.25 2.25 0 0 1 20.25 6v8A2.25 2.25 0 0 1 18 16.25h-5a.753.753 0 0 0-.166.018", clipRule: "evenodd" })
  ] }));
};
var sizes36 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionOpenMessages(_a) {
  var _b = _a, {
    title = "Open Messages",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes36 ? sizes36[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
    Svgr36,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes36.medium,
      height: resolvedSize || sizes36.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionRated.tsx
var import_jsx_runtime38 = require("react/jsx-runtime");
var Svgr37 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime38.jsx)("path", { fill: "currentcolor", d: "M21.1 10.9c.4-.3.5-.7.4-1.1-.1-.4-.5-.7-1-.7h-5c-.4 0-.8-.3-1-.7L13 3.6c-.1-.4-.5-.7-1-.7-.4 0-.8.3-1 .7L9.5 8.4c-.1.4-.5.7-1 .7h-5c-.4 0-.8.3-1 .7-.1.4 0 .9.4 1.1l4.1 3c.4.3.5.7.4 1.1l-1.6 4.8c-.1.4 0 .9.4 1.1.2.1.4.2.6.2.2 0 .4-.1.6-.2l4.1-3c.4-.3.8-.3 1.2 0l4.1 3c.4.3.8.3 1.2 0 .4-.3.5-.7.4-1.1L16.6 15c-.1-.4 0-.9.4-1.1l4.1-3Z" })
  ] }));
};
var sizes37 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionRated(_a) {
  var _b = _a, {
    title = "Rated",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes37 ? sizes37[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
    Svgr37,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes37.medium,
      height: resolvedSize || sizes37.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionReassignItem.tsx
var import_jsx_runtime39 = require("react/jsx-runtime");
var Svgr38 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.987 11.75a2.196 2.196 0 0 0-2.237 2.236V15a.75.75 0 0 1-1.5 0v-.993a3.696 3.696 0 0 1 3.757-3.757h2.987a3.696 3.696 0 0 1 3.757 3.757V15a.75.75 0 0 1-1.5 0v-1.014a2.196 2.196 0 0 0-2.237-2.236H5.987ZM19.608 12.393a2.196 2.196 0 0 0-1.594-.643H16a.75.75 0 0 1 0-1.5h1.994a3.696 3.696 0 0 1 3.756 3.757V15a.75.75 0 0 1-1.5 0v-1.014a2.196 2.196 0 0 0-.642-1.593ZM7.5 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM4.25 5.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM17 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM14.25 6a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM14.659 17.5a.75.75 0 0 1 .75-.75H18a.75.75 0 0 1 0 1.5H15.41a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M18 16.75a.75.75 0 0 1 .75.75v2.556a.75.75 0 0 1-1.5 0V17.5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.642 16.89a.75.75 0 0 1 1.017.3 5.865 5.865 0 0 0 10.302 0 .75.75 0 1 1 1.317.717 7.365 7.365 0 0 1-12.936 0 .75.75 0 0 1 .3-1.017Z", clipRule: "evenodd" })
  ] }));
};
var sizes38 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionReassignItem(_a) {
  var _b = _a, {
    title = "Reassign Item",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes38 ? sizes38[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
    Svgr38,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes38.medium,
      height: resolvedSize || sizes38.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionRefer.tsx
var import_jsx_runtime40 = require("react/jsx-runtime");
var Svgr39 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)("path", { fill: "currentcolor", d: "m11.905 11.372 1.204.238c1.82.364 2.856 1.092 2.856 2.618 0 1.568-1.148 2.688-2.94 2.926v1.526H11.57v-1.526c-1.946-.238-3.22-1.428-3.374-3.262h1.666c.168 1.12 1.092 1.82 2.52 1.82 1.162 0 1.862-.49 1.862-1.288 0-.504-.322-.994-1.4-1.176l-1.568-.308c-1.848-.35-2.688-1.288-2.688-2.702 0-1.61 1.162-2.744 2.982-2.94v-1.54h1.456V7.34c1.428.224 2.8 1.05 2.982 2.954h-1.666c-.154-.952-.784-1.582-2.086-1.582-1.148 0-1.89.518-1.89 1.386 0 .728.546 1.078 1.54 1.274Z" })
  ] }));
};
var sizes39 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionRefer(_a) {
  var _b = _a, {
    title = "Refer",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes39 ? sizes39[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(
    Svgr39,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes39.medium,
      height: resolvedSize || sizes39.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionRemove.tsx
var import_jsx_runtime41 = require("react/jsx-runtime");
var Svgr40 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime41.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m9 9 5.818 6.095m0-6.095L9 15.095" })
  ] }));
};
var sizes40 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionRemove(_a) {
  var _b = _a, {
    title = "Remove",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes40 ? sizes40[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
    Svgr40,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes40.medium,
      height: resolvedSize || sizes40.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionReset.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
var Svgr41 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.512 3.889a.75.75 0 0 0-.75.75v3.536c0 .414.336.75.75.75h3.535a.75.75 0 0 0 0-1.5H5.262V4.639a.75.75 0 0 0-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M20.75 12A8.75 8.75 0 0 0 4.315 7.816a.75.75 0 1 0 1.316.718A7.25 7.25 0 1 1 4.75 12a.75.75 0 0 0-1.5 0 8.75 8.75 0 0 0 17.5 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes41 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionReset(_a) {
  var _b = _a, {
    title = "Reset",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes41 ? sizes41[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(
    Svgr41,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes41.medium,
      height: resolvedSize || sizes41.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionSaveToCloud.tsx
var import_jsx_runtime43 = require("react/jsx-runtime");
var Svgr42 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.256 5.02a2.75 2.75 0 0 1 2.75-2.77h11.157c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19a2.75 2.75 0 0 1-2.75 2.75H5.11a2.75 2.75 0 0 1-2.75-2.73l-.104-14Zm1.5-.01.104 14a1.25 1.25 0 0 0 1.25 1.24h13.88c.692 0 1.25-.56 1.25-1.25V7.828c0-.33-.13-.65-.365-.884l-2.828-2.828a1.249 1.249 0 0 0-.884-.366H5.006a1.25 1.25 0 0 0-1.25 1.26Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime43.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.992 2.25a.75.75 0 0 1 .75.75v3.909c0 .138.112.25.25.25h6a.25.25 0 0 0 .25-.25V3a.75.75 0 0 1 1.5 0v3.909a1.75 1.75 0 0 1-1.75 1.75h-6a1.75 1.75 0 0 1-1.75-1.75V3a.75.75 0 0 1 .75-.75ZM8.285 12.75a.536.536 0 0 0-.536.536V21a.75.75 0 0 1-1.5 0v-7.714c0-1.124.912-2.036 2.036-2.036h7.429c1.123 0 2.035.912 2.035 2.036V21a.75.75 0 0 1-1.5 0v-7.714a.536.536 0 0 0-.535-.536h-7.43Z", clipRule: "evenodd" })
  ] }));
};
var sizes42 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionSaveToCloud(_a) {
  var _b = _a, {
    title = "Save To Cloud",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes42 ? sizes42[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
    Svgr42,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes42.medium,
      height: resolvedSize || sizes42.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionSearch.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");
var Svgr43 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.875 17.962a9.046 9.046 0 1 1 1.087-1.087l3.813 3.812a.77.77 0 1 1-1.088 1.088l-3.813-3.813ZM5.737 5.737a7.507 7.507 0 0 1 10.687 10.545.783.783 0 0 0-.142.142A7.507 7.507 0 0 1 5.737 5.737Z", clipRule: "evenodd" })
  ] }));
};
var sizes43 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionSearch(_a) {
  var _b = _a, {
    title = "Search",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes43 ? sizes43[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
    Svgr43,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes43.medium,
      height: resolvedSize || sizes43.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionSelectListExpand.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");
var Svgr44 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime45.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime45.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.47 9.47a.75.75 0 0 1 1.06 0L12 12.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes44 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionSelectListExpand(_a) {
  var _b = _a, {
    title = "Expand List",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes44 ? sizes44[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
    Svgr44,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes44.medium,
      height: resolvedSize || sizes44.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionSendMessage.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
var Svgr45 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.996 7.451C1.815 6.27 2.652 4.25 4.323 4.25h15.55c1.459 0 2.36 1.59 1.607 2.84L13.232 20.84c-.872 1.454-3.07 1.096-3.438-.558L8.07 12.525 2.996 7.45ZM4.323 5.75a.375.375 0 0 0-.266.64l5.228 5.229c.101.1.171.228.202.367l1.77 7.97a.375.375 0 0 0 .689.111l8.249-13.749a.375.375 0 0 0-.321-.568H4.323Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime46.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.499 5.201a.75.75 0 0 1-.3 1.018l-12.09 6.59a.75.75 0 1 1-.718-1.317l12.09-6.59a.75.75 0 0 1 1.018.3Z", clipRule: "evenodd" })
  ] }));
};
var sizes45 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionSendMessage(_a) {
  var _b = _a, {
    title = "Send Message",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes45 ? sizes45[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
    Svgr45,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes45.medium,
      height: resolvedSize || sizes45.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionShareLink.tsx
var import_jsx_runtime47 = require("react/jsx-runtime");
var Svgr46 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime47.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime47.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime47.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.47 2.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L12 4.06 9.53 6.53a.75.75 0 0 1-1.06-1.06l3-3ZM2.25 12A2.75 2.75 0 0 1 5 9.25h3a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25h-3a.75.75 0 0 1 0-1.5h3A2.75 2.75 0 0 1 21.75 12v7A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-7Z", clipRule: "evenodd" })
  ] }));
};
var sizes46 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionShareLink(_a) {
  var _b = _a, {
    title = "Share Link",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes46 ? sizes46[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    Svgr46,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes46.medium,
      height: resolvedSize || sizes46.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionShowFilters.tsx
var import_jsx_runtime48 = require("react/jsx-runtime");
var Svgr47 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5 2.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 5 2.25ZM5 9.25a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-1.5 0V10A.75.75 0 0 1 5 9.25ZM12 2.25a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM12 17.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75ZM19 2.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM19 9.25a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-1.5 0V10a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime48.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.884 7.116a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768Zm1.06-1.061a2.75 2.75 0 1 0-3.89 3.889 2.75 2.75 0 0 0 3.89-3.889ZM12.884 15.116a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768Zm1.06-1.061a2.75 2.75 0 1 0-3.89 3.889 2.75 2.75 0 0 0 3.89-3.888v-.001ZM19.884 7.116a1.25 1.25 0 1 0-1.768 1.768 1.25 1.25 0 0 0 1.768-1.768Zm1.06-1.061a2.75 2.75 0 1 0-3.89 3.889 2.75 2.75 0 0 0 3.89-3.889Z", clipRule: "evenodd" })
  ] }));
};
var sizes47 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionShowFilters(_a) {
  var _b = _a, {
    title = "Show Filters",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes47 ? sizes47[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
    Svgr47,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes47.medium,
      height: resolvedSize || sizes47.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionShowMenu.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");
var Svgr48 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime49.jsx)("path", { fill: "currentcolor", d: "M2 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM2 12a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 17a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Z" })
  ] }));
};
var sizes48 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionShowMenu(_a) {
  var _b = _a, {
    title = "Show Menu",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes48 ? sizes48[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
    Svgr48,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes48.medium,
      height: resolvedSize || sizes48.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionShowOptions.tsx
var import_jsx_runtime50 = require("react/jsx-runtime");
var Svgr49 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10 20.282c-.009-.959.897-1.73 1.995-1.73 1.103 0 2.005.77 2.005 1.724 0 .95-.897 1.724-2 1.724-1.1 0-1.996-.77-2-1.718Zm1.101-.006H10v.006M10 12.006c-.009-.96.897-1.73 1.995-1.73 1.103 0 2.005.77 2.005 1.724 0 .95-.897 1.724-2 1.724-1.1 0-1.996-.77-2-1.718ZM11.101 12H10v.006M10 3.73C9.991 2.77 10.897 2 11.995 2 13.098 2 14 2.77 14 3.724c0 .95-.897 1.724-2 1.724-1.1 0-1.996-.77-2-1.719Zm1.101-.006H10v.005", clipRule: "evenodd" })
  ] }));
};
var sizes49 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionShowOptions(_a) {
  var _b = _a, {
    title = "Show Options",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes49 ? sizes49[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(
    Svgr49,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes49.medium,
      height: resolvedSize || sizes49.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionShowPreview.tsx
var import_jsx_runtime51 = require("react/jsx-runtime");
var Svgr50 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime51.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes50 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionShowPreview(_a) {
  var _b = _a, {
    title = "Show Preview",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes50 ? sizes50[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(
    Svgr50,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes50.medium,
      height: resolvedSize || sizes50.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionStopProcess.tsx
var import_jsx_runtime52 = require("react/jsx-runtime");
var Svgr51 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.997 3.749a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5Zm-9.75 8.25c0-5.385 4.366-9.75 9.75-9.75 5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75c-5.384 0-9.75-4.365-9.75-9.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.469 9.469a.75.75 0 0 1 1.06 0l4.002 4.002a.75.75 0 1 1-1.06 1.06L9.469 10.53a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime52.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.531 9.469a.75.75 0 0 1 0 1.06l-4.001 4.002a.75.75 0 0 1-1.061-1.06l4.002-4.002a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes51 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionStopProcess(_a) {
  var _b = _a, {
    title = "Stop Process",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes51 ? sizes51[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
    Svgr51,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes51.medium,
      height: resolvedSize || sizes51.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionUnfavorited.tsx
var import_jsx_runtime53 = require("react/jsx-runtime");
var Svgr52 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime53.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime53.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M16.5 4C19.67 4 21 6.22 21 9c0 5.63-8.84 11-9 11-.16 0-9-5.37-9-11 0-2.78 1.33-5 4.5-5 1.82 0 3.81 2.2 4.5 3 .69-.8 2.68-3 4.5-3Z", clipRule: "evenodd" })
  ] }));
};
var sizes52 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionUnfavorited(_a) {
  var _b = _a, {
    title = "Unfavorited",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes52 ? sizes52[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(
    Svgr52,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes52.medium,
      height: resolvedSize || sizes52.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionUnmaskField.tsx
var import_jsx_runtime54 = require("react/jsx-runtime");
var Svgr53 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime54.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)("path", { fill: "currentcolor", d: "M9.692 12A2.315 2.315 0 0 1 12 9.677a.771.771 0 0 0 .769-.773.771.771 0 0 0-.77-.774c-2.123 0-3.845 1.733-3.845 3.87S9.876 15.87 12 15.87s3.846-1.733 3.846-3.87a.771.771 0 0 0-.769-.774.771.771 0 0 0-.769.774A2.315 2.315 0 0 1 12 14.322 2.315 2.315 0 0 1 9.692 12Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m2.536 9.685.008-.016A10.456 10.456 0 0 1 12 4.001a10.455 10.455 0 0 1 9.456 5.668l.007.015a5.264 5.264 0 0 1 0 4.632l-.007.014A10.456 10.456 0 0 1 12 20a10.456 10.456 0 0 1-9.456-5.668l-.008-.016A5.287 5.287 0 0 1 2 12v-.002a5.287 5.287 0 0 1 .536-2.314ZM3.538 12c0-.563.129-1.118.375-1.624a8.919 8.919 0 0 1 8.1-4.827 8.919 8.919 0 0 1 8.075 4.827c.499 1.024.499 2.224 0 3.248a8.92 8.92 0 0 1-8.102 4.827 8.919 8.919 0 0 1-8.073-4.827A3.73 3.73 0 0 1 3.538 12Z", clipRule: "evenodd" })
  ] }));
};
var sizes53 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionUnmaskField(_a) {
  var _b = _a, {
    title = "Unmask Field",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes53 ? sizes53[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    Svgr53,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes53.medium,
      height: resolvedSize || sizes53.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionUnrated.tsx
var import_jsx_runtime55 = require("react/jsx-runtime");
var Svgr54 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("path", { fill: "currentcolor", d: "M6.8 21.1c-.2 0-.4-.1-.6-.2-.4-.3-.5-.7-.4-1.1L7.4 15c.1-.4 0-.9-.4-1.1l-4.1-3c-.4-.3-.5-.7-.4-1.1.1-.4.5-.7 1-.7h5c.4 0 .8-.3 1-.7L11 3.6c.1-.4.5-.7 1-.7.4 0 .8.3 1 .7l1.6 4.8c.1.4.5.7 1 .7h5c.4 0 .8.3 1 .7.1.4 0 .9-.4 1.1l-4.1 3c-.4.3-.5.7-.4 1.1l1.6 4.8c.1.4 0 .9-.4 1.1-.4.2-.8.3-1.2 0l-4.1-3c-.4-.3-.8-.3-1.2 0l-4.1 3c-.1.1-.3.2-.5.2Zm5.2-4.9c.5 0 1 .2 1.5.5l2.8 2.1-1.1-3.3c-.3-1 0-2.2.9-2.8l2.8-2.1h-3.5c-1.1 0-2-.7-2.4-1.7l-1-3.4-1.1 3.3c-.3 1-1.3 1.7-2.4 1.7H5l2.8 2.1c.9.6 1.2 1.8.9 2.8l-1.1 3.3 2.8-2.1c.6-.2 1.1-.4 1.6-.4Z" })
  ] }));
};
var sizes54 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionUnrated(_a) {
  var _b = _a, {
    title = "Unrated",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes54 ? sizes54[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
    Svgr54,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes54.medium,
      height: resolvedSize || sizes54.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionUserAvatar.tsx
var import_jsx_runtime56 = require("react/jsx-runtime");
var Svgr55 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.834 6.166A8.25 8.25 0 1 0 6.166 17.834 8.25 8.25 0 0 0 17.834 6.166Zm1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime56.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M13.459 8.854a2.063 2.063 0 1 0-2.918 2.918 2.063 2.063 0 0 0 2.918-2.918Zm1.06-1.06a3.563 3.563 0 1 0-5.038 5.039 3.563 3.563 0 0 0 5.038-5.04ZM5.749 18.443a8.595 8.595 0 0 1 6.25-2.693 8.598 8.598 0 0 1 6.252 2.692.75.75 0 0 1-1.088 1.032A7.098 7.098 0 0 0 12 17.25a7.095 7.095 0 0 0-5.163 2.225.75.75 0 0 1-1.088-1.032Z", clipRule: "evenodd" })
  ] }));
};
var sizes55 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionUserAvatar(_a) {
  var _b = _a, {
    title = "User Avatar",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes55 ? sizes55[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
    Svgr55,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes55.medium,
      height: resolvedSize || sizes55.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionViewAsCards.tsx
var import_jsx_runtime57 = require("react/jsx-runtime");
var Svgr56 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime57.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime57.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime57.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.461 3.75c-.69 0-1.25.56-1.25 1.25v2.75c0 .69.56 1.25 1.25 1.25h2.75c.691 0 1.25-.56 1.25-1.25V5c0-.69-.559-1.25-1.25-1.25h-2.75ZM2.711 5a2.75 2.75 0 0 1 2.75-2.75h2.75A2.75 2.75 0 0 1 10.961 5v2.75a2.75 2.75 0 0 1-2.75 2.75h-2.75a2.75 2.75 0 0 1-2.75-2.75V5Zm14-1.25c-.69 0-1.25.56-1.25 1.25v2.75c0 .69.56 1.25 1.25 1.25h2.75c.691 0 1.25-.56 1.25-1.25V5c0-.69-.559-1.25-1.25-1.25h-2.75ZM13.961 5a2.75 2.75 0 0 1 2.75-2.75h2.75A2.75 2.75 0 0 1 22.211 5v2.75a2.75 2.75 0 0 1-2.75 2.75h-2.75a2.75 2.75 0 0 1-2.75-2.75V5Zm-8.5 10c-.69 0-1.25.56-1.25 1.25V19c0 .69.56 1.25 1.25 1.25h2.75c.691 0 1.25-.56 1.25-1.25v-2.75c0-.69-.559-1.25-1.25-1.25h-2.75Zm-2.75 1.25a2.75 2.75 0 0 1 2.75-2.75h2.75a2.75 2.75 0 0 1 2.75 2.75V19a2.75 2.75 0 0 1-2.75 2.75h-2.75A2.75 2.75 0 0 1 2.711 19v-2.75Zm14-1.25c-.69 0-1.25.56-1.25 1.25V19c0 .69.56 1.25 1.25 1.25h2.75c.691 0 1.25-.56 1.25-1.25v-2.75c0-.69-.559-1.25-1.25-1.25h-2.75Zm-2.75 1.25a2.75 2.75 0 0 1 2.75-2.75h2.75a2.75 2.75 0 0 1 2.75 2.75V19a2.75 2.75 0 0 1-2.75 2.75h-2.75a2.75 2.75 0 0 1-2.75-2.75v-2.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes56 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionViewAsCards(_a) {
  var _b = _a, {
    title = "View As Cards",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes56 ? sizes56[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
    Svgr56,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes56.medium,
      height: resolvedSize || sizes56.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionViewAsList.tsx
var import_jsx_runtime58 = require("react/jsx-runtime");
var Svgr57 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime58.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime58.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.714 5.468c0-.486.384-.88.857-.88h12.572c.473 0 .857.394.857.88s-.384.88-.857.88H8.571a.869.869 0 0 1-.857-.88ZM7.714 12c0-.486.384-.88.857-.88h12.572c.473 0 .857.394.857.88s-.384.88-.857.88H8.571a.869.869 0 0 1-.857-.88ZM7.714 18.532c0-.486.384-.88.857-.88h12.572c.473 0 .857.394.857.88s-.384.88-.857.88H8.571a.869.869 0 0 1-.857-.88ZM2 5.468C2 4.658 2.64 4 3.428 4c.79 0 1.429.657 1.429 1.468 0 .81-.64 1.468-1.429 1.468S2 6.279 2 5.468ZM2 12c0-.81.64-1.468 1.428-1.468.79 0 1.429.657 1.429 1.468 0 .81-.64 1.468-1.429 1.468S2 12.81 2 12ZM2 18.532c0-.81.64-1.468 1.428-1.468.79 0 1.429.657 1.429 1.468 0 .81-.64 1.468-1.429 1.468S2 19.343 2 18.532Z", clipRule: "evenodd" })
  ] }));
};
var sizes57 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionViewAsList(_a) {
  var _b = _a, {
    title = "View As List",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes57 ? sizes57[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
    Svgr57,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes57.medium,
      height: resolvedSize || sizes57.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconActionWatchInterview.tsx
var import_jsx_runtime59 = require("react/jsx-runtime");
var Svgr58 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6 3.75A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6ZM2.25 6A3.75 3.75 0 0 1 6 2.25h12A3.75 3.75 0 0 1 21.75 6v12A3.75 3.75 0 0 1 18 21.75H6A3.75 3.75 0 0 1 2.25 18V6Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime59.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.559 9.704v4.59L14.44 12l-3.882-2.295Zm.763-1.292A1.5 1.5 0 0 0 9.06 9.704v4.59a1.5 1.5 0 0 0 2.263 1.292l3.882-2.295a1.5 1.5 0 0 0 0-2.583l-3.882-2.296Z", clipRule: "evenodd" })
  ] }));
};
var sizes58 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconActionWatchInterview(_a) {
  var _b = _a, {
    title = "Watch Interview",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes58 ? sizes58[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(
    Svgr58,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes58.medium,
      height: resolvedSize || sizes58.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveActionItems.tsx
var import_jsx_runtime60 = require("react/jsx-runtime");
var Svgr59 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.5 3.75a.75.75 0 0 0-.75.75v15c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-13Zm-2.25.75A2.25 2.25 0 0 1 5.5 2.25h13a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-15Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.882 16.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM10.058 15.15a.75.75 0 0 1-.057 1.06l-1.336 1.2a.75.75 0 0 1-1.002 0l-.664-.597A.75.75 0 0 1 8 15.697l.163.147.835-.75a.75.75 0 0 1 1.06.057ZM11.882 12.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM8.25 7A.75.75 0 0 1 9 6.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 7ZM10.058 11.15a.75.75 0 0 1-.057 1.06l-1.336 1.2a.75.75 0 0 1-1.002 0l-.664-.597A.75.75 0 0 1 8 11.697l.163.147.835-.75a.75.75 0 0 1 1.06.057Z", clipRule: "evenodd" })
  ] }));
};
var sizes59 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveActionItems(_a) {
  var _b = _a, {
    title = "Action Items",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes59 ? sizes59[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
    Svgr59,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes59.medium,
      height: resolvedSize || sizes59.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveBenefits.tsx
var import_jsx_runtime61 = require("react/jsx-runtime");
var Svgr60 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime61.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.814 11.538c0-1.147.937-2.077 2.093-2.077S22 10.391 22 11.538v6.052c0 .68-.16 1.351-.466 1.96l-.538 1.067a.7.7 0 0 1-.936.31.69.69 0 0 1-.312-.93l.538-1.066a2.98 2.98 0 0 0 .319-1.341v-6.052a.695.695 0 0 0-.698-.692.695.695 0 0 0-.698.692v3.693a.695.695 0 0 1-.697.692.695.695 0 0 1-.698-.692v-3.693Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.576 14.774a.816.816 0 0 0-1.224.087l-1.561 2.065c-.151.2-.233.443-.233.692v2.69a.695.695 0 0 1-.697.692.695.695 0 0 1-.698-.692v-2.69c0-.549.18-1.083.511-1.523l1.561-2.065a2.217 2.217 0 0 1 3.327-.235m0 0c.777.771.865 1.992.206 2.864l-.979 1.295a.701.701 0 0 1-.977.138.689.689 0 0 1-.14-.969l.98-1.295a.802.802 0 0 0-.076-1.053M4.093 10.846a.695.695 0 0 0-.698.692v6.052c0 .465.11.925.32 1.34l.537 1.068a.69.69 0 0 1-.312.929.7.7 0 0 1-.936-.31l-.538-1.067A4.355 4.355 0 0 1 2 17.59v-6.052c0-1.147.937-2.077 2.093-2.077s2.093.93 2.093 2.077v3.693a.695.695 0 0 1-.698.692.695.695 0 0 1-.697-.692v-3.693a.695.695 0 0 0-.698-.692Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime61.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.437 13.796a2.218 2.218 0 0 1 3.328.234l1.56 2.065c.333.44.512.974.512 1.523v2.69a.695.695 0 0 1-.697.692.695.695 0 0 1-.698-.692v-2.69c0-.25-.082-.492-.233-.692l-1.56-2.065a.814.814 0 0 0-1.225-.087.802.802 0 0 0-.075 1.054l.978 1.295a.689.689 0 0 1-.14.97.701.701 0 0 1-.976-.14l-.979-1.294a2.178 2.178 0 0 1 .205-2.863ZM9.628 4.615c0-.892.729-1.615 1.628-1.615h1.488c.9 0 1.628.723 1.628 1.615v.877h.884c.899 0 1.628.724 1.628 1.616v1.477c0 .428-.172.839-.477 1.142-.305.303-.72.473-1.151.473h-.884v.877c0 .892-.729 1.615-1.628 1.615h-1.488c-.9 0-1.628-.723-1.628-1.615V10.2h-.884c-.899 0-1.628-.723-1.628-1.615V7.108c0-.892.73-1.616 1.628-1.616h.884v-.877Zm1.628-.23a.232.232 0 0 0-.233.23v1.57a.695.695 0 0 1-.697.692H8.744a.232.232 0 0 0-.232.23v1.478c0 .127.104.23.232.23h1.582c.385 0 .697.31.697.693v1.569c0 .127.104.23.233.23h1.488a.232.232 0 0 0 .233-.23v-1.57c0-.382.312-.692.697-.692h1.582a.23.23 0 0 0 .233-.23V7.108a.232.232 0 0 0-.233-.231h-1.582a.695.695 0 0 1-.697-.692v-1.57a.232.232 0 0 0-.233-.23h-1.488Z", clipRule: "evenodd" })
  ] }));
};
var sizes60 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveBenefits(_a) {
  var _b = _a, {
    title = "Benefits",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes60 ? sizes60[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
    Svgr60,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes60.medium,
      height: resolvedSize || sizes60.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveBuilding.tsx
var import_jsx_runtime62 = require("react/jsx-runtime");
var Svgr61 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 4.75a.75.75 0 0 1 .75.75V8A.75.75 0 0 1 11 8V5.5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.75 6.75A.75.75 0 0 1 10.5 6H13a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM7 6.75a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0ZM8.75 15.5a.25.25 0 0 0-.25.25V21H15v-5.25a.25.25 0 0 0-.25-.25h-6ZM7 15.75c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-.75.75h-8a.75.75 0 0 1-.75-.75v-6ZM2.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13A.75.75 0 0 1 2.75 8ZM20.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.75 6.5a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h5.537a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 7.75v-1C1 5.784 1.784 5 2.75 5h5.128a.75.75 0 0 1 0 1.5H2.75ZM14.873 5.75a.75.75 0 0 1 .75-.75h5.127c.966 0 1.75.784 1.75 1.75v1a1.75 1.75 0 0 1-1.75 1.75h-5.536a.75.75 0 1 1 0-1.5h5.536a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-5.127a.75.75 0 0 1-.75-.75ZM1 21.75a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5h-20a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 14a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes61 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveBuilding(_a) {
  var _b = _a, {
    title = "Building",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes61 ? sizes61[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
    Svgr61,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes61.medium,
      height: resolvedSize || sizes61.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveCalendar.tsx
var import_jsx_runtime63 = require("react/jsx-runtime");
var Svgr62 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("path", { fill: "currentcolor", d: "M19.001 3.8h-2.2V2.5c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.2h-6.4V2.5c0-.4-.3-.8-.8-.8s-.8.4-.8.8v1.2h-2.2c-1.5.1-2.8 1.3-2.8 2.8v13c0 1.5 1.2 2.8 2.8 2.8h14c1.5 0 2.8-1.2 2.8-2.8v-13c0-1.5-1.3-2.7-2.8-2.7Zm-14 1.4h2.2v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.2h6.5v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.2h2.1c.7 0 1.2.6 1.2 1.2v2.2h-16.4V6.5c0-.7.5-1.3 1.2-1.3Zm14 15.6h-14c-.7 0-1.2-.6-1.2-1.2v-9.2h16.5v9.2c-.1.6-.6 1.2-1.3 1.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("path", { fill: "currentcolor", d: "M12.001 12.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM17.001 12.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM7.001 16.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM12.001 16.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes62 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveCalendar(_a) {
  var _b = _a, {
    title = "Calendar",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes62 ? sizes62[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
    Svgr62,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes62.medium,
      height: resolvedSize || sizes62.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveClock.tsx
var import_jsx_runtime64 = require("react/jsx-runtime");
var Svgr63 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("path", { fill: "currentcolor", d: "M12.001 21.8c-1.3 0-2.5-.2-3.7-.7-2.4-1.1-4.3-3-5.3-5.4-2.1-4.9.3-10.6 5.3-12.7 2.4-1 5.1-1 7.5 0 2.3 1 4.2 2.9 5.2 5.3s1 5.1 0 7.5c-1 2.4-2.9 4.3-5.3 5.3-1.2.4-2.4.7-3.7.7Zm0-18.1c-1.1 0-2.1.2-3.2.6-4.2 1.8-6.2 6.7-4.4 10.9.8 2 2.4 3.6 4.5 4.5 2 .8 4.3.8 6.3 0s3.6-2.4 4.5-4.5c.9-2.1.8-4.3 0-6.3s-2.4-3.6-4.5-4.5c-1.1-.4-2.1-.7-3.2-.7Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.701 7.2c.4 0 .8.3.8.8v4.2l3.3 2c.4.2.5.7.2 1-.2.4-.7.5-1 .2l-3.7-2.2c-.2-.1-.4-.4-.4-.6V8c.1-.4.4-.8.8-.8Z", clipRule: "evenodd" })
  ] }));
};
var sizes63 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveClock(_a) {
  var _b = _a, {
    title = "Clock",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes63 ? sizes63[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
    Svgr63,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes63.medium,
      height: resolvedSize || sizes63.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveEducation.tsx
var import_jsx_runtime65 = require("react/jsx-runtime");
var Svgr64 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime65.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M22.2 9.2c0-1-.5-1.8-1.3-2.3l-6.2-3.4c-1.7-.9-3.7-.9-5.3 0L3.2 6.9c-.9.5-1.4 1.3-1.4 2.3 0 1 .5 1.8 1.3 2.3l2.1 1.2v3.5c0 1.2.6 2.3 1.6 2.9l1.6 1.1c1.1.7 2.3 1.1 3.5 1.1 1.2 0 2.5-.4 3.5-1.1l1.6-1.1c1-.7 1.6-1.8 1.6-2.9v-3.5l1.1-.6v3c0 .4.3.7.7.7.4 0 .7-.3.7-.7v-3.8c.7-.6 1.1-1.3 1.1-2.1Zm-18.9 0c0-.4.2-.8.6-1L10 4.7c1.3-.7 2.7-.7 4 0l6.2 3.4c.4.2.6.6.6 1s-.2.8-.6 1L14 13.6c-1.2.7-2.7.7-3.9 0l-6.2-3.4c-.4-.2-.6-.6-.6-1Zm14 6.9c0 .7-.4 1.4-.9 1.8L14.7 19c-1.7 1.1-3.8 1.1-5.5 0l-1.6-1.1c-.6-.4-.9-1.1-.9-1.8v-2.7l2.7 1.5c.8.5 1.7.7 2.6.7.9 0 1.8-.2 2.6-.7l2.7-1.5v2.7Z", clipRule: "evenodd" })
  ] }));
};
var sizes64 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveEducation(_a) {
  var _b = _a, {
    title = "Education",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes64 ? sizes64[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
    Svgr64,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes64.medium,
      height: resolvedSize || sizes64.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveFacility.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
var Svgr65 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 4a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 12 4Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10 6a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 10 6Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM7.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0ZM9 14.75a.25.25 0 0 0-.25.25v5.25h6.5V15a.25.25 0 0 0-.25-.25H9ZM7.25 15c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-.75.75H8a.75.75 0 0 1-.75-.75v-6ZM3 7.25a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 3 7.25ZM21 7.25a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3 5.75a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h5.537a.75.75 0 0 1 0 1.5H3A1.75 1.75 0 0 1 1.25 7V6c0-.966.784-1.75 1.75-1.75h5.128a.75.75 0 0 1 0 1.5H3ZM15.123 5a.75.75 0 0 1 .75-.75H21c.966 0 1.75.784 1.75 1.75v1A1.75 1.75 0 0 1 21 8.75h-5.536a.75.75 0 1 1 0-1.5H21a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-5.127a.75.75 0 0 1-.75-.75ZM1.25 21a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 13.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes65 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveFacility(_a) {
  var _b = _a, {
    title = "Facility",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes65 ? sizes65[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
    Svgr65,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes65.medium,
      height: resolvedSize || sizes65.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveHealthSystem.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var Svgr66 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M1.25 7c0-.966.784-1.75 1.75-1.75h4a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h.25V7Zm1.5 13.25h3.5v-2.5H5a.75.75 0 0 1 0-1.5h1.25v-2H5a.75.75 0 0 1 0-1.5h1.25v-2H5a.75.75 0 0 1 0-1.5h1.25v-2.5H3a.25.25 0 0 0-.25.25v13.25ZM16.25 6a.75.75 0 0 1 .75-.75h4c.966 0 1.75.784 1.75 1.75v13.25H23a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75V6Zm1.5 4.75H19a.75.75 0 0 0 0-1.5h-1.25v-2.5H21a.25.25 0 0 1 .25.25v13.25h-3.5v-2.5H19a.75.75 0 0 0 0-1.5h-1.25v-2H19a.75.75 0 0 0 0-1.5h-1.25v-2ZM9.25 12a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Zm0 3a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Zm-.5 3a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-.25V21a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-2.25H9.5a.75.75 0 0 1-.75-.75Zm2.5.75v1.5h1.5v-1.5h-1.5Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 4.04c0-.96.756-1.79 1.75-1.79h8c.994 0 1.75.83 1.75 1.79V21a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75V4.04ZM8 3.75c-.11 0-.25.102-.25.29v16.21h8.5V4.04c0-.188-.14-.29-.25-.29H8Zm4 1.5a.75.75 0 0 1 .75.75v.75h.75a.75.75 0 0 1 0 1.5h-.75V9a.75.75 0 0 1-1.5 0v-.75h-.75a.75.75 0 0 1 0-1.5h.75V6a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes66 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveHealthSystem(_a) {
  var _b = _a, {
    title = "Health System",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes66 ? sizes66[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
    Svgr66,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes66.medium,
      height: resolvedSize || sizes66.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveLicense.tsx
var import_jsx_runtime68 = require("react/jsx-runtime");
var Svgr67 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.5 4.75a.25.25 0 0 0-.25.25v4.25h3.5V5a.25.25 0 0 0-.25-.25h-3ZM8.75 5c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75V5Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.25 10A.75.75 0 0 1 8 9.25h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM8 13.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.75 15.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM12.25 14a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM12.25 17a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime68.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5 7.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-4.5a.75.75 0 0 1 0-1.5H19A2.75 2.75 0 0 1 21.75 9v10A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V9A2.75 2.75 0 0 1 5 6.25h4.5a.75.75 0 0 1 0 1.5H5Z", clipRule: "evenodd" })
  ] }));
};
var sizes67 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveLicense(_a) {
  var _b = _a, {
    title = "License",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes67 ? sizes67[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(
    Svgr67,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes67.medium,
      height: resolvedSize || sizes67.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveLocation.tsx
var import_jsx_runtime69 = require("react/jsx-runtime");
var Svgr68 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("path", { fill: "currentcolor", d: "M12 21.8c-.4 0-.8-.1-1.1-.4-2.2-1.9-7.1-6.7-7.1-11.4 0-4.3 3.7-7.8 8.2-7.8 4.5 0 8.2 3.5 8.2 7.8 0 4.7-5 9.5-7.1 11.3-.3.3-.7.5-1.1.5Zm0-18.1c-3.7 0-6.8 2.8-6.8 6.2 0 4.1 5 8.8 6.6 10.2.1.1.2.1.3 0 1.5-1.3 6.6-6 6.6-10.2.1-3.3-3-6.2-6.7-6.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime69.jsx)("path", { fill: "currentcolor", d: "M12 13.6c-1.8 0-3.2-1.5-3.2-3.2 0-1.7 1.5-3.2 3.2-3.2 1.7 0 3.2 1.5 3.2 3.2 0 1.7-1.4 3.2-3.2 3.2Zm0-5c-1 0-1.7.8-1.7 1.7 0 1 .8 1.7 1.7 1.7 1 0 1.7-.8 1.7-1.7 0-.9-.7-1.7-1.7-1.7Z" })
  ] }));
};
var sizes68 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveLocation(_a) {
  var _b = _a, {
    title = "Location",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes68 ? sizes68[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
    Svgr68,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes68.medium,
      height: resolvedSize || sizes68.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveMealBreak.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");
var Svgr69 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("path", { fill: "currentcolor", d: "M6.999 21.8c-1.2 0-2.2-1-2.2-2.2v-7.4c0-.4-.3-.7-.4-.8-1-.9-1.5-2.2-1.6-3.5V3.1c0-.4.3-.8.8-.8s.8.3.8.8v4.5c0 1 .4 2 1.1 2.6.6.5.9 1.2.9 1.9v7.4c0 .4.3.8.8.8s.8-.3.8-.8v-7.4c0-.7.3-1.4.9-1.9.7-.6 1.1-1.6 1.1-2.6V3.1c0-.4.3-.8.8-.8s.8.3.8.8v4.5c0 1.4-.6 2.8-1.6 3.7-.2.1-.4.4-.4.8v7.4c-.4 1.2-1.4 2.3-2.6 2.3Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime70.jsx)("path", { fill: "currentcolor", d: "M6.999 8.8c-.4 0-.8-.4-.8-.8V3c0-.4.3-.8.8-.8s.8.4.8.8v5c0 .4-.4.8-.8.8ZM18.999 21.8c-1.2 0-2.2-1-2.2-2.2v-4.1c-1.2-.6-2-1.9-2-3.3v-6c0-2.1 1.7-3.8 3.8-3.8h1c1 0 1.8.8 1.8 1.8v15.4c-.2 1.1-1.2 2.2-2.4 2.2Zm-.5-18c-1.2 0-2.2 1-2.2 2.2v6c0 .9.6 1.8 1.5 2.1.3.1.5.4.5.7v4.6c0 .4.3.8.8.8s.8-.3.8-.8V4.1c0-.1-.1-.2-.2-.2h-1.2v-.1Z" })
  ] }));
};
var sizes69 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveMealBreak(_a) {
  var _b = _a, {
    title = "Meal Break",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes69 ? sizes69[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(
    Svgr69,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes69.medium,
      height: resolvedSize || sizes69.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveNotes.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");
var Svgr70 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 7A4.75 4.75 0 0 1 7 2.25h10A4.75 4.75 0 0 1 21.75 7v10A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17V7ZM7 3.75A3.25 3.25 0 0 0 3.75 7v10A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17V7A3.25 3.25 0 0 0 17 3.75H7Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime71.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 8A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8ZM6.25 16a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes70 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveNotes(_a) {
  var _b = _a, {
    title = "Notes",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes70 ? sizes70[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
    Svgr70,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes70.medium,
      height: resolvedSize || sizes70.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveOfferExtended.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");
var Svgr71 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime72.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime72.jsx)("path", { fill: "currentcolor", d: "M21.8 9.1c-.1-.1-.3-.2-.5-.2s-.3.1-.5.2l-3.3 3.3-5.2-5.1.6-.6c.1-.1.2-.3.2-.5s-.1-.3-.2-.5c-.1-.1-.3-.2-.5-.2s-.3.1-.5.2L9.1 8.4c-.1.1-.3.1-.4 0l-.3-.2c0-.1-.1-.2-.1-.3 0-.1 0-.2.1-.2l3-3s.8-.7 1.3-.2l1.4 1.3c.1.1.3.2.5.2s.3-.1.5-.2l1.5-1.4c.1-.1.2-.3.2-.5s-.1-.3-.2-.5c-.3-.3-.7-.3-1 0l-1 1-.9-.8c-1.1-1.1-2.5-.5-3.2.2l-.9.9-1.1-1.1c-.1-.1-.3-.2-.5-.2s-.3.1-.5.2c-.1.2-.2.3-.2.5s.1.3.2.5l1.1 1.1-1.1 1.1c-.3.3-.5.7-.5 1.2s.2.9.5 1.2l.2.2c.3.3.8.5 1.2.5.5 0 .9-.2 1.2-.5l1.2-1.2 6.1 6c.1.1.2.2.2.4 0 .1-.1.3-.2.4-.2.2-.6.2-.8 0l-2-2c-.1-.1-.3-.2-.5-.2s-.3.1-.5.2c-.1.1-.2.3-.2.5s.1.3.2.5l2.2 2.1c.1.1.2.2.2.4 0 .1-.1.3-.2.4-.2.2-.6.2-.8 0l-.1-.1-.1-.1-2.1-2c-.1-.1-.3-.2-.5-.2s-.3.1-.5.2c-.1.1-.2.3-.2.5s.1.3.2.5l2.1 2.1c.2 0 .2.1.2.2s-.1.3-.2.4c-.2.2-.6.2-.8 0l-1.9-1.9c.1-.2.1-.3.1-.6 0-.5-.2-.9-.5-1.2-.2-.2-.6-.4-.9-.5l.1-.1c.3-.3.5-.8.5-1.2 0-.5-.2-.9-.5-1.2-.3-.3-.7-.5-1.2-.5s-.9.2-1.2.5l-.5.5-3.8-3.6c-.2-.1-.3-.2-.5-.2s-.3.1-.5.2c-.1.2-.2.4-.2.6 0 .2.1.3.2.5l3.7 3.7-1 1c-.7.7-.7 1.7 0 2.4.3.3.8.5 1.2.5h.1c-.1.5.1 1.1.5 1.5.4.4 1 .6 1.5.5v.1c0 .5.2.9.5 1.2.4.2.8.4 1.3.4s.9-.2 1.2-.5l1-1c.3.3.8.5 1.3.5s1-.2 1.4-.6c.3-.3.5-.6.5-1 .5 0 1-.2 1.4-.6.3-.3.5-.8.6-1.3.4-.1.8-.2 1.1-.5.4-.4.6-.8.6-1.4 0-.5-.2-1-.5-1.3l3.3-3.3c.2-.3.2-.7-.1-.9ZM9.6 19.3c0-.1 0-.2.1-.2l1-1 .5.5-1 1c-.1.1-.4.1-.5 0-.1-.1-.1-.2-.1-.3Zm-1.9-2.1 1.5-1.5c.1-.1.4-.1.5 0 .1.1.1.1.1.2s0 .2-.1.2l-1.5 1.5c-.1.1-.1.1-.2.1s-.2 0-.2-.1c-.2 0-.2-.2-.1-.4ZM8.9 13c0 .1 0 .2-.1.2l-2.5 2.4c-.1.1-.1.1-.2.1s-.2 0-.2-.1c-.1-.1-.1-.3 0-.5l2.5-2.4c.1-.1.2-.1.2-.1.1 0 .2 0 .2.1.1.2.1.2.1.3Z" })
  ] }));
};
var sizes71 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveOfferExtended(_a) {
  var _b = _a, {
    title = "Offer Extended",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes71 ? sizes71[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
    Svgr71,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes71.medium,
      height: resolvedSize || sizes71.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptivePayRate.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
var Svgr72 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("path", { fill: "currentcolor", d: "m20.3 4.7-.3-.1c-2.6-.5-5.3-.5-7.9.2l-.5.1c-2.4.6-4.9.7-7.3.2-.5-.1-1 0-1.5.4-.3.3-.6.8-.6 1.3v10.8c0 .8.6 1.6 1.4 1.7h.2c1.2.2 2.5.4 3.7.4 1.6 0 3.1-.2 4.6-.6l.2-.1c2.4-.6 4.9-.6 7.2-.2.5.1 1 0 1.5-.4.4-.3.6-.8.6-1.4V6.4c.2-.8-.4-1.6-1.3-1.7Zm-.1 12.5c0 .1-.1.2-.1.2s-.1.1-.2.1c-2.6-.5-5.3-.5-7.9.2l-.2.1c-2.5.6-5.2.7-7.7.2h-.2c-.1 0-.2-.1-.2-.2v-11c0-.1.1-.2.1-.2s.1-.1.2-.1h.1c2.5.6 5.3.5 7.8-.1l.5-.1c2.4-.6 4.9-.6 7.2-.2h.4c.1 0 .2.1.2.2v10.9Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.5 8a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0V8.75A.75.75 0 0 1 11.5 8ZM11.5 14.125a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0v-.875a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.978 10.374a.478.478 0 0 0-.115.944l1.64.412a1.978 1.978 0 0 1-.482 3.898h-.958c-.763 0-1.377-.425-1.72-.986a.75.75 0 0 1 1.279-.783c.11.18.27.269.441.269h.959a.478.478 0 0 0 .115-.944l-1.64-.412a1.978 1.978 0 0 1 .48-3.898h.96c.762 0 1.375.421 1.72.983a.75.75 0 1 1-1.28.784.512.512 0 0 0-.44-.267h-.959Z", clipRule: "evenodd" })
  ] }));
};
var sizes72 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptivePayRate(_a) {
  var _b = _a, {
    title = "Pay Rate",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes72 ? sizes72[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(
    Svgr72,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes72.medium,
      height: resolvedSize || sizes72.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptivePlacementHistory.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
var Svgr73 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.221 10.383a3.234 3.234 0 1 1 6.468 0 3.234 3.234 0 0 1-6.468 0Zm3.234-1.734a1.734 1.734 0 1 0 0 3.468 1.734 1.734 0 0 0 0-3.468Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.431 6.2a8.205 8.205 0 0 1 15.209 4.772.75.75 0 0 1-1.497-.096 6.705 6.705 0 1 0-11.427 4.319l.001.001 5.27 5.278a.75.75 0 1 1-1.062 1.06l-5.268-5.277A8.206 8.206 0 0 1 3.43 6.2Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.502 13.75a3.752 3.752 0 1 0 0 7.504 3.752 3.752 0 0 0 0-7.504Zm0-1.5a5.252 5.252 0 1 0 0 10.504 5.252 5.252 0 0 0 0-10.504Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.395 15.235a.75.75 0 0 1 .75.75v1.338l1.023.624a.75.75 0 1 1-.781 1.28l-1.383-.843a.75.75 0 0 1-.36-.64v-1.76a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes73 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptivePlacementHistory(_a) {
  var _b = _a, {
    title = "Placement History",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes73 ? sizes73[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
    Svgr73,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes73.medium,
      height: resolvedSize || sizes73.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveQuicklySubmtted.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");
var Svgr74 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 1.411C6.152 1.411 1.411 6.152 1.411 12A.706.706 0 1 1 0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12a.706.706 0 1 1 0-1.411c5.848 0 10.589-4.741 10.589-10.589 0-5.848-4.741-10.589-10.589-10.589Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime75.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m16.436 7.89-9.948 3.838 1.999.624c.223.07.397.245.465.468l.875 2.882 1.212-1.18a.706.706 0 0 1 .91-.061l2.653 1.958c.004.004.01.005.016.003a.017.017 0 0 0 .01-.013l1.808-8.518Zm-10.85 4.186.003-.001Zm10.606-5.603a1.262 1.262 0 0 1 1.686 1.423l-.002.01L16.01 16.7a1.43 1.43 0 0 1-2.249.854l-2.167-1.601-1.133 1.103a1.115 1.115 0 0 1-1.837-.459l-.004-.01-.91-2.998-2.561-.8a1.074 1.074 0 0 1-.066-2.03l.002-.001 11.107-4.284ZM6.224 17.776a.706.706 0 0 1 0 .998L2.46 22.538a.706.706 0 1 1-.997-.997l3.764-3.765a.706.706 0 0 1 .998 0ZM8.734 21.54a.706.706 0 0 1 0 .998L7.48 23.793a.706.706 0 1 1-.998-.997l1.255-1.255a.706.706 0 0 1 .998 0ZM2.46 15.266a.706.706 0 0 1 0 .998l-1.255 1.255a.706.706 0 0 1-.998-.998l1.255-1.255a.706.706 0 0 1 .997 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes74 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveQuicklySubmtted(_a) {
  var _b = _a, {
    title = "Quickly Submitted",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes74 ? sizes74[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
    Svgr74,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes74.medium,
      height: resolvedSize || sizes74.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveReference.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
var Svgr75 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.987 11.75a2.196 2.196 0 0 0-2.237 2.236V15a.75.75 0 0 1-1.5 0v-.993a3.696 3.696 0 0 1 3.757-3.757h2.987a3.696 3.696 0 0 1 3.757 3.757V15a.75.75 0 0 1-1.5 0v-1.014a2.196 2.196 0 0 0-2.237-2.236H5.987ZM19.608 12.393a2.196 2.196 0 0 0-1.594-.643H16a.75.75 0 0 1 0-1.5h1.994a3.696 3.696 0 0 1 3.756 3.757V15a.75.75 0 0 1-1.5 0v-1.014a2.196 2.196 0 0 0-.642-1.593ZM7.5 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM4.25 5.5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM17 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM14.25 6a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM14.659 17.5a.75.75 0 0 1 .75-.75H18a.75.75 0 0 1 0 1.5H15.41a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M18 16.75a.75.75 0 0 1 .75.75v2.556a.75.75 0 0 1-1.5 0V17.5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.642 16.89a.75.75 0 0 1 1.017.3 5.865 5.865 0 0 0 10.302 0 .75.75 0 1 1 1.317.717 7.365 7.365 0 0 1-12.936 0 .75.75 0 0 1 .3-1.017Z", clipRule: "evenodd" })
  ] }));
};
var sizes75 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveReference(_a) {
  var _b = _a, {
    title = "Reference",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes75 ? sizes75[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
    Svgr75,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes75.medium,
      height: resolvedSize || sizes75.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveReminder.tsx
var import_jsx_runtime77 = require("react/jsx-runtime");
var Svgr76 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.21 18.04a.75.75 0 0 1 1.06 0l2.26 2.26a.75.75 0 1 1-1.06 1.06l-2.26-2.26a.75.75 0 0 1 0-1.06ZM6.79 18.04a.75.75 0 0 1 0 1.06l-2.26 2.26a.75.75 0 0 1-1.06-1.06l2.26-2.26a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.226 6.304a7.249 7.249 0 0 1 9.472 3.923L9.226 6.304Zm-.574-1.386a8.749 8.749 0 0 1 11.432 4.735 8.748 8.748 0 0 1-4.735 11.43A8.748 8.748 0 0 1 3.92 16.35M9.225 6.304a7.248 7.248 0 0 0-3.922 9.47 7.249 7.249 0 0 0 9.471 3.924 7.248 7.248 0 0 0 3.923-9.471M8.652 4.917A8.748 8.748 0 0 0 3.918 16.35L8.652 4.918Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime77.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 8.682a.75.75 0 0 1 .75.75v3.714l2.89 1.762a.75.75 0 0 1-.78 1.281l-3.25-1.982a.75.75 0 0 1-.36-.64V9.432a.75.75 0 0 1 .75-.75ZM3.508 3.456C4.655 2.31 6.278 1.97 7.719 2.378a.75.75 0 1 1-.41 1.443 2.78 2.78 0 0 0-2.74.696m0 0a2.78 2.78 0 0 0-.78 2.346.75.75 0 1 1-1.487.197 4.28 4.28 0 0 1 1.206-3.604M19.444 4.517a2.78 2.78 0 0 0-2.74-.696.75.75 0 0 1-.41-1.443c1.442-.409 3.064-.068 4.21 1.078a4.278 4.278 0 0 1 1.208 3.604.75.75 0 1 1-1.487-.197 2.778 2.778 0 0 0-.781-2.346Z", clipRule: "evenodd" })
  ] }));
};
var sizes76 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveReminder(_a) {
  var _b = _a, {
    title = "Reminder",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes76 ? sizes76[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(
    Svgr76,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes76.medium,
      height: resolvedSize || sizes76.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveRestBreak.tsx
var import_jsx_runtime78 = require("react/jsx-runtime");
var Svgr77 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime78.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.997 11.25a.25.25 0 0 0-.25.25V14.5c0 2.901 2.35 5.253 5.252 5.253h2c2.901 0 5.253-2.352 5.253-5.253V11.5a.25.25 0 0 0-.25-.25H3.996Zm-1.75.25c0-.967.783-1.75 1.75-1.75h12.005c.966 0 1.75.783 1.75 1.75V14.5a6.753 6.753 0 0 1-6.753 6.753H9A6.753 6.753 0 0 1 2.246 14.5V11.5ZM12.983 1.953a.75.75 0 0 1 1.06.026c.943.99.943 2.545 0 3.535a1.063 1.063 0 0 0 0 1.467.75.75 0 0 1-1.086 1.034 2.563 2.563 0 0 1 0-3.535 1.063 1.063 0 0 0 0-1.467.75.75 0 0 1 .026-1.06ZM9.482 1.953a.75.75 0 0 1 1.06.026c.943.99.943 2.545 0 3.535a1.063 1.063 0 0 0 0 1.467.75.75 0 1 1-1.086 1.034 2.563 2.563 0 0 1 0-3.535 1.063 1.063 0 0 0 0-1.467.75.75 0 0 1 .026-1.06ZM5.98 1.953a.75.75 0 0 1 1.06.026c.943.99.943 2.545 0 3.535a1.063 1.063 0 0 0 0 1.467.75.75 0 0 1-1.086 1.034 2.563 2.563 0 0 1 0-3.535m.026-2.527a.75.75 0 0 0-.026 1.06l.026-1.06Zm-.026 1.06c.391.411.391 1.056 0 1.467V3.013Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.751 10.5a.75.75 0 0 1 .75-.75h2.606a3.646 3.646 0 0 1 3.646 3.646 4.647 4.647 0 0 1-3.61 4.53l-1.847.422a.75.75 0 0 1-.334-1.462l1.846-.422a3.147 3.147 0 0 0 2.445-3.068 2.147 2.147 0 0 0-2.146-2.147H15.5a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes77 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveRestBreak(_a) {
  var _b = _a, {
    title = "Rest Break",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes77 ? sizes77[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
    Svgr77,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes77.medium,
      height: resolvedSize || sizes77.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveSecuredField.tsx
var import_jsx_runtime79 = require("react/jsx-runtime");
var Svgr78 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75A3.25 3.25 0 0 0 8.75 7v3a.75.75 0 0 1-1.5 0V7a4.75 4.75 0 0 1 9.5 0v3a.75.75 0 0 1-1.5 0V7A3.25 3.25 0 0 0 12 3.75ZM12 13.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime79.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7 10.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-7c0-.69-.56-1.25-1.25-1.25H7ZM4.25 12A2.75 2.75 0 0 1 7 9.25h10A2.75 2.75 0 0 1 19.75 12v7A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19v-7Z", clipRule: "evenodd" })
  ] }));
};
var sizes78 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveSecuredField(_a) {
  var _b = _a, {
    title = "Secured",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes78 ? sizes78[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(
    Svgr78,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes78.medium,
      height: resolvedSize || sizes78.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveShiftType.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");
var Svgr79 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75a.25.25 0 0 0-.177.073l-1.757 1.758a1.75 1.75 0 0 1-1.238.512H6.343a.25.25 0 0 0-.25.25v2.485c0 .464-.184.91-.512 1.238l-1.758 1.757a.25.25 0 0 0 0 .354l1.758 1.757c.328.329.512.774.512 1.238v2.485c0 .138.112.25.25.25h2.485c.464 0 .91.184 1.238.512l1.757 1.758a.25.25 0 0 0 .354 0l1.757-1.758a1.75 1.75 0 0 1 1.238-.512h2.485a.25.25 0 0 0 .25-.25v-2.485c0-.464.184-.91.512-1.238l1.758-1.757a.25.25 0 0 0 0-.354l-1.758-1.757a1.75 1.75 0 0 1-.512-1.238V6.343a.25.25 0 0 0-.25-.25h-2.485a1.75 1.75 0 0 1-1.238-.512l-1.757-1.758A.25.25 0 0 0 12 3.75Zm-1.237-.987a1.75 1.75 0 0 1 2.474 0l1.758 1.757a.25.25 0 0 0 .177.073h2.485c.966 0 1.75.784 1.75 1.75v2.485c0 .067.026.13.073.177l1.757 1.757a1.75 1.75 0 0 1 0 2.475l-1.757 1.758a.25.25 0 0 0-.073.177v2.485a1.75 1.75 0 0 1-1.75 1.75h-2.485a.25.25 0 0 0-.177.073l-1.757 1.757a1.75 1.75 0 0 1-2.475 0L9.005 19.48a.25.25 0 0 0-.177-.073H6.343a1.75 1.75 0 0 1-1.75-1.75v-2.485a.25.25 0 0 0-.073-.177l-1.757-1.758a1.75 1.75 0 0 1 0-2.474L4.52 9.005a.25.25 0 0 0 .073-.177V6.343c0-.966.784-1.75 1.75-1.75h2.485a.25.25 0 0 0 .177-.073l1.758-1.757Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.349 8.183a.75.75 0 0 1 1.023-.28 4.717 4.717 0 0 1 0 8.194.75.75 0 0 1-.744-1.303 3.217 3.217 0 0 0 0-5.588.75.75 0 0 1-.28-1.023Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime80.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.996 7.25H12a4.75 4.75 0 0 1 0 9.5h-.004a4.709 4.709 0 0 1-2.379-.66.75.75 0 0 1 .766-1.29c.49.291 1.049.447 1.619.45a3.25 3.25 0 0 0 0-6.5 3.209 3.209 0 0 0-1.62.45.75.75 0 1 1-.765-1.29 4.709 4.709 0 0 1 2.379-.66Z", clipRule: "evenodd" })
  ] }));
};
var sizes79 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveShiftType(_a) {
  var _b = _a, {
    title = "Shift Type",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes79 ? sizes79[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(
    Svgr79,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes79.medium,
      height: resolvedSize || sizes79.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveShiftsList.tsx
var import_jsx_runtime81 = require("react/jsx-runtime");
var Svgr80 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.127 7.873A7.25 7.25 0 1 0 6.873 18.128 7.25 7.25 0 0 0 17.127 7.873Zm1.06-1.06A8.75 8.75 0 1 0 5.813 19.189 8.75 8.75 0 0 0 18.187 6.813Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.997 11.75a1.248 1.248 0 0 1 1.253 1.248v.004a1.252 1.252 0 0 1-1.251 1.248c-.69 0-1.249-.559-1.249-1.249 0-.69.56-1.248 1.247-1.251Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime81.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 8.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM9.25 2a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4A.75.75 0 0 1 9.25 2ZM18.47 3.47a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06L20 6.06l-1.813 1.813a.75.75 0 1 1-1.06-1.06L18.939 5l-.47-.47a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes80 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveShiftsList(_a) {
  var _b = _a, {
    title = "Shifts List",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes80 ? sizes80[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(
    Svgr80,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes80.medium,
      height: resolvedSize || sizes80.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveSignature.tsx
var import_jsx_runtime82 = require("react/jsx-runtime");
var Svgr81 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime82.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime82.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.956 2.756a1.75 1.75 0 0 1 2.485-.01l1.812 1.811a1.75 1.75 0 0 1-.01 2.485l-6.6 6.492a.75.75 0 0 1-.526.216H11a.75.75 0 0 1-.75-.75V9.883a.75.75 0 0 1 .215-.526l6.491-6.601Zm1.425 1.05a.25.25 0 0 0-.355.001L11.75 10.19v2.06h2.06l6.38-6.277a.25.25 0 0 0 .003-.355L18.38 3.806Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime82.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 15A2.75 2.75 0 0 1 5 12.25h2a.75.75 0 0 1 0 1.5H5a1.25 1.25 0 1 0 0 2.5h14a2.75 2.75 0 1 1 0 5.5h-4a.75.75 0 0 1 0-1.5h4a1.25 1.25 0 1 0 0-2.5H5A2.75 2.75 0 0 1 2.25 15Z", clipRule: "evenodd" })
  ] }));
};
var sizes81 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveSignature(_a) {
  var _b = _a, {
    title = "Signature",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes81 ? sizes81[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
    Svgr81,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes81.medium,
      height: resolvedSize || sizes81.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveStartDate.tsx
var import_jsx_runtime83 = require("react/jsx-runtime");
var Svgr82 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime83.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8 1.25a.75.75 0 0 1 .75.75v1.25h6.5V2a.75.75 0 0 1 1.5 0v1.25H19A2.75 2.75 0 0 1 21.75 6v13A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V6A2.75 2.75 0 0 1 5 3.25h2.25V2A.75.75 0 0 1 8 1.25Zm-.75 3.5H5c-.69 0-1.25.56-1.25 1.25v2.25h16.5V6c0-.69-.56-1.25-1.25-1.25h-2.25V6a.75.75 0 0 1-1.5 0V4.75h-6.5V6a.75.75 0 0 1-1.5 0V4.75Zm13 5H3.75V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9.75Zm-7.886 2.065a.75.75 0 0 1 .446.685v4.25h.59a.75.75 0 0 1 0 1.5h-2.68a.75.75 0 0 1 0-1.5h.59v-2.56l-.207.186a.75.75 0 0 1-1.006-1.112l1.46-1.32a.75.75 0 0 1 .807-.13Z", clipRule: "evenodd" })
  ] }));
};
var sizes82 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveStartDate(_a) {
  var _b = _a, {
    title = "Start Date",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes82 ? sizes82[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
    Svgr82,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes82.medium,
      height: resolvedSize || sizes82.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveSupport.tsx
var import_jsx_runtime84 = require("react/jsx-runtime");
var Svgr83 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M18.154 10.608a.255.255 0 0 0-.257.253v5.063c0 .14.116.253.257.253h1.026c.708 0 1.282-.566 1.282-1.266v-3.038c0-.7-.574-1.265-1.282-1.265h-1.026Zm-1.795.253c0-.979.804-1.772 1.795-1.772h1.026c1.558 0 2.82 1.246 2.82 2.784v3.038c0 1.539-1.262 2.785-2.82 2.785h-1.026c-.991 0-1.795-.794-1.795-1.772v-5.063ZM4.82 10.608c-.708 0-1.282.566-1.282 1.265v3.038c0 .7.574 1.266 1.283 1.266h1.025a.255.255 0 0 0 .257-.253v-5.063a.255.255 0 0 0-.257-.253H4.821ZM2 11.873C2 10.335 3.262 9.09 4.82 9.09h1.026c.991 0 1.795.793 1.795 1.772v5.063c0 .979-.804 1.772-1.795 1.772H4.821C3.262 17.696 2 16.45 2 14.911v-3.038Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.564 9.342C4.564 5.287 7.894 2 12 2c4.107 0 7.436 3.287 7.436 7.342v.506c0 .42-.345.76-.77.76a.764.764 0 0 1-.769-.76v-.506c0-3.216-2.64-5.823-5.897-5.823S6.103 6.126 6.103 9.342v.506c0 .42-.345.76-.77.76a.764.764 0 0 1-.769-.76v-.506ZM11.359 19.468a.51.51 0 0 0-.513.507c0 .279.23.506.513.506h1.282a.51.51 0 0 0 .513-.506.51.51 0 0 0-.513-.507h-1.282Zm3.333.507c0-1.119-.918-2.026-2.051-2.026h-1.282c-1.133 0-2.051.907-2.051 2.026 0 1.118.918 2.025 2.051 2.025h1.282c1.133 0 2.051-.907 2.051-2.025Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime84.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M18.154 16.177c.425 0 .77.34.77.76v1.012c0 1.539-1.263 2.785-2.821 2.785h-2.18a.764.764 0 0 1-.77-.76c0-.419.345-.759.77-.759h2.18c.708 0 1.282-.566 1.282-1.266v-1.012c0-.42.344-.76.769-.76Z", clipRule: "evenodd" })
  ] }));
};
var sizes83 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveSupport(_a) {
  var _b = _a, {
    title = "Support",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes83 ? sizes83[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(
    Svgr83,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes83.medium,
      height: resolvedSize || sizes83.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveTechnology.tsx
var import_jsx_runtime85 = require("react/jsx-runtime");
var Svgr84 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.615 11.512c0-.404.345-.732.77-.732h3.076c.425 0 .77.328.77.732 0 .404-.345.732-.77.732H7.385c-.425 0-.77-.328-.77-.732Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.82 3.463c-.708 0-1.282.546-1.282 1.22v13.659c0 .673.574 1.219 1.283 1.219h3.076c.425 0 .77.328.77.732 0 .404-.345.731-.77.731H4.82c-1.557 0-2.82-1.2-2.82-2.683V4.684C2 3.2 3.263 2 4.82 2h8.206c1.557 0 2.82 1.201 2.82 2.683v1.951c0 .404-.344.732-.77.732-.424 0-.768-.328-.768-.732V4.683c0-.674-.574-1.22-1.282-1.22H4.82Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M13.282 12c0-1.212 1.033-2.195 2.308-2.195 1.274 0 2.307.983 2.307 2.195v1.574l1.736.269c1.497.232 2.533 1.549 2.345 2.98l-.371 2.827C21.43 20.992 20.23 22 18.808 22h-3.893c-.943 0-1.824-.448-2.347-1.195l-1.99-2.84a2.035 2.035 0 0 1 .277-2.664c.417-.396.981-.618 1.57-.618.297 0 .588.057.857.164V12Zm-.375 4.336a.7.7 0 0 0-.482-.19.7.7 0 0 0-.482.19.625.625 0 0 0-.085.818m0 0 1.99 2.84a1.3 1.3 0 0 0 1.067.543h3.893c.646 0 1.192-.458 1.272-1.069l.371-2.826c.086-.65-.385-1.25-1.065-1.355l-2.382-.37a.744.744 0 0 1-.645-.721V12c0-.404-.345-.732-.77-.732-.424 0-.769.328-.769.732v4.39a.732.732 0 0 1-.474.676.798.798 0 0 1-.839-.159l-.6-.57M6.359 2c.425 0 .77.328.77.732v1.707h3.589V2.732c0-.404.344-.732.77-.732.424 0 .768.328.768.732v1.95c0 .674-.574 1.22-1.282 1.22H6.872c-.708 0-1.282-.546-1.282-1.22v-1.95c0-.404.344-.732.769-.732ZM8.923 9.317c.425 0 .77.328.77.732v2.927c0 .404-.345.731-.77.731-.425 0-.77-.327-.77-.731v-2.927c0-.404.345-.732.77-.732Z", clipRule: "evenodd" })
  ] }));
};
var sizes84 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveTechnology(_a) {
  var _b = _a, {
    title = "Technology",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes84 ? sizes84[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
    Svgr84,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes84.medium,
      height: resolvedSize || sizes84.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveToday.tsx
var import_jsx_runtime86 = require("react/jsx-runtime");
var Svgr85 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime86.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime86.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime86.jsx)("path", { fill: "currentcolor", d: "M19.001 3.8h-2.2V2.5c0-.4-.3-.8-.8-.8s-.8.3-.8.8v1.2h-6.4V2.5c0-.4-.3-.8-.8-.8s-.8.4-.8.8v1.2h-2.2c-1.5.1-2.8 1.3-2.8 2.8v13c0 1.5 1.2 2.8 2.8 2.8h14c1.5 0 2.8-1.2 2.8-2.8v-13c0-1.5-1.3-2.7-2.8-2.7Zm-14 1.4h2.2v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.2h6.5v1.2c0 .4.3.8.8.8s.8-.3.8-.8V5.2h2.1c.7 0 1.2.6 1.2 1.2v2.2h-16.4V6.5c0-.7.5-1.3 1.2-1.3Zm14 15.6h-14c-.7 0-1.2-.6-1.2-1.2v-9.2h16.5v9.2c-.1.6-.6 1.2-1.3 1.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime86.jsx)("path", { fill: "currentcolor", d: "M12.001 12.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM17.001 12.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM7.001 16.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1ZM12.001 16.5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes85 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveToday(_a) {
  var _b = _a, {
    title = "Today",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes85 ? sizes85[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(
    Svgr85,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes85.medium,
      height: resolvedSize || sizes85.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveTopMatches.tsx
var import_jsx_runtime87 = require("react/jsx-runtime");
var Svgr86 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime87.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime87.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.3 3.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM2.05 12c0-5.66 4.589-10.25 10.25-10.25 5.66 0 10.25 4.59 10.25 10.25S17.96 22.25 12.3 22.25C6.639 22.25 2.05 17.66 2.05 12Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime87.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.28 6.89a.61.61 0 0 1 .597.41l1.002 2.907c.014.04.047.093.095.133.044.035.085.05.126.05h3.1a.611.611 0 0 1 .357 1.106l-2.5 1.8a.151.151 0 0 0-.073.096.208.208 0 0 0-.005.113l.998 2.896a.61.61 0 0 1-.934.695l-2.489-1.792a.282.282 0 0 0-.154-.043.581.581 0 0 1-.043.035l-2.5 1.8a.61.61 0 0 1-.935-.695l.999-2.896a.207.207 0 0 0-.005-.113.15.15 0 0 0-.073-.096l-2.5-1.8a.61.61 0 0 1 .357-1.107h2.8c.11 0 .234-.03.326-.078.06-.032.079-.056.083-.064l.003-.01.799-2.9a.61.61 0 0 1 .57-.448Zm-1.372 3.362v-.002.002Zm1.457-.69-.274.994c-.107.417-.41.683-.69.833a1.952 1.952 0 0 1-.9.222h-.907l.955.688c.548.372.706 1.068.53 1.594l-.002.006-.372 1.08.906-.652c.239-.213.54-.288.801-.288a1.503 1.503 0 0 1 .845.265l.938.676-.375-1.087c-.175-.526-.017-1.222.53-1.594l.956-.688H14.1c-.72 0-1.214-.527-1.378-1.014l-.357-1.034Z", clipRule: "evenodd" })
  ] }));
};
var sizes86 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveTopMatches(_a) {
  var _b = _a, {
    title = "Top Matches",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes86 ? sizes86[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
    Svgr86,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes86.medium,
      height: resolvedSize || sizes86.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveUnworkedType.tsx
var import_jsx_runtime88 = require("react/jsx-runtime");
var Svgr87 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15 2.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7 2.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 7 2.25ZM2.25 9A.75.75 0 0 1 3 8.25h16a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 9Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 7A3.75 3.75 0 0 1 6 3.25h10A3.75 3.75 0 0 1 19.75 7v3a.75.75 0 0 1-1.5 0V7A2.25 2.25 0 0 0 16 4.75H6A2.25 2.25 0 0 0 3.75 7v9A2.25 2.25 0 0 0 6 18.25h4a.75.75 0 0 1 0 1.5H6A3.75 3.75 0 0 1 2.25 16V7Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.503 13.75c-2.019-.002-3.753 1.73-3.753 3.75a3.75 3.75 0 1 0 3.753-3.75Zm.002-1.5c-2.85-.003-5.255 2.402-5.255 5.25a5.25 5.25 0 1 0 5.255-5.25Zm0 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M19.03 15.97a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l2-2a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime88.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.97 15.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes87 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveUnworkedType(_a) {
  var _b = _a, {
    title = "Unworked",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes87 ? sizes87[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
    Svgr87,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes87.medium,
      height: resolvedSize || sizes87.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveWeather.tsx
var import_jsx_runtime89 = require("react/jsx-runtime");
var Svgr88 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime89.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime89.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14.175 12.194c-1.845 0-3.386 1.295-3.654 2.98a.731.731 0 0 1-.406.537.802.802 0 0 1-.696.004 2.572 2.572 0 0 0-1.111-.232c-1.463 0-2.654 1.131-2.654 2.53 0 1.398 1.19 2.53 2.654 2.53h9.954c1.215 0 2.205-.94 2.205-2.102 0-1.092-.84-1.964-1.915-2.094a.743.743 0 0 1-.67-.704c-.051-1.91-1.697-3.449-3.707-3.449Zm-4.956 1.923c.7-1.964 2.659-3.38 4.956-3.38 2.644 0 4.828 1.874 5.19 4.292C20.89 15.473 22 16.823 22 18.44 22 20.404 20.327 22 18.262 22H8.308c-2.313 0-4.187-1.788-4.187-3.986 0-2.2 1.874-3.988 4.187-3.988.31 0 .615.03.911.091ZM10.94 2c.423 0 .766.326.766.728v.777c0 .402-.343.728-.766.728s-.766-.326-.766-.728v-.777c0-.402.343-.728.766-.728ZM17.26 4.48a.703.703 0 0 1 .01 1.03l-.573.554a.795.795 0 0 1-1.083.009.703.703 0 0 1-.01-1.03l.572-.553a.795.795 0 0 1 1.084-.01ZM2 10.495c0-.402.343-.728.766-.728h.818c.423 0 .766.326.766.728 0 .402-.343.728-.766.728h-.818c-.423 0-.766-.326-.766-.728ZM4.63 4.48a.795.795 0 0 1 1.084.01l.572.553a.703.703 0 0 1-.01 1.03.795.795 0 0 1-1.083-.01L4.62 5.51a.703.703 0 0 1 .01-1.03ZM6.09 10.495c0-2.547 2.174-4.611 4.854-4.611 1.34 0 2.555.517 3.432 1.35.3.285.3.746 0 1.03a.795.795 0 0 1-1.083 0 3.397 3.397 0 0 0-2.349-.924c-1.834 0-3.32 1.413-3.32 3.155 0 .402-.344.728-.767.728-.423 0-.766-.326-.766-.728Z", clipRule: "evenodd" })
  ] }));
};
var sizes88 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveWeather(_a) {
  var _b = _a, {
    title = "Weather",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes88 ? sizes88[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
    Svgr88,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes88.medium,
      height: resolvedSize || sizes88.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveWorkExperience.tsx
var import_jsx_runtime90 = require("react/jsx-runtime");
var Svgr89 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime90.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime90.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.997 7.748c-.69 0-1.25.56-1.25 1.25v8.004a3.252 3.252 0 0 0 3.25 3.252h10.005a3.252 3.252 0 0 0 3.252-3.252V8.999c0-.691-.56-1.251-1.251-1.251H4.997Zm-2.75 1.25a2.75 2.75 0 0 1 2.75-2.75h14.006a2.75 2.75 0 0 1 2.75 2.75v8.004a4.752 4.752 0 0 1-4.751 4.752H6.998a4.752 4.752 0 0 1-4.752-4.752V8.999Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime90.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.999 3.746c-.69 0-1.25.56-1.25 1.25v2.002a.75.75 0 0 1-1.5 0V4.997a2.75 2.75 0 0 1 2.75-2.75h4.002a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25H9.999ZM9.249 11.5c0-.69.56-1.25 1.25-1.25h3.002c.69 0 1.25.56 1.25 1.25v2c0 .691-.56 1.25-1.25 1.25h-3.002c-.69 0-1.25-.559-1.25-1.25v-2Zm1.5.25v1.5h2.502v-1.5h-2.502Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime90.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.754 8.999a4.251 4.251 0 0 1-4.252 4.251h-3.501a.75.75 0 0 1 0-1.5h3.501A2.752 2.752 0 0 0 20.254 9h1.5ZM3.746 8.999a2.751 2.751 0 0 0 2.752 2.751h3.501a.75.75 0 1 1 0 1.5H6.498A4.252 4.252 0 0 1 2.246 9h1.5Z", clipRule: "evenodd" })
  ] }));
};
var sizes89 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveWorkExperience(_a) {
  var _b = _a, {
    title = "Work Experience",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes89 ? sizes89[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
    Svgr89,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes89.medium,
      height: resolvedSize || sizes89.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconDescriptiveWorkType.tsx
var import_jsx_runtime91 = require("react/jsx-runtime");
var Svgr90 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime91.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.997 7.748c-.69 0-1.25.56-1.25 1.25v8.004a3.252 3.252 0 0 0 3.25 3.252h10.005a3.252 3.252 0 0 0 3.252-3.252V8.999c0-.691-.56-1.251-1.251-1.251H4.997Zm-2.75 1.25a2.75 2.75 0 0 1 2.75-2.75h14.006a2.75 2.75 0 0 1 2.75 2.75v8.004a4.752 4.752 0 0 1-4.751 4.752H6.998a4.752 4.752 0 0 1-4.752-4.752V8.999Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.999 3.746c-.69 0-1.25.56-1.25 1.25v2.002a.75.75 0 0 1-1.5 0V4.997a2.75 2.75 0 0 1 2.75-2.75h4.002a2.75 2.75 0 0 1 2.75 2.75v2a.75.75 0 0 1-1.5 0v-2c0-.69-.56-1.25-1.25-1.25H9.999ZM9.249 11.5c0-.69.56-1.25 1.25-1.25h3.002c.69 0 1.25.56 1.25 1.25v2c0 .691-.56 1.25-1.25 1.25h-3.002c-.69 0-1.25-.559-1.25-1.25v-2Zm1.5.25v1.5h2.502v-1.5h-2.502Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime91.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.754 8.999a4.251 4.251 0 0 1-4.252 4.251h-3.501a.75.75 0 0 1 0-1.5h3.501A2.752 2.752 0 0 0 20.254 9h1.5ZM3.746 8.999a2.751 2.751 0 0 0 2.752 2.751h3.501a.75.75 0 1 1 0 1.5H6.498A4.252 4.252 0 0 1 2.246 9h1.5Z", clipRule: "evenodd" })
  ] }));
};
var sizes90 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconDescriptiveWorkType(_a) {
  var _b = _a, {
    title = "Work Type",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes90 ? sizes90[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
    Svgr90,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes90.medium,
      height: resolvedSize || sizes90.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeature1stToApply.tsx
var import_jsx_runtime92 = require("react/jsx-runtime");
var Svgr91 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime92.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime92.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime92.jsx)("circle", { cx: 12, cy: 12, r: 10, stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25 }),
    /* @__PURE__ */ (0, import_jsx_runtime92.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25, d: "m10.241 10.244 1.758-1.762v7.04" })
  ] }));
};
var sizes91 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeature1stToApply(_a) {
  var _b = _a, {
    title = "1st to Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes91 ? sizes91[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(
    Svgr91,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes91.medium,
      height: resolvedSize || sizes91.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeature1stToApplyFilled.tsx
var import_jsx_runtime93 = require("react/jsx-runtime");
var Svgr92 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime93.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime93.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 2.5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19ZM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime93.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm.624-13.518a.625.625 0 0 0-1.068-.442L9.798 9.803a.625.625 0 1 0 .886.882l.69-.692v5.529a.625.625 0 0 0 1.25 0v-7.04Z", clipRule: "evenodd" })
  ] }));
};
var sizes92 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeature1stToApplyFilled(_a) {
  var _b = _a, {
    title = "1st to Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes92 ? sizes92[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
    Svgr92,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes92.medium,
      height: resolvedSize || sizes92.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureAutoOffer.tsx
var import_jsx_runtime94 = require("react/jsx-runtime");
var Svgr93 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.705 4.263a8.375 8.375 0 0 0-9.127 1.815.625.625 0 1 1-.884-.884 9.625 9.625 0 1 1 0 13.612.625.625 0 0 1 .884-.884 8.375 8.375 0 1 0 9.127-13.66Zm-7.19 5.626a2.125 2.125 0 0 1 2.035-1.514h5.448a2.125 2.125 0 0 1 2.035 2.736l-1.05 3.5a2.125 2.125 0 0 1-2.035 1.514H9.5a2.125 2.125 0 0 1-2.035-2.736l1.05-3.5Zm2.035-.264a.875.875 0 0 0-.838.624l-1.05 3.5a.875.875 0 0 0 .838 1.126h5.448a.875.875 0 0 0 .838-.624l1.05-3.5a.875.875 0 0 0-.838-1.126H10.55ZM3.5 8.377h3a.625.625 0 0 1 0 1.25h-3a.625.625 0 0 1 0-1.25Zm11.459 2.594a.625.625 0 0 1-.28.838l-2 1a.625.625 0 0 1-.721-.117l-1-1a.625.625 0 1 1 .883-.883l.682.68 1.597-.798a.625.625 0 0 1 .839.28ZM2.5 11.375h3a.625.625 0 1 1 0 1.25h-3a.625.625 0 0 1 0-1.25Zm.375 3.628c0-.345.28-.625.625-.625h2a.625.625 0 0 1 0 1.25h-2a.625.625 0 0 1-.625-.625Z", clipRule: "evenodd" })
  ] }));
};
var sizes93 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureAutoOffer(_a) {
  var _b = _a, {
    title = "Auto-Offer",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes93 ? sizes93[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
    Svgr93,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes93.medium,
      height: resolvedSize || sizes93.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureAutoOfferFilled.tsx
var import_jsx_runtime95 = require("react/jsx-runtime");
var Svgr94 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime95.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime95.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)("path", { fill: "currentcolor", d: "M15.205 4.263a8.375 8.375 0 0 0-9.127 1.815.625.625 0 1 1-.884-.884 9.625 9.625 0 1 1 0 13.612.625.625 0 0 1 .884-.884 8.375 8.375 0 1 0 9.127-13.66Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)("path", { fill: "currentcolor", d: "M6.5 9.002a.5.5 0 0 1-.5.5H3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5ZM3 14.503a.5.5 0 0 0 0 1h2a.5.5 0 1 0 0-1H3ZM5.5 12a.5.5 0 0 1-.5.5H2a.5.5 0 1 1 0-1h3a.5.5 0 0 1 .5.5Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.498 8.502h-5.447A1.5 1.5 0 0 0 8.614 9.57l-1.05 3.5A1.5 1.5 0 0 0 9 15h5.448a1.5 1.5 0 0 0 1.437-1.068l1.05-3.5a1.5 1.5 0 0 0-1.437-1.931Zm-1.413 2.082a.375.375 0 0 1-.168.503l-2 1a.375.375 0 0 1-.433-.07l-1-1a.375.375 0 1 1 .53-.53l.81.808 1.758-.879a.375.375 0 0 1 .503.168Z", clipRule: "evenodd" })
  ] }));
};
var sizes94 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureAutoOfferFilled(_a) {
  var _b = _a, {
    title = "Auto-Offer",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes94 ? sizes94[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
    Svgr94,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes94.medium,
      height: resolvedSize || sizes94.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureBoostedCampaign.tsx
var import_jsx_runtime96 = require("react/jsx-runtime");
var Svgr95 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m12.94 11.06-7.07 7.07M6.633 12.999l-3.463-.818a.5.5 0 0 1-.239-.84l2.754-2.754a1 1 0 0 1 .699-.293l3.105-.027" }),
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m19.88 8.975.807-3.888a1.5 1.5 0 0 0-1.774-1.774l-3.888.808a5.993 5.993 0 0 0-3.02 1.632l-3.19 3.189a8.006 8.006 0 0 0-2.26 4.498l-.01.073a3.48 3.48 0 0 0 .981 2.961v0a3.476 3.476 0 0 0 2.961.981l.073-.011a8 8 0 0 0 4.498-2.259l3.19-3.189a5.993 5.993 0 0 0 1.631-3.021v0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M13.4 4.714a22.415 22.415 0 0 1 5.886 5.886M11 17.367l.818 3.463a.5.5 0 0 0 .84.239l2.754-2.754a1 1 0 0 0 .293-.699l.027-3.105" })
  ] }));
};
var sizes95 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureBoostedCampaign(_a) {
  var _b = _a, {
    title = "Boosted Campaign",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes95 ? sizes95[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
    Svgr95,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes95.medium,
      height: resolvedSize || sizes95.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureCareerStarter.tsx
var import_jsx_runtime97 = require("react/jsx-runtime");
var Svgr96 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime97.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25, d: "M4 19.658V5.342c0-.84.453-1.617 1.187-2.034a2.367 2.367 0 0 1 2.367.018l12.18 7.16A2.339 2.339 0 0 1 20.89 12.5c0 .827-.439 1.592-1.154 2.014l-12.181 7.16a2.367 2.367 0 0 1-2.367.018A2.338 2.338 0 0 1 4 19.658Z", clipRule: "evenodd" })
  ] }));
};
var sizes96 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureCareerStarter(_a) {
  var _b = _a, {
    title = "Career Starter",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes96 ? sizes96[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
    Svgr96,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes96.medium,
      height: resolvedSize || sizes96.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureCareerStarterFilled.tsx
var import_jsx_runtime98 = require("react/jsx-runtime");
var Svgr97 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime98.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime98.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 0.5, d: "M4 19.658V5.342c0-.84.453-1.617 1.187-2.034a2.367 2.367 0 0 1 2.367.018l12.18 7.16A2.339 2.339 0 0 1 20.89 12.5c0 .827-.439 1.592-1.154 2.014l-12.181 7.16a2.367 2.367 0 0 1-2.367.018A2.338 2.338 0 0 1 4 19.658Z", clipRule: "evenodd" })
  ] }));
};
var sizes97 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureCareerStarterFilled(_a) {
  var _b = _a, {
    title = "Career Starter",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes97 ? sizes97[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(
    Svgr97,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes97.medium,
      height: resolvedSize || sizes97.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureClosingSoon.tsx
var import_jsx_runtime99 = require("react/jsx-runtime");
var Svgr98 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime99.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("path", { fill: "currentcolor", d: "M6.924 3.719A.75.75 0 0 0 5.96 2.57L2.554 5.431a.75.75 0 1 0 .965 1.149l3.405-2.861ZM11.993 8.104a.75.75 0 0 1 .75.75V13.3a.75.75 0 0 1-1.5 0V8.852a.75.75 0 0 1 .75-.75ZM11.992 17.532a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.24 12.854a8.752 8.752 0 1 1 17.504 0 8.752 8.752 0 0 1-17.503 0Zm8.753-7.251a7.252 7.252 0 1 0 0 14.503 7.252 7.252 0 0 0 0-14.504Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime99.jsx)("path", { fill: "currentcolor", d: "M16.977 2.672a.75.75 0 0 1 1.057-.092l3.412 2.866a.75.75 0 0 1-.965 1.149L17.07 3.729a.75.75 0 0 1-.091-1.057Z" })
  ] }));
};
var sizes98 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureClosingSoon(_a) {
  var _b = _a, {
    title = "Closing Soon",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes98 ? sizes98[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
    Svgr98,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes98.medium,
      height: resolvedSize || sizes98.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureClosingSoonFilled.tsx
var import_jsx_runtime100 = require("react/jsx-runtime");
var Svgr99 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime100.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("path", { fill: "currentcolor", d: "M7.016 3.037a.75.75 0 0 1-.092 1.057L3.52 6.954a.75.75 0 1 1-.965-1.148L5.96 2.945a.75.75 0 0 1 1.056.092ZM16.977 3.047a.75.75 0 0 1 1.057-.092l3.412 2.866a.75.75 0 0 1-.965 1.149L17.07 4.104a.75.75 0 0 1-.091-1.057Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime100.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M19.994 13.23a8.002 8.002 0 1 0-16.002 0 8.002 8.002 0 0 0 16.002 0Zm-7.251-4.002a.75.75 0 0 0-1.5 0v4.446a.75.75 0 1 0 1.5 0V9.228Zm.149 7.78a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes99 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureClosingSoonFilled(_a) {
  var _b = _a, {
    title = "Closing Soon",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes99 ? sizes99[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
    Svgr99,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes99.medium,
      height: resolvedSize || sizes99.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureEasyApply.tsx
var import_jsx_runtime101 = require("react/jsx-runtime");
var Svgr100 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime101.jsx)("path", { stroke: "currentcolor", strokeWidth: 1.25, d: "m12.293 8.056-.267.819h5.294c.08 0 .174.048.235.16.06.109.05.21.005.28l-.01.016-.01.017-6.725 11.875-.01.017-.008.017a.177.177 0 0 1-.075.081.337.337 0 0 1-.166.037c-.139 0-.308-.145-.267-.38l1.755-7.605.177-.765H6.926c-.196 0-.325-.137-.297-.349L7.85 2.901l.002-.015.002-.015c.01-.116.132-.246.294-.246h5.502c.13 0 .328.164.276.42l-1.634 5.011Z" })
  ] }));
};
var sizes100 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureEasyApply(_a) {
  var _b = _a, {
    title = "Easy Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes100 ? sizes100[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    Svgr100,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes100.medium,
      height: resolvedSize || sizes100.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureEasyApplyFilled.tsx
var import_jsx_runtime102 = require("react/jsx-runtime");
var Svgr101 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("path", { fill: "currentcolor", d: "M17.32 8.25h-4.433l1.643-5.04c.153-.624-.306-1.21-.879-1.21H8.15c-.459 0-.879.352-.917.82l-1.223 9.375c-.076.586.344 1.055.917 1.055h4.509l-1.758 7.617c-.114.586.306 1.133.88 1.133.343 0 .649-.156.801-.469l6.726-11.875c.382-.586-.077-1.406-.764-1.406Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m11.165 9.5 2.038-6.25H8.436L7.295 12h5.711l-1.59 6.894 5.32-9.394h-5.571Zm3.365-6.29-1.643 5.04h4.433c.687 0 1.146.82.764 1.406l-6.726 11.875c-.152.313-.458.469-.802.469-.573 0-.993-.547-.879-1.133l1.758-7.617H6.926c-.573 0-.993-.469-.917-1.055L7.232 2.82c.038-.468.458-.82.917-.82h5.502c.573 0 1.032.586.88 1.21Z", clipRule: "evenodd" })
  ] }));
};
var sizes101 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureEasyApplyFilled(_a) {
  var _b = _a, {
    title = "Easy Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes101 ? sizes101[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
    Svgr101,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes101.medium,
      height: resolvedSize || sizes101.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureExclusive.tsx
var import_jsx_runtime103 = require("react/jsx-runtime");
var Svgr102 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime103.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime103.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M16.824 15.278c-.105-.439 0-.987.42-1.207l4.299-3.292c.42-.33.524-.768.42-1.207-.106-.439-.525-.768-1.05-.768H15.67c-.42 0-.839-.33-1.048-.768l-1.573-5.268C12.944 2.33 12.524 2 12 2c-.42 0-.839.33-1.049.768L9.378 8.036c-.104.439-.524.768-1.048.768H3.086c-.419 0-.838.33-1.048.768-.105.439 0 .988.42 1.207l4.299 3.292c.42.33.524.768.42 1.207l-1.679 5.268c-.104.439 0 .988.42 1.207.21.11.42.22.629.22.21 0 .42-.11.63-.22l4.299-3.292c.42-.33.839-.33 1.258 0l4.3 3.292c.419.33.838.33 1.258 0 .42-.33.524-.768.42-1.207l-1.888-5.268Zm.51 5.131L13.5 17.472c-.368-.287-.84-.508-1.394-.508-.555 0-1.026.221-1.394.508l-3.864 2.959 1.534-4.817.011-.045c.206-.86-.019-1.818-.863-2.481l-.006-.005-3.957-3.03H8.33c1.032 0 1.987-.655 2.254-1.686L12 3.625l1.452 4.862.042.088c.345.723 1.129 1.479 2.176 1.479h4.764l-3.885 2.975c-.502.305-.781.775-.91 1.206a2.602 2.602 0 0 0-.031 1.334l.016.067 1.71 4.773Z", clipRule: "evenodd" })
  ] }));
};
var sizes102 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureExclusive(_a) {
  var _b = _a, {
    title = "Exclusive",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes102 ? sizes102[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(
    Svgr102,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes102.medium,
      height: resolvedSize || sizes102.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureExclusiveFilled.tsx
var import_jsx_runtime104 = require("react/jsx-runtime");
var Svgr103 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime104.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime104.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime104.jsx)("path", { fill: "currentcolor", d: "M21.543 10.78c.42-.33.524-.769.42-1.208-.106-.439-.525-.768-1.05-.768H15.67c-.42 0-.839-.33-1.048-.768l-1.573-5.268C12.944 2.33 12.524 2 12 2c-.42 0-.839.33-1.049.768L9.378 8.036c-.104.439-.524.768-1.048.768H3.086c-.419 0-.838.33-1.048.768-.105.439 0 .988.42 1.207l4.299 3.292c.42.33.524.768.42 1.207l-1.679 5.268c-.104.439 0 .988.42 1.207.21.11.42.22.629.22.21 0 .42-.11.63-.22l4.299-3.292c.42-.33.839-.33 1.258 0l4.3 3.292c.419.33.838.33 1.258 0 .42-.33.524-.768.42-1.207l-1.888-5.268c-.105-.439 0-.987.42-1.207l4.299-3.292Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime104.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m13.686 8.396-1.604-5.368-.002-.01a.126.126 0 0 0-.055-.017.479.479 0 0 0-.144.147L10.343 8.3c-.234.913-1.082 1.504-2.013 1.504H3.114A.447.447 0 0 0 3 9.906a.34.34 0 0 0 .002.031l4.372 3.348c.76.596.96 1.45.775 2.226l-.009.036-1.674 5.256a.408.408 0 0 0-.003.106l.053.027.031.015.032-.015.058-.03 4.227-3.236c.336-.263.755-.456 1.24-.456.487 0 .906.194 1.242.456l4.305 3.296.012.01.011-.01a.298.298 0 0 0 .06-.059.07.07 0 0 0 .011-.02.161.161 0 0 0 .001-.07l-1.882-5.253-.013-.053a2.35 2.35 0 0 1 .028-1.204c.116-.39.365-.805.81-1.071l4.24-3.246a.296.296 0 0 0 .056-.057.07.07 0 0 0 .011-.02c.002-.004.01-.03-.002-.09a.148.148 0 0 0-.08-.02H15.67c-.921 0-1.632-.67-1.95-1.336l-.034-.07Zm7.857 2.383-4.3 3.292c-.42.22-.524.768-.42 1.207l1.888 5.268c.105.439 0 .878-.42 1.207-.419.33-.838.33-1.258 0l-4.299-3.292c-.42-.33-.839-.33-1.258 0l-4.3 3.292c-.21.11-.42.22-.629.22-.21 0-.42-.11-.63-.22-.419-.22-.523-.768-.419-1.207l1.678-5.268c.105-.439 0-.878-.42-1.207L2.458 10.78c-.42-.22-.524-.768-.42-1.207.21-.439.63-.768 1.05-.768H8.33c.524 0 .944-.33 1.048-.768l1.573-5.268C11.161 2.33 11.581 2 12 2c.524 0 .944.33 1.049.768l1.573 5.268c.21.439.629.768 1.048.768h5.243c.525 0 .944.33 1.05.768.104.439 0 .878-.42 1.207ZM6.476 20.98h.002-.002Z", clipRule: "evenodd" })
  ] }));
};
var sizes103 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureExclusiveFilled(_a) {
  var _b = _a, {
    title = "Exclusive",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes103 ? sizes103[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(
    Svgr103,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes103.medium,
      height: resolvedSize || sizes103.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureLowCOLI.tsx
var import_jsx_runtime105 = require("react/jsx-runtime");
var Svgr104 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime105.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime105.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8.486 3.608a5.625 5.625 0 0 1 7.028 0l4.375 3.5a4.625 4.625 0 0 1 1.736 3.611V17A4.625 4.625 0 0 1 17 21.625H7A4.625 4.625 0 0 1 2.375 17v-6.28c0-1.406.639-2.734 1.736-3.612l4.375-3.5Zm6.247.976a4.375 4.375 0 0 0-5.466 0l-4.375 3.5c-.801.64-1.267 1.61-1.267 2.635V17A3.375 3.375 0 0 0 7 20.375h10A3.375 3.375 0 0 0 20.375 17v-6.28a3.375 3.375 0 0 0-1.267-2.636l-4.375-3.5Zm-2.734 3.79c.346 0 .625.28.625.624v.228c.86.17 1.592.773 1.91 1.623a.625.625 0 1 1-1.17.438 1.325 1.325 0 0 0-1.365-.856.627.627 0 0 1-.09-.006 1.214 1.214 0 0 0-1.283 1.03.81.81 0 0 0 .65.757l1.694.339a2.06 2.06 0 0 1 1.654 2.066 2.465 2.465 0 0 1-2 2.17v.219a.625.625 0 1 1-1.25 0v-.233a2.578 2.578 0 0 1-1.909-1.624.625.625 0 0 1 1.171-.438c.205.546.743.896 1.325.86a.618.618 0 0 1 .098 0 1.214 1.214 0 0 0 1.316-1.032.81.81 0 0 0-.65-.762l-1.694-.339a2.06 2.06 0 0 1-1.656-2.02m0 0c-.004.03 0-.04 0-.008v.008Zm0 0c.141-1.081.975-2.014 2-2.205v-.215c0-.345.28-.625.624-.625", clipRule: "evenodd" })
  ] }));
};
var sizes104 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureLowCOLI(_a) {
  var _b = _a, {
    title = "Low COLI",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes104 ? sizes104[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
    Svgr104,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes104.medium,
      height: resolvedSize || sizes104.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureLowCOLIFilled.tsx
var import_jsx_runtime106 = require("react/jsx-runtime");
var Svgr105 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime106.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime106.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21 10.72V17a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4v-6.28a4 4 0 0 1 1.501-3.124l4.375-3.5a5 5 0 0 1 6.248 0l4.375 3.5A4 4 0 0 1 21 10.719Zm-8.5-1.722a.5.5 0 1 0-1 0v.322a2.34 2.34 0 0 0-2 2.098c0 .922.652 1.716 1.556 1.897l1.693.339c.429.086.74.457.751.892a1.34 1.34 0 0 1-1.425 1.152.5.5 0 0 0-.106-.004 1.45 1.45 0 0 1-1.45-.94.5.5 0 1 0-.936.35 2.45 2.45 0 0 0 1.916 1.564v.338a.5.5 0 0 0 1 0v-.326a2.34 2.34 0 0 0 2-2.075l.002-.034c0-.923-.652-1.717-1.556-1.898l-1.693-.338a.935.935 0 0 1-.751-.886 1.339 1.339 0 0 1 1.498-1.143 1.45 1.45 0 0 1 1.481.937.5.5 0 0 0 .937-.35A2.451 2.451 0 0 0 12.5 9.33v-.332Z", clipRule: "evenodd" })
  ] }));
};
var sizes105 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureLowCOLIFilled(_a) {
  var _b = _a, {
    title = "Low COLI",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes105 ? sizes105[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
    Svgr105,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes105.medium,
      height: resolvedSize || sizes105.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureNearby.tsx
var import_jsx_runtime107 = require("react/jsx-runtime");
var Svgr106 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime107.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)("path", { fill: "currentcolor", d: "M12 21.8c-.4 0-.8-.1-1.1-.4-2.2-1.9-7.1-6.7-7.1-11.4 0-4.3 3.7-7.8 8.2-7.8 4.5 0 8.2 3.5 8.2 7.8 0 4.7-5 9.5-7.1 11.3-.3.3-.7.5-1.1.5Zm0-18.1c-3.7 0-6.8 2.8-6.8 6.2 0 4.1 5 8.8 6.6 10.2.1.1.2.1.3 0 1.5-1.3 6.6-6 6.6-10.2.1-3.3-3-6.2-6.7-6.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)("path", { fill: "currentcolor", d: "M12 13.6c-1.8 0-3.2-1.5-3.2-3.2 0-1.7 1.5-3.2 3.2-3.2 1.7 0 3.2 1.5 3.2 3.2 0 1.7-1.4 3.2-3.2 3.2Zm0-5c-1 0-1.7.8-1.7 1.7 0 1 .8 1.7 1.7 1.7 1 0 1.7-.8 1.7-1.7 0-.9-.7-1.7-1.7-1.7Z" })
  ] }));
};
var sizes106 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureNearby(_a) {
  var _b = _a, {
    title = "Nearby",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes106 ? sizes106[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
    Svgr106,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes106.medium,
      height: resolvedSize || sizes106.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureNearbyFilled.tsx
var import_jsx_runtime108 = require("react/jsx-runtime");
var Svgr107 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime108.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime108.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.2 21.6c-.4 0-.8-.1-1.1-.4C8.9 19.3 4 14.5 4 9.8 4 5.5 7.7 2 12.2 2c4.5 0 8.2 3.5 8.2 7.8 0 4.7-5 9.5-7.1 11.3-.3.3-.7.5-1.1.5ZM9 10.4c0 1.7 1.4 3.2 3.2 3.2 1.8 0 3.2-1.5 3.2-3.2 0-1.7-1.5-3.2-3.2-3.2-1.7 0-3.2 1.5-3.2 3.2Z", clipRule: "evenodd" })
  ] }));
};
var sizes107 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureNearbyFilled(_a) {
  var _b = _a, {
    title = "Nearby",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes107 ? sizes107[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
    Svgr107,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes107.medium,
      height: resolvedSize || sizes107.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureNew.tsx
var import_jsx_runtime109 = require("react/jsx-runtime");
var Svgr108 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime109.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime109.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime109.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.102 15.897c0-.368.298-.666.666-.666h4.464a.666.666 0 1 1 0 1.333H9.768a.666.666 0 0 1-.666-.667Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime109.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.999 8.66a3.57 3.57 0 0 0-2.063 6.483c.376.255.604.678.61 1.133v1.959a1.099 1.099 0 0 0 1.1 1.099h.706a1.099 1.099 0 0 0 1.1-1.1v-1.966c.008-.452.236-.871.61-1.125a3.57 3.57 0 0 0-2.063-6.482Zm-4.673 2.088a4.902 4.902 0 1 1 7.498 5.489l-.014.01a.059.059 0 0 0-.026.044v1.944a2.432 2.432 0 0 1-2.432 2.431h-.706a2.432 2.432 0 0 1-2.432-2.431v-1.942a.06.06 0 0 0-.026-.047l-.014-.01a4.902 4.902 0 0 1-1.848-5.488ZM2.667 12c0-.368.298-.666.666-.666H4a.666.666 0 0 1 0 1.332h-.667A.666.666 0 0 1 2.667 12ZM12 2.667c.368 0 .666.298.666.666V4a.666.666 0 0 1-1.332 0v-.667c0-.368.298-.666.666-.666ZM5.395 5.396c.26-.26.683-.26.943 0l.48.48a.666.666 0 1 1-.943.942l-.48-.48a.666.666 0 0 1 0-.942ZM19.334 12c0-.368.298-.666.666-.666h.667a.666.666 0 0 1 0 1.332H20a.666.666 0 0 1-.666-.666ZM18.604 5.396c.26.26.26.682 0 .942l-.48.48a.666.666 0 1 1-.942-.942l.48-.48c.26-.26.682-.26.942 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes108 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureNew(_a) {
  var _b = _a, {
    title = "New Feature",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes108 ? sizes108[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
    Svgr108,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes108.medium,
      height: resolvedSize || sizes108.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureNewItem.tsx
var import_jsx_runtime110 = require("react/jsx-runtime");
var Svgr109 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime110.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.64 1.453a.625.625 0 1 0-1.25 0c0 1.119-.307 2.104-.771 2.791-.467.691-1.045 1.026-1.602 1.026a.625.625 0 1 0 0 1.25c.557 0 1.135.335 1.602 1.026.464.687.771 1.672.771 2.79a.625.625 0 1 0 1.25 0c0-1.118.308-2.103.772-2.79.466-.691 1.044-1.026 1.602-1.026a.625.625 0 0 0 0-1.25c-.558 0-1.136-.335-1.602-1.026-.464-.687-.772-1.672-.772-2.79Zm-.985 3.49c.132-.195.253-.405.36-.627.108.222.229.432.36.628.248.367.544.692.881.95a4.064 4.064 0 0 0-.88.952 5.107 5.107 0 0 0-.36.628 5.106 5.106 0 0 0-.361-.628 4.063 4.063 0 0 0-.88-.951c.336-.259.632-.584.88-.951ZM15.986 3.054a.75.75 0 0 0-1.5 0c0 2.467-.642 4.664-1.639 6.222-1.002 1.567-2.296 2.4-3.609 2.4a.75.75 0 0 0 0 1.5c1.313 0 2.607.832 3.61 2.399.996 1.558 1.638 3.755 1.638 6.222a.75.75 0 0 0 1.5 0c0-2.467.641-4.665 1.638-6.223 1.003-1.566 2.296-2.399 3.61-2.399a.75.75 0 1 0 0-1.5c-1.314 0-2.607-.832-3.61-2.399-.997-1.558-1.638-3.755-1.638-6.222Zm-1.875 7.031c.448-.7.827-1.496 1.125-2.362a11.03 11.03 0 0 0 1.125 2.362c.625.976 1.403 1.792 2.298 2.34-.895.548-1.673 1.364-2.298 2.34a11.03 11.03 0 0 0-1.125 2.363 11.039 11.039 0 0 0-1.125-2.362c-.625-.976-1.404-1.793-2.299-2.34.896-.549 1.674-1.365 2.299-2.341Z", clipRule: "evenodd" })
  ] }));
};
var sizes109 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureNewItem(_a) {
  var _b = _a, {
    title = "New",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes109 ? sizes109[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
    Svgr109,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes109.medium,
      height: resolvedSize || sizes109.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureNewItemFilled.tsx
var import_jsx_runtime111 = require("react/jsx-runtime");
var Svgr110 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime111.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M5.015.828c.346 0 .625.28.625.625 0 1.119.308 2.104.772 2.791.466.691 1.044 1.026 1.602 1.026a.625.625 0 1 1 0 1.25c-.558 0-1.136.335-1.602 1.026-.464.687-.772 1.672-.772 2.79a.625.625 0 1 1-1.25 0c0-1.118-.307-2.103-.771-2.79-.467-.691-1.045-1.026-1.602-1.026a.625.625 0 0 1 0-1.25c.557 0 1.135-.335 1.602-1.026.464-.687.771-1.672.771-2.79 0-.346.28-.626.625-.626Zm10.22 1.476a.75.75 0 0 1 .75.75c0 2.467.642 4.664 1.64 6.222 1.002 1.567 2.295 2.4 3.608 2.4a.75.75 0 0 1 0 1.5c-1.313 0-2.606.832-3.609 2.399-.997 1.558-1.638 3.755-1.638 6.222a.75.75 0 0 1-1.5 0c0-2.467-.642-4.665-1.639-6.223-1.002-1.566-2.296-2.399-3.609-2.399a.75.75 0 1 1 0-1.5c1.313 0 2.607-.832 3.61-2.399.996-1.558 1.638-3.755 1.638-6.222a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes110 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureNewItemFilled(_a) {
  var _b = _a, {
    title = "New",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes110 ? sizes110[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
    Svgr110,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes110.medium,
      height: resolvedSize || sizes110.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureOneClick.tsx
var import_jsx_runtime112 = require("react/jsx-runtime");
var Svgr111 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8.832 8.5a2.126 2.126 0 0 1 4.25 0v3.97l3.583.597a2.626 2.626 0 0 1 2.174 2.915l-.543 4.343a2.626 2.626 0 0 1-2.605 2.3h-4.51a2.634 2.634 0 0 1-1.68-.607l-.001-.002-4.055-3.378a2.277 2.277 0 0 1 2.177-3.909l1.21.403V8.5Zm2.125-.876a.876.876 0 0 0-.875.875V16a.625.625 0 0 1-.823.593l-2.032-.677a1.028 1.028 0 0 0-.982 1.762l4.053 3.378c.25.207.563.32.883.32h4.51c.693 0 1.278-.517 1.365-1.206l.543-4.342a1.376 1.376 0 0 0-1.14-1.527l-4.105-.684a.625.625 0 0 1-.522-.617V8.5a.876.876 0 0 0-.875-.875ZM4.335 8c0-.345.28-.625.625-.625h1a.625.625 0 1 1 0 1.25h-1A.625.625 0 0 1 4.335 8ZM15.336 8c0-.345.28-.625.625-.625h1a.625.625 0 1 1 0 1.25h-1A.625.625 0 0 1 15.336 8ZM15.646 3.32a.625.625 0 0 1-.006.884l-.71.7a.625.625 0 0 1-.878-.89l.71-.7a.625.625 0 0 1 .884.007ZM6.265 3.32a.625.625 0 0 1 .884-.006l.71.7a.625.625 0 0 1-.877.89l-.71-.7a.625.625 0 0 1-.007-.883ZM10.96 1.375c.345 0 .625.28.625.625v1a.625.625 0 0 1-1.25 0V2c0-.345.28-.625.625-.625Z", clipRule: "evenodd" })
  ] }));
};
var sizes111 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureOneClick(_a) {
  var _b = _a, {
    title = "One-Click Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes111 ? sizes111[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
    Svgr111,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes111.medium,
      height: resolvedSize || sizes111.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureOneClickFilled.tsx
var import_jsx_runtime113 = require("react/jsx-runtime");
var Svgr112 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime113.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime113.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.457 13V8.5a1.5 1.5 0 0 0-3 0V16l-2.032-.678a1.652 1.652 0 0 0-1.58 2.835l4.055 3.38a2.01 2.01 0 0 0 1.28.462h4.51a2 2 0 0 0 1.986-1.752l.543-4.343a2 2 0 0 0-1.656-2.22l-4.106-.685ZM4.46 8a.5.5 0 0 1 .5-.5h1.5a.5.5 0 1 1 0 1h-1.5a.5.5 0 0 1-.5-.5ZM15.461 8a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1h-1.5a.5.5 0 0 1-.5-.5ZM16.444 3.548a.5.5 0 0 1-.242.664l-1.5.7a.5.5 0 0 1-.422-.906l1.5-.7a.5.5 0 0 1 .664.242ZM5.547 3.789a.5.5 0 0 1 .665-.242l1.5.7a.5.5 0 0 1-.423.906l-1.5-.7a.5.5 0 0 1-.242-.664ZM10.96 1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V2a.5.5 0 0 1 .5-.5Z", clipRule: "evenodd" })
  ] }));
};
var sizes112 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureOneClickFilled(_a) {
  var _b = _a, {
    title = "One-Click Apply",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes112 ? sizes112[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
    Svgr112,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes112.medium,
      height: resolvedSize || sizes112.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeaturePayRate.tsx
var import_jsx_runtime114 = require("react/jsx-runtime");
var Svgr113 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime114.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime114.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)("path", { fill: "currentcolor", d: "m20.3 4.7-.3-.1c-2.6-.5-5.3-.5-7.9.2l-.5.1c-2.4.6-4.9.7-7.3.2-.5-.1-1 0-1.5.4-.3.3-.6.8-.6 1.3v10.8c0 .8.6 1.6 1.4 1.7h.2c1.2.2 2.5.4 3.7.4 1.6 0 3.1-.2 4.6-.6l.2-.1c2.4-.6 4.9-.6 7.2-.2.5.1 1 0 1.5-.4.4-.3.6-.8.6-1.4V6.4c.2-.8-.4-1.6-1.3-1.7Zm-.1 12.5c0 .1-.1.2-.1.2s-.1.1-.2.1c-2.6-.5-5.3-.5-7.9.2l-.2.1c-2.5.6-5.2.7-7.7.2h-.2c-.1 0-.2-.1-.2-.2v-11c0-.1.1-.2.1-.2s.1-.1.2-.1h.1c2.5.6 5.3.5 7.8-.1l.5-.1c2.4-.6 4.9-.6 7.2-.2h.4c.1 0 .2.1.2.2v10.9Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.5 8a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0V8.75A.75.75 0 0 1 11.5 8ZM11.5 14.125a.75.75 0 0 1 .75.75v.875a.75.75 0 0 1-1.5 0v-.875a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.978 10.374a.478.478 0 0 0-.115.944l1.64.412a1.978 1.978 0 0 1-.482 3.898h-.958c-.763 0-1.377-.425-1.72-.986a.75.75 0 0 1 1.279-.783c.11.18.27.269.441.269h.959a.478.478 0 0 0 .115-.944l-1.64-.412a1.978 1.978 0 0 1 .48-3.898h.96c.762 0 1.375.421 1.72.983a.75.75 0 1 1-1.28.784.512.512 0 0 0-.44-.267h-.959Z", clipRule: "evenodd" })
  ] }));
};
var sizes113 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeaturePayRate(_a) {
  var _b = _a, {
    title = "Pay Rate",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes113 ? sizes113[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(
    Svgr113,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes113.medium,
      height: resolvedSize || sizes113.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeaturePayRateFilled.tsx
var import_jsx_runtime115 = require("react/jsx-runtime");
var Svgr114 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime115.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime115.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime115.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m20.3 4.7-.3-.1c-2.6-.5-5.3-.5-7.9.2l-.5.1c-2.4.6-4.9.7-7.3.2-.5-.1-1 0-1.5.4-.3.3-.6.8-.6 1.3v10.8c0 .8.6 1.6 1.4 1.7h.2c1.2.2 2.5.4 3.7.4 1.6 0 3.1-.2 4.6-.6l.2-.1c2.4-.6 4.9-.6 7.2-.2.5.1 1 0 1.5-.4.4-.3.6-.8.6-1.4V6.4c.2-.8-.4-1.6-1.3-1.7Zm-7.301 2.896a.5.5 0 1 0-1 0v.321A2.34 2.34 0 0 0 10 10.015c0 .922.651 1.717 1.556 1.898l1.692.338c.43.086.74.457.752.892a1.34 1.34 0 0 1-1.426 1.153.5.5 0 0 0-.106-.005 1.45 1.45 0 0 1-1.45-.94.5.5 0 1 0-.936.351 2.451 2.451 0 0 0 1.917 1.563v.338a.5.5 0 0 0 1 0v-.326a2.34 2.34 0 0 0 2-2.075 1.935 1.935 0 0 0-1.554-1.931l-1.693-.339a.935.935 0 0 1-.752-.885A1.339 1.339 0 0 1 12.5 8.904a1.45 1.45 0 0 1 1.481.936.5.5 0 1 0 .937-.35 2.451 2.451 0 0 0-1.918-1.563v-.33Z", clipRule: "evenodd" })
  ] }));
};
var sizes114 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeaturePayRateFilled(_a) {
  var _b = _a, {
    title = "Pay Rate",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes114 ? sizes114[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
    Svgr114,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes114.medium,
      height: resolvedSize || sizes114.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureQuickOffer.tsx
var import_jsx_runtime116 = require("react/jsx-runtime");
var Svgr115 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25, d: "m12.053 13.582-1.32 1.32 1.32 1.319" }),
    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25, d: "M7.778 11.255a5.529 5.529 0 0 1 3.958-1.366c2.478 0 4.486 1.135 4.486 2.536 0 1.4-2.008 2.536-4.486 2.536a7.795 7.795 0 0 1-.994-.067" }),
    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)("circle", { cx: 12, cy: 12, r: 9.5, stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25 })
  ] }));
};
var sizes115 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureQuickOffer(_a) {
  var _b = _a, {
    title = "Quick Offer Turn-Around",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes115 ? sizes115[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
    Svgr115,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes115.medium,
      height: resolvedSize || sizes115.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureQuickOfferFilled.tsx
var import_jsx_runtime117 = require("react/jsx-runtime");
var Svgr116 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime117.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime117.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.5 12a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0Zm-9.371.348a.5.5 0 0 1 0 .707l-.525.525c1.11-.022 2.087-.285 2.78-.677.74-.418 1.06-.917 1.06-1.358 0-.44-.32-.94-1.06-1.358-.723-.41-1.757-.678-2.926-.678A5.029 5.029 0 0 0 7.83 10.75.5.5 0 0 1 7.17 10a6.029 6.029 0 0 1 4.302-1.491c1.304.002 2.508.3 3.405.807.884.5 1.568 1.269 1.568 2.229 0 .96-.684 1.728-1.568 2.229-.84.474-1.95.766-3.158.803l.41.41a.5.5 0 1 1-.707.707l-1.32-1.32a.5.5 0 0 1 0-.706l1.32-1.32a.5.5 0 0 1 .707 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes116 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureQuickOfferFilled(_a) {
  var _b = _a, {
    title = "Quick Offer Turn-Around",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes116 ? sizes116[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
    Svgr116,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes116.medium,
      height: resolvedSize || sizes116.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureSocialProof.tsx
var import_jsx_runtime118 = require("react/jsx-runtime");
var Svgr117 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime118.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime118.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.561 2a2.683 2.683 0 0 0-2.683 2.683v3.902a4.634 4.634 0 0 0 9.268 0V4.683A2.683 2.683 0 0 0 13.463 2H9.561Zm0 1.463a1.22 1.22 0 0 0-1.22 1.22v1.22h6.342v-1.22a1.22 1.22 0 0 0-1.22-1.22H9.561Zm5.122 5.122v-1.22H8.34v1.22a3.17 3.17 0 0 0 6.342 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime118.jsx)("path", { fill: "currentcolor", d: "M17.863 17.873a.985.985 0 1 0 0-1.97.985.985 0 0 0 0 1.97Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime118.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.854 12.732a4.146 4.146 0 0 0-4.147 4.146c0 1.045.558 2.033 1.148 2.803.605.79 1.333 1.467 1.85 1.905l.012.01c.662.538 1.61.538 2.272 0l.012-.01c.517-.438 1.246-1.114 1.852-1.905.59-.77 1.147-1.758 1.147-2.803a4.146 4.146 0 0 0-4.146-4.146Zm0 1.463a2.683 2.683 0 0 0-2.683 2.683c0 .554.314 1.22.846 1.913.513.67 1.15 1.268 1.628 1.673a.338.338 0 0 0 .417 0c.478-.405 1.115-1.002 1.629-1.673.531-.694.846-1.36.846-1.913a2.683 2.683 0 0 0-2.683-2.683ZM9.303 14.783a.732.732 0 0 1-.574.861l-.388.078v2.013a2.196 2.196 0 1 1-1.463 0v-1.72l-1.65.33a2.195 2.195 0 0 0-1.765 2.152v1.796a.732.732 0 0 1-1.463 0v-1.796a3.659 3.659 0 0 1 2.941-3.588l2.51-.502a.818.818 0 0 1 .028-.005l.963-.193a.732.732 0 0 1 .86.574Zm-1.697 4.29a.732.732 0 1 0 .008 0h-.008Z", clipRule: "evenodd" })
  ] }));
};
var sizes117 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureSocialProof(_a) {
  var _b = _a, {
    title = "Other Nomads Worked Here",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes117 ? sizes117[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(
    Svgr117,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes117.medium,
      height: resolvedSize || sizes117.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureSocialProofFilled.tsx
var import_jsx_runtime119 = require("react/jsx-runtime");
var Svgr118 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime119.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.561 2a2.683 2.683 0 0 0-2.683 2.683v3.902a4.634 4.634 0 0 0 9.268 0V4.683A2.683 2.683 0 0 0 13.463 2H9.561Zm5.122 6.585v-1.22H8.34v1.22a3.17 3.17 0 0 0 6.342 0ZM17.854 12.732a4.146 4.146 0 0 0-4.147 4.146c0 1.045.558 2.033 1.148 2.803.605.79 1.333 1.467 1.85 1.905l.012.01c.662.538 1.61.538 2.272 0l.012-.01c.517-.438 1.246-1.114 1.852-1.905.59-.77 1.147-1.758 1.147-2.803a4.146 4.146 0 0 0-4.146-4.146Zm.995 4.156a.985.985 0 1 1-1.971 0 .985.985 0 0 1 1.97 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)("path", { fill: "currentcolor", d: "M8.729 15.644a.732.732 0 0 0-.287-1.435l-.963.193a.818.818 0 0 0-.027.005l-2.51.502A3.659 3.659 0 0 0 2 18.497v1.796a.732.732 0 0 0 1.463 0v-1.796c0-1.047.74-1.948 1.765-2.153l1.65-.33v1.72a2.196 2.196 0 1 0 1.463 0v-2.012l.388-.078Z" })
  ] }));
};
var sizes118 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureSocialProofFilled(_a) {
  var _b = _a, {
    title = "Other Nomads Worked Here",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes118 ? sizes118[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(
    Svgr118,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes118.medium,
      height: resolvedSize || sizes118.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureTopHospital.tsx
var import_jsx_runtime120 = require("react/jsx-runtime");
var Svgr119 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime120.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 4.75a.75.75 0 0 1 .75.75V8A.75.75 0 0 1 11 8V5.5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.75 6.75A.75.75 0 0 1 10.5 6H13a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 3.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM7 6.75a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0ZM8.75 15.5a.25.25 0 0 0-.25.25V21H15v-5.25a.25.25 0 0 0-.25-.25h-6ZM7 15.75c0-.966.784-1.75 1.75-1.75h6c.966 0 1.75.784 1.75 1.75v6a.75.75 0 0 1-.75.75h-8a.75.75 0 0 1-.75-.75v-6ZM2.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13A.75.75 0 0 1 2.75 8ZM20.75 8a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-1.5 0v-13a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.75 6.5a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h5.537a.75.75 0 0 1 0 1.5H2.75A1.75 1.75 0 0 1 1 7.75v-1C1 5.784 1.784 5 2.75 5h5.128a.75.75 0 0 1 0 1.5H2.75ZM14.873 5.75a.75.75 0 0 1 .75-.75h5.127c.966 0 1.75.784 1.75 1.75v1a1.75 1.75 0 0 1-1.75 1.75h-5.536a.75.75 0 1 1 0-1.5h5.536a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-5.127a.75.75 0 0 1-.75-.75ZM1 21.75a.75.75 0 0 1 .75-.75h20a.75.75 0 0 1 0 1.5h-20a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime120.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.75 14a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes119 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureTopHospital(_a) {
  var _b = _a, {
    title = "Top Hospital",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes119 ? sizes119[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(
    Svgr119,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes119.medium,
      height: resolvedSize || sizes119.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureTopHospitalFilled.tsx
var import_jsx_runtime121 = require("react/jsx-runtime");
var Svgr120 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.726 4.616c.394 0 .713.32.713.713v2.378a.713.713 0 1 1-1.427 0V5.33c0-.394.32-.713.714-.713Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M9.823 6.518c0-.394.32-.713.714-.713h2.378a.713.713 0 0 1 0 1.427h-2.378a.713.713 0 0 1-.714-.714Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.726 3.427a3.091 3.091 0 1 0 0 6.183 3.091 3.091 0 0 0 0-6.183ZM7.207 6.518a4.518 4.518 0 1 1 9.037 0 4.518 4.518 0 0 1-9.037 0ZM8.872 14.841a.238.238 0 0 0-.238.238v4.994h6.183V15.08a.238.238 0 0 0-.238-.238H8.872Zm-1.665.238c0-.92.746-1.664 1.665-1.664h5.707c.92 0 1.665.745 1.665 1.664v5.708c0 .394-.32.713-.713.713H7.92a.713.713 0 0 1-.714-.713v-5.708Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.683 6.518c.394 0 2.033 4.048 4.28 4.28l-.237 2.617H8.872l-1.665 7.372c0 .394-3.648.713-4.042.713a.713.713 0 0 1-.714-.713V8.42c0-.394 4.838-1.903 5.232-1.903ZM16.244 6.518c.394 0 4.756 1.509 4.756 1.903v12.366c0 .394-.32.713-.713.713-.394 0-4.043-.32-4.043-.713l-1.665-7.372h-2.853l.237-2.616c1.427 0 3.887-4.28 4.28-4.28Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M7.683 6.518c-.131 0 0-.131 0 0-.131 0 0 .132 0 0l.748 1.19a.713.713 0 0 1 0 1.426H3.165c-.92 0-1.665-.745-1.665-1.664v-.952c0-.919.745-1.664 1.665-1.664h4.877a.713.713 0 1 1 0 1.426l-.36.238ZM14.696 5.567c0-.394.32-.713.713-.713h4.878c.919 0 1.664.745 1.664 1.664v.952c0 .919-.745 1.664-1.664 1.664H15.02c-.394 0-.204-.082-.204-.476 0-.394-.121-.61.204-.95l1.223-1.19c0 .132.131 0 0 0h.713-.713l-.835-.237a.713.713 0 0 1-.713-.714ZM1.5 20.787c0-.394.32-.714.713-.714h19.025a.713.713 0 1 1 0 1.427H2.213a.713.713 0 0 1-.713-.713Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.726 13.415c.394 0 .713.319.713.713v6.659a.713.713 0 1 1-1.427 0v-6.659c0-.394.32-.713.714-.713Z", clipRule: "evenodd" })
  ] }));
};
var sizes120 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureTopHospitalFilled(_a) {
  var _b = _a, {
    title = "Top Hospital",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes120 ? sizes120[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
    Svgr120,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes120.medium,
      height: resolvedSize || sizes120.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureTopMatch.tsx
var import_jsx_runtime122 = require("react/jsx-runtime");
var Svgr121 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime122.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.25, d: "M9.824 12.653H8.748a1.402 1.402 0 0 1-1.402-1.402v-1.076a.602.602 0 0 0-.175-.424l-.76-.76a1.402 1.402 0 0 1 0-1.983l.76-.76a.597.597 0 0 0 .176-.424V4.748c0-.774.628-1.402 1.402-1.402h1.075c.16 0 .312-.063.425-.175l.76-.76a1.402 1.402 0 0 1 1.983 0l.76.76a.599.599 0 0 0 .424.175h1.076c.774 0 1.402.628 1.402 1.402v1.076c0 .159.063.311.175.424l.76.76a1.402 1.402 0 0 1 0 1.983l-.76.76a.6.6 0 0 0-.175.425v1.075c0 .775-.628 1.403-1.402 1.403h-1.076a.602.602 0 0 0-.424.175l-.76.76a1.402 1.402 0 0 1-1.983 0l-.76-.76a.6.6 0 0 0-.425-.176Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8.56 12.268a.625.625 0 0 1 .374.8l-2.338 6.427.987-.604a.625.625 0 0 1 .914.322l.428 1.192 2.359-6.481a.625.625 0 0 1 1.174.427l-2.95 8.107a.625.625 0 0 1-1.176-.003l-.752-2.097-1.857 1.136a.625.625 0 0 1-.914-.747l2.95-8.106a.625.625 0 0 1 .802-.373Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.883 13.466a.625.625 0 0 1 .801.374l2.365 6.497.364-1.103a.625.625 0 0 1 .91-.342l1.096.646-2.386-6.553a.625.625 0 0 1 1.175-.428l2.981 8.191a.625.625 0 0 1-.905.752l-1.927-1.137-.685 2.077a.625.625 0 0 1-1.181.018l-2.981-8.19a.625.625 0 0 1 .373-.802Z", clipRule: "evenodd" })
  ] }));
};
var sizes121 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureTopMatch(_a) {
  var _b = _a, {
    title = "Top Match",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes121 ? sizes121[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
    Svgr121,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes121.medium,
      height: resolvedSize || sizes121.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconFeatureTopMatchFilled.tsx
var import_jsx_runtime123 = require("react/jsx-runtime");
var Svgr122 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime123.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime123.jsx)("path", { fill: "currentcolor", d: "m11.999 15.613-2.491 6.845a.625.625 0 0 1-1.176-.003l-.752-2.097-1.857 1.136a.625.625 0 0 1-.914-.747l2.854-7.84a2.026 2.026 0 0 1-.941-1.712V10.13l-.753-.753a2.028 2.028 0 0 1 0-2.866l.754-.754V4.693c0-1.12.907-2.027 2.027-2.027h1.065l.753-.753a2.027 2.027 0 0 1 2.126-.472v-.006c.269.099.521.255.737.47l.754.755h1.065c1.12 0 2.027.907 2.027 2.027v1.065l.753.753a2.028 2.028 0 0 1 0 2.866l-.754.754v1.064c0 .72-.376 1.354-.943 1.713l2.856 7.846a.625.625 0 0 1-.905.752l-1.927-1.137-.685 2.077a.625.625 0 0 1-1.181.018l-2.492-6.845Z" })
  ] }));
};
var sizes122 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconFeatureTopMatchFilled(_a) {
  var _b = _a, {
    title = "Top Match",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes122 ? sizes122[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(
    Svgr122,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes122.medium,
      height: resolvedSize || sizes122.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationHelp.tsx
var import_jsx_runtime124 = require("react/jsx-runtime");
var Svgr123 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime124.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime124.jsx)("path", { fill: "currentcolor", d: "M12.001 2.2c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8 9.8-4.4 9.8-9.8-4.4-9.8-9.8-9.8Zm0 18c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime124.jsx)("path", { fill: "currentcolor", d: "M12.001 7.1c-1.5 0-2.8 1.2-2.8 2.8 0 .4.3.8.8.8s.8-.3.8-.8c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c0 .4-.2.6-.7.9-.6.4-1.3 1.1-1.3 2.2v.2c0 .4.3.8.8.8s.8-.3.8-.8V13c0-.4.2-.6.7-1 .4-.2 1.3-.9 1.3-2.2 0-1.5-1.3-2.7-2.8-2.7ZM12.001 15.2c-.3 0-.5.1-.7.3-.2.2-.3.5-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes123 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationHelp(_a) {
  var _b = _a, {
    title = "Help",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes123 ? sizes123[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
    Svgr123,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes123.medium,
      height: resolvedSize || sizes123.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationHome.tsx
var import_jsx_runtime125 = require("react/jsx-runtime");
var Svgr124 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime125.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M19 21h-3v-6c0-1.2-1-1.5-1.5-1.5h-5c-1.2 0-1.5 1-1.5 1.5v6H5c-2 0-2-1-2-2v-7.5c0-1.328 1-2 1-2L12 3c2.333 1.833 8 6.5 8 6.5s1 .672 1 2V19c0 1 0 2-2 2Z" })
  ] }));
};
var sizes124 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationHome(_a) {
  var _b = _a, {
    title = "Home",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes124 ? sizes124[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
    Svgr124,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes124.medium,
      height: resolvedSize || sizes124.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationHomeFilled.tsx
var import_jsx_runtime126 = require("react/jsx-runtime");
var Svgr125 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime126.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime126.jsx)("path", { fill: "currentcolor", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M19 21h-3v-6c0-1.2-1-1.5-1.5-1.5h-5c-1.2 0-1.5 1-1.5 1.5v6H5c-2 0-2-1-2-2v-7.5c0-1.328 1-2 1-2L12 3c2.333 1.833 8 6.5 8 6.5s1 .672 1 2V19c0 1 0 2-2 2Z" })
  ] }));
};
var sizes125 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationHomeFilled(_a) {
  var _b = _a, {
    title = "Home",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes125 ? sizes125[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
    Svgr125,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes125.medium,
      height: resolvedSize || sizes125.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationMessages.tsx
var import_jsx_runtime127 = require("react/jsx-runtime");
var Svgr126 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime127.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime127.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 6.8A2.543 2.543 0 0 1 4.8 4.25h14.4a2.543 2.543 0 0 1 2.55 2.55c0 .866-.44 1.537-.864 2.069a.753.753 0 0 1-.17.155l-6.01 4.007c-1.647 1.059-3.665 1.059-5.312 0l-.017-.012-6-4.1a.75.75 0 0 1-.046-.033C2.704 8.383 2.25 7.686 2.25 6.8Zm1.5 0c0 .309.14.605.498.898l5.966 4.077c1.15.734 2.526.733 3.675-.003l5.895-3.93c.326-.422.466-.73.466-1.042 0-.586-.464-1.05-1.05-1.05H4.8c-.586 0-1.05.464-1.05 1.05Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime127.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3 6.25a.75.75 0 0 1 .75.75v10c0 .686.564 1.25 1.25 1.25h14c.686 0 1.25-.564 1.25-1.25V7a.75.75 0 0 1 1.5 0v10A2.756 2.756 0 0 1 19 19.75H5A2.756 2.756 0 0 1 2.25 17V7A.75.75 0 0 1 3 6.25Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime127.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.212 11.788a.75.75 0 0 1 0 1.06l-6.094 6.094a.75.75 0 0 1-1.06-1.06l6.094-6.094a.75.75 0 0 1 1.06 0ZM13.83 11.83a.75.75 0 0 1 1.06 0l6.052 6.052a.75.75 0 1 1-1.06 1.06L13.83 12.89a.75.75 0 0 1 0-1.06Z", clipRule: "evenodd" })
  ] }));
};
var sizes126 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationMessages(_a) {
  var _b = _a, {
    title = "Messages",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes126 ? sizes126[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
    Svgr126,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes126.medium,
      height: resolvedSize || sizes126.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationMessagesFilled.tsx
var import_jsx_runtime128 = require("react/jsx-runtime");
var Svgr127 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime128.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime128.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime128.jsx)("path", { fill: "currentcolor", d: "m21.5 8.4-6.2-5c-2.6-2.1-5.5-.9-6.6 0l-6.2 5c-.1.2-.3.4-.3.6v10c0 1.5 1.2 2.8 2.8 2.8h14c1.5 0 2.8-1.2 2.8-2.8V9c0-.2-.2-.4-.3-.6Zm-1 12.1c-.3.3-.8.3-1.1 0L14 15c-.8-.8-1.6-1-2.3-.9-.7.2-1.3.6-1.7.9l-5.5 5.5c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l4.9-4.9-4.9-4c-.3-.3-.4-.7-.1-1.1.3-.3.7-.4 1.1-.1l5 4.1c.5-.4 1.2-.7 1.9-.8 1-.2 2 0 3.1.8l5-4.1c.3-.3.8-.2 1.1.1.3.3.2.8-.1 1.1l-4.9 4 4.9 4.9c.4.4.4.8.1 1.1Z" })
  ] }));
};
var sizes127 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationMessagesFilled(_a) {
  var _b = _a, {
    title = "Messages",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes127 ? sizes127[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(
    Svgr127,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes127.medium,
      height: resolvedSize || sizes127.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationNotes.tsx
var import_jsx_runtime129 = require("react/jsx-runtime");
var Svgr128 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M2.25 7A4.75 4.75 0 0 1 7 2.25h10A4.75 4.75 0 0 1 21.75 7v10A4.75 4.75 0 0 1 17 21.75H7A4.75 4.75 0 0 1 2.25 17V7ZM7 3.75A3.25 3.25 0 0 0 3.75 7v10A3.25 3.25 0 0 0 7 20.25h10A3.25 3.25 0 0 0 20.25 17V7A3.25 3.25 0 0 0 17 3.75H7Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime129.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.25 8A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8ZM6.25 16a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes128 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationNotes(_a) {
  var _b = _a, {
    title = "Notes",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes128 ? sizes128[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
    Svgr128,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes128.medium,
      height: resolvedSize || sizes128.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationNotesFilled.tsx
var import_jsx_runtime130 = require("react/jsx-runtime");
var Svgr129 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime130.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime130.jsx)("path", { fill: "currentcolor", d: "M17 2.2H7C4.4 2.2 2.2 4.4 2.2 7v10c0 2.6 2.1 4.8 4.8 4.8h10c2.6 0 4.8-2.1 4.8-4.8V7c0-2.6-2.2-4.8-4.8-4.8Zm-5 14.6H7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h5c.4 0 .8.3.8.8s-.4.8-.8.8Zm5-4H7c-.4 0-.8-.3-.8-.8s.3-.8.8-.8h10c.4 0 .8.3.8.8s-.4.8-.8.8Zm0-4H7c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h10c.4 0 .8.3.8.8s-.4.8-.8.8Z" })
  ] }));
};
var sizes129 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationNotesFilled(_a) {
  var _b = _a, {
    title = "Notes",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes129 ? sizes129[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
    Svgr129,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes129.medium,
      height: resolvedSize || sizes129.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationSettings.tsx
var import_jsx_runtime131 = require("react/jsx-runtime");
var Svgr130 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime131.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M12.8 2.996a1 1 0 0 1 .942.663l.508 1.415c.08.223.237.41.442.528l1.508.87a1 1 0 0 0 .677.119l1.48-.267a1 1 0 0 1 1.046.484l.8 1.38a1 1 0 0 1-.1 1.147l-.97 1.148a1 1 0 0 0-.238.647v1.74a1 1 0 0 0 .237.647l.971 1.148a1 1 0 0 1 .1 1.147l-.8 1.38a1 1 0 0 1-1.044.485l-1.48-.268a1 1 0 0 0-.678.118l-1.508.87a1.006 1.006 0 0 0-.442.529l-.508 1.416a1 1 0 0 1-.943.662h-1.6a1 1 0 0 1-.942-.662l-.508-1.416a1.01 1.01 0 0 0-.441-.528l-1.509-.87c-.204-.119-.444-.16-.677-.119l-1.48.268a1 1 0 0 1-1.046-.485l-.8-1.38a1 1 0 0 1 .1-1.147l.971-1.148a1 1 0 0 0 .237-.646V11.13a1 1 0 0 0-.237-.647l-.961-1.148a1 1 0 0 1-.1-1.147l.8-1.38a1 1 0 0 1 1.045-.484l1.48.267a1 1 0 0 0 .677-.118l1.509-.87a1.01 1.01 0 0 0 .441-.529l.508-1.415a1 1 0 0 1 .933-.663h1.6Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)("circle", { cx: 12, cy: 12, r: 2.751, stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 })
  ] }));
};
var sizes130 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationSettings(_a) {
  var _b = _a, {
    title = "Settings",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes130 ? sizes130[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
    Svgr130,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes130.medium,
      height: resolvedSize || sizes130.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationSupport.tsx
var import_jsx_runtime132 = require("react/jsx-runtime");
var Svgr131 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime132.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime132.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime132.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M19.153 6.49a.75.75 0 0 1 1.037.222 9.748 9.748 0 0 1 0 10.577.75.75 0 1 1-1.26-.814 8.248 8.248 0 0 0 0-8.949.75.75 0 0 1 .223-1.037ZM15.017 8.983a4.267 4.267 0 1 0-6.034 6.034 4.267 4.267 0 0 0 6.034-6.034Zm1.06-1.06a5.767 5.767 0 1 0-8.155 8.155 5.767 5.767 0 0 0 8.156-8.156Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime132.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.858 4.871a.253.253 0 0 0-.374.018L14.9 8.028a.75.75 0 1 1-1.158-.953l2.584-3.14c.657-.799 1.86-.855 2.591-.126l1.274 1.274a1.752 1.752 0 0 1-.126 2.592l-3.139 2.584a.75.75 0 0 1-.953-1.158l3.14-2.584a.252.252 0 0 0 .017-.373L17.858 4.87ZM8.129 13.844a.75.75 0 0 1-.103 1.055l-3.139 2.584a.252.252 0 0 0-.018.374l1.272 1.272c.107.106.28.097.375-.017l2.584-3.14a.75.75 0 1 1 1.158.954l-2.584 3.139c-.658.8-1.86.856-2.592.126l-1.274-1.273a1.752 1.752 0 0 1 .126-2.593l3.14-2.584a.75.75 0 0 1 1.055.103ZM6.516 4.888a.252.252 0 0 0-.374-.018L4.87 6.142a.253.253 0 0 0 .017.374L8.027 9.1a.75.75 0 0 1-.953 1.158l-3.14-2.584a1.753 1.753 0 0 1-.126-2.591L5.08 3.809a1.752 1.752 0 0 1 2.593.126l2.584 3.139a.75.75 0 0 1-1.158.953l-2.584-3.14ZM15.87 13.845a.75.75 0 0 1 1.055-.103l3.14 2.584c.799.658.855 1.86.126 2.592l-1.274 1.274a1.752 1.752 0 0 1-2.592-.126l-2.584-3.14a.75.75 0 0 1 1.158-.952l2.584 3.139a.252.252 0 0 0 .373.018l1.273-1.273a.253.253 0 0 0-.018-.374L15.972 14.9a.75.75 0 0 1-.102-1.055Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime132.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.489 19.153a.75.75 0 0 1 1.037-.223 8.248 8.248 0 0 0 8.949.001.75.75 0 1 1 .814 1.26A9.748 9.748 0 0 1 6.71 20.19a.75.75 0 0 1-.222-1.037ZM4.846 6.488a.75.75 0 0 1 .223 1.037 8.248 8.248 0 0 0 0 8.95.75.75 0 1 1-1.26.813 9.748 9.748 0 0 1 0-10.577.75.75 0 0 1 1.037-.223ZM6.71 3.81a9.748 9.748 0 0 1 10.578 0 .75.75 0 1 1-.814 1.26 8.248 8.248 0 0 0-8.95 0 .75.75 0 0 1-.813-1.26Z", clipRule: "evenodd" })
  ] }));
};
var sizes131 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationSupport(_a) {
  var _b = _a, {
    title = "Support",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes131 ? sizes131[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
    Svgr131,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes131.medium,
      height: resolvedSize || sizes131.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationTimekeeping.tsx
var import_jsx_runtime133 = require("react/jsx-runtime");
var Svgr132 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime133.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime133.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 8.7c-.4 0-.8.3-.8.8v4c0 .4.3.8.8.8.4 0 .8-.3.8-.8v-4c-.1-.4-.4-.8-.8-.8ZM10 3.2h4c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-4c-.4 0-.8.3-.8.8s.4.7.8.7Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime133.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m21.5 6-2-2c-.3-.3-.8-.3-1.1 0-.3.3-.3.8 0 1.1l.5.5-1.3 1.3c-3.4-3-8.5-2.8-11.8.4-3.4 3.4-3.4 9 0 12.4 3.4 3.4 9 3.4 12.4 0 3.2-3.2 3.4-8.4.5-11.8L20 6.6l.5.4c.3.3.8.3 1.1 0 .3-.3.2-.7-.1-1Zm-4.4 12.6c-2.8 2.8-7.4 2.8-10.3 0-2.9-2.8-2.8-7.4.1-10.2 2.9-2.8 7.4-2.8 10.3 0 2.9 2.8 2.8 7.4-.1 10.2Z", clipRule: "evenodd" })
  ] }));
};
var sizes132 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationTimekeeping(_a) {
  var _b = _a, {
    title = "Timekeeping",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes132 ? sizes132[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
    Svgr132,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes132.medium,
      height: resolvedSize || sizes132.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconNavigationTimekeepingFilled.tsx
var import_jsx_runtime134 = require("react/jsx-runtime");
var Svgr133 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime134.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime134.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime134.jsx)("path", { fill: "currentcolor", d: "M10.001 3.3h4c.4 0 .8-.3.8-.8s-.4-.7-.8-.7h-4c-.4 0-.8.3-.8.8s.4.7.8.7ZM21.501 6l-2-2c-.3-.3-.8-.3-1.1 0-.1.1-.2.3-.2.5s.1.4.2.5l.5.5-1.3 1.3c-1.6-1.3-3.5-2.1-5.6-2.1-2.3 0-4.5.9-6.2 2.6-1.6 1.7-2.6 3.9-2.6 6.2 0 2.3.9 4.5 2.6 6.2 1.7 1.7 3.9 2.6 6.2 2.6 2.2 0 4.5-.9 6.2-2.6 3.2-3.2 3.4-8.4.5-11.8l1.3-1.3.5.4c.3.3.8.3 1.1 0 .3-.3.2-.7-.1-1Zm-8.7 7.5c0 .4-.3.8-.8.8s-.8-.3-.8-.8v-4c0-.4.3-.8.8-.8s.8.3.8.8v4Z" })
  ] }));
};
var sizes133 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconNavigationTimekeepingFilled(_a) {
  var _b = _a, {
    title = "Timekeeping",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes133 ? sizes133[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(
    Svgr133,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes133.medium,
      height: resolvedSize || sizes133.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconSocialFacebook.tsx
var import_jsx_runtime135 = require("react/jsx-runtime");
var Svgr134 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime135.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime135.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime135.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.958 9.877V8.815c0-.16.007-.283.022-.37a.714.714 0 0 1 .102-.258.416.416 0 0 1 .256-.176 1.84 1.84 0 0 1 .472-.048h1.071V5.839h-1.712c-.99 0-1.702.233-2.135.699-.432.466-.648 1.153-.648 2.06v1.28H9.104V12h1.282v6.162h2.572v-6.162h1.712l.226-2.124h-1.938Z", clipRule: "evenodd" })
  ] }));
};
var sizes134 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconSocialFacebook(_a) {
  var _b = _a, {
    title = "Facebook Logo",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes134 ? sizes134[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
    Svgr134,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes134.medium,
      height: resolvedSize || sizes134.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconSocialInstagram.tsx
var import_jsx_runtime136 = require("react/jsx-runtime");
var Svgr135 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime136.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime136.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.864 6.842c1.635 0 1.829.006 2.475.036.597.027.921.127 1.137.21.286.112.49.244.704.459.215.214.347.418.459.704.083.216.183.54.21 1.137.03.646.036.84.036 2.475 0 1.636-.006 1.83-.036 2.475-.027.597-.127.921-.21 1.137-.112.286-.244.49-.459.705a1.897 1.897 0 0 1-.704.458c-.216.083-.54.183-1.137.21-.646.03-.84.036-2.475.036-1.636 0-1.83-.006-2.475-.035-.597-.028-.921-.128-1.137-.211a1.897 1.897 0 0 1-.704-.459 1.897 1.897 0 0 1-.459-.704c-.083-.216-.183-.54-.21-1.137-.03-.646-.036-.84-.036-2.475 0-1.635.006-1.829.036-2.475.027-.597.127-.921.21-1.137.112-.286.244-.49.459-.704.214-.215.418-.347.704-.458.216-.084.54-.184 1.137-.211.646-.03.84-.036 2.475-.036Zm0-1.103c-1.664 0-1.872.007-2.525.037-.652.03-1.097.133-1.487.285a3.003 3.003 0 0 0-1.085.706c-.34.34-.55.682-.706 1.085-.152.39-.255.835-.285 1.487-.03.653-.037.861-.037 2.525 0 1.663.007 1.872.037 2.525.03.652.133 1.097.285 1.487.156.403.366.744.706 1.085.34.34.682.55 1.085.706.39.151.835.255 1.487.285.653.03.861.037 2.525.037 1.663 0 1.872-.008 2.525-.037.652-.03 1.097-.134 1.487-.285a3.002 3.002 0 0 0 1.085-.706c.34-.34.55-.682.706-1.085.151-.39.255-.835.285-1.487.03-.653.037-.862.037-2.525 0-1.664-.008-1.872-.037-2.525-.03-.652-.134-1.097-.285-1.487a3.001 3.001 0 0 0-.706-1.085c-.34-.34-.682-.55-1.085-.706-.39-.152-.835-.255-1.487-.285-.653-.03-.862-.037-2.525-.037Zm.012 2.99a3.147 3.147 0 1 0 0 6.294 3.147 3.147 0 0 0 0-6.294Zm0 5.191a2.043 2.043 0 1 1 0-4.086 2.043 2.043 0 0 1 0 4.086Zm3.974-5.337a.73.73 0 1 1-1.458 0 .73.73 0 0 1 1.458 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes135 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconSocialInstagram(_a) {
  var _b = _a, {
    title = "Instagram Logo",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes135 ? sizes135[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
    Svgr135,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes135.medium,
      height: resolvedSize || sizes135.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconSocialLinkedIn.tsx
var import_jsx_runtime137 = require("react/jsx-runtime");
var Svgr136 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime137.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.857 7.056c.246-.233.568-.35.965-.35s.716.117.955.35c.24.233.361.528.366.884.005.35-.116.644-.362.88-.247.235-.571.353-.973.353h-.015c-.392 0-.708-.118-.947-.354a1.184 1.184 0 0 1-.36-.88c0-.355.124-.65.37-.883Zm7.936 2.924c-.301 0-.575.038-.822.112a1.862 1.862 0 0 0-.625.314 3.07 3.07 0 0 0-.405.375 3.1 3.1 0 0 0-.28.381v-1.016h-2.362l.007.346c.005.231.007.942.007 2.135 0 1.192-.005 2.747-.014 4.665h2.362v-3.987c0-.246.026-.44.079-.585.1-.245.252-.45.455-.616a1.16 1.16 0 0 1 .758-.249c.412 0 .714.143.908.43.194.285.29.68.29 1.185v3.822h2.363v-4.096c0-1.053-.25-1.852-.747-2.397-.497-.546-1.156-.819-1.974-.819Zm-8.168.161v7.146h2.37v-7.146h-2.37Z", clipRule: "evenodd" })
  ] }));
};
var sizes136 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconSocialLinkedIn(_a) {
  var _b = _a, {
    title = "LinkedIn Logo",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes136 ? sizes136[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(
    Svgr136,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes136.medium,
      height: resolvedSize || sizes136.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconSocialTiktok.tsx
var import_jsx_runtime138 = require("react/jsx-runtime");
var Svgr137 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime138.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime138.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime138.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.297 8.984v5.188a4.316 4.316 0 0 1-1.268 3.06 4.316 4.316 0 0 1-3.06 1.268 4.316 4.316 0 0 1-3.06-1.267 4.316 4.316 0 0 1-1.267-3.06c0-1.152.453-2.246 1.267-3.06a4.315 4.315 0 0 1 3.06-1.268h.803v2.275h-.803c-.546 0-1.065.215-1.451.601a2.045 2.045 0 0 0-.601 1.451 2.047 2.047 0 0 0 2.053 2.053c.546 0 1.064-.215 1.45-.601.387-.387.602-.905.602-1.447V5.5h2.265l.114.21c.352.654.828 1.274 1.418 1.73.456.354.973.604 1.543.704l.403.07-.432 2.194-.388-.07a5.357 5.357 0 0 1-1.339-.422 4.334 4.334 0 0 1-1.309-.932Z", clipRule: "evenodd" })
  ] }));
};
var sizes137 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconSocialTiktok(_a) {
  var _b = _a, {
    title = "TikTok Logo",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes137 ? sizes137[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(
    Svgr137,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes137.medium,
      height: resolvedSize || sizes137.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconSocialTwitter.tsx
var import_jsx_runtime139 = require("react/jsx-runtime");
var Svgr138 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime139.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime139.jsx)("path", { fill: "currentcolor", d: "m13.462 11.196 4.736-5.504h-1.123l-4.111 4.78-3.285-4.78H5.892l4.966 7.227-4.966 5.773h1.122l4.342-5.048 3.468 5.048h3.788l-5.15-7.496Zm-6.044-4.66h1.724l7.934 11.35h-1.724L7.418 6.535Z" })
  ] }));
};
var sizes138 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconSocialTwitter(_a) {
  var _b = _a, {
    title = "X (Twitter) Logo",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes138 ? sizes138[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(
    Svgr138,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes138.medium,
      height: resolvedSize || sizes138.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusFail.tsx
var import_jsx_runtime140 = require("react/jsx-runtime");
var Svgr139 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime140.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime140.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m9.999 10 4.002 4m0-4-4.002 4M20.997 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" })
  ] }));
};
var sizes139 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusFail(_a) {
  var _b = _a, {
    title = "Fail",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes139 ? sizes139[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
    Svgr139,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes139.medium,
      height: resolvedSize || sizes139.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusFailFilled.tsx
var import_jsx_runtime141 = require("react/jsx-runtime");
var Svgr140 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime141.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime141.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime141.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.997 2.249c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75-4.365-9.75-9.75-9.75Zm-1.468 7.22a.75.75 0 0 0-1.06 1.06L10.939 12l-1.47 1.47a.75.75 0 1 0 1.06 1.061l1.47-1.47 1.471 1.47a.75.75 0 1 0 1.061-1.06L13.061 12l1.47-1.47a.75.75 0 0 0-1.06-1.061L12 10.939l-1.47-1.47Z", clipRule: "evenodd" })
  ] }));
};
var sizes140 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusFailFilled(_a) {
  var _b = _a, {
    title = "Fail",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes140 ? sizes140[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
    Svgr140,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes140.medium,
      height: resolvedSize || sizes140.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusGeneralNotification.tsx
var import_jsx_runtime142 = require("react/jsx-runtime");
var Svgr141 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime142.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75Zm0-1.5A9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12 9.75 9.75 0 0 1 12 2.25Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)("path", { fill: "currentcolor", d: "M13 16.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })
  ] }));
};
var sizes141 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusGeneralNotification(_a) {
  var _b = _a, {
    title = "Notification",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes141 ? sizes141[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
    Svgr141,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes141.medium,
      height: resolvedSize || sizes141.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusGeneralNotificationFilled.tsx
var import_jsx_runtime143 = require("react/jsx-runtime");
var Svgr142 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime143.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime143.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime143.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M21.75 12A9.75 9.75 0 0 0 12 2.25 9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12Zm-9-4.5a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5ZM12 17.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z", clipRule: "evenodd" })
  ] }));
};
var sizes142 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusGeneralNotificationFilled(_a) {
  var _b = _a, {
    title = "Notification",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes142 ? sizes142[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(
    Svgr142,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes142.medium,
      height: resolvedSize || sizes142.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusInfo.tsx
var import_jsx_runtime144 = require("react/jsx-runtime");
var Svgr143 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime144.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime144.jsx)("path", { fill: "currentcolor", d: "M12.001 2.2c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8 9.8-4.4 9.8-9.8-4.4-9.8-9.8-9.8Zm0 18c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime144.jsx)("path", { fill: "currentcolor", d: "M12.001 11.2h-1c-.4 0-.8.3-.8.8s.3.8.8.8h.2V17c0 .4.3.8.8.8s.8-.3.8-.8v-5c0-.4-.4-.8-.8-.8ZM11.701 7.2c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes143 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusInfo(_a) {
  var _b = _a, {
    title = "Info",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes143 ? sizes143[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
    Svgr143,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes143.medium,
      height: resolvedSize || sizes143.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusInfoFilled.tsx
var import_jsx_runtime145 = require("react/jsx-runtime");
var Svgr144 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime145.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime145.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.001 21.8c5.413 0 9.8-4.388 9.8-9.8 0-5.413-4.387-9.8-9.8-9.8-5.412 0-9.8 4.387-9.8 9.8 0 5.412 4.388 9.8 9.8 9.8Zm-1-14.3c.2-.2.4-.3.7-.3.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1c0-.3.1-.5.3-.7Zm1 3.7c.4 0 .8.4.8.8v5c0 .5-.3.8-.8.8s-.8-.4-.8-.8v-4.2h-.2c-.5 0-.8-.3-.8-.8s.4-.8.8-.8h1Z", clipRule: "evenodd" })
  ] }));
};
var sizes144 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusInfoFilled(_a) {
  var _b = _a, {
    title = "Info",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes144 ? sizes144[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
    Svgr144,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes144.medium,
      height: resolvedSize || sizes144.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessComplete.tsx
var import_jsx_runtime146 = require("react/jsx-runtime");
var Svgr145 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime146.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime146.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime146.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "m13.11 7.291 1.065 2.157 2.377.345c1.018.148 1.422 1.398.687 2.114l-1.722 1.675.407 2.368c.174 1.014-.89 1.783-1.797 1.307L12 16.139l-2.127 1.118c-.907.476-1.971-.292-1.797-1.306l.406-2.369-1.72-1.675c-.735-.716-.333-1.966.685-2.114l2.378-.345L10.89 7.29c.455-.919 1.767-.921 2.222.001Zm-.798 7.657 2.373 1.247a.053.053 0 0 0 .014.005h.006a.044.044 0 0 0 .021-.009.043.043 0 0 0 .014-.016l.002-.006v-.015l-.46-2.68a.6.6 0 0 1 .172-.531l1.948-1.896a.053.053 0 0 0 .01-.012.02.02 0 0 0 .001-.005.044.044 0 0 0-.001-.023.044.044 0 0 0-.012-.019.019.019 0 0 0-.005-.003.05.05 0 0 0-.014-.004l-2.691-.391a.6.6 0 0 1-.452-.329l-1.204-2.44a.056.056 0 0 0-.008-.012.018.018 0 0 0-.005-.004A.043.043 0 0 0 12 7.8a.044.044 0 0 0-.022.005.023.023 0 0 0-.005.004.054.054 0 0 0-.009.013l-1.202 2.44a.6.6 0 0 1-.452.328l-2.69.391a.057.057 0 0 0-.015.004.02.02 0 0 0-.005.003.044.044 0 0 0-.012.019.044.044 0 0 0-.001.023.02.02 0 0 0 .002.005.05.05 0 0 0 .01.012l1.947 1.896a.6.6 0 0 1 .173.531l-.46 2.68a.057.057 0 0 0-.001.015c0 .002 0 .004.002.006.001.004.005.01.014.016a.044.044 0 0 0 .02.01l.007-.001a.053.053 0 0 0 .014-.005l2.372-1.247a.597.597 0 0 1 .312-.087H12c.113 0 .22.031.311.087ZM21.48 12a.6.6 0 0 1 .6-.6h1.32a.6.6 0 1 1 0 1.2h-1.32a.6.6 0 0 1-.6-.6ZM0 12a.6.6 0 0 1 .6-.6h1.32a.6.6 0 1 1 0 1.2H.6A.6.6 0 0 1 0 12ZM20.656 3.344a.6.6 0 0 1 0 .848l-1.26 1.26a.6.6 0 0 1-.848-.848l1.26-1.26a.6.6 0 0 1 .848 0ZM5.488 18.572a.6.6 0 0 1 0 .848l-1.272 1.272a.6.6 0 1 1-.848-.848l1.272-1.272a.6.6 0 0 1 .848 0ZM3.346 3.366a.6.6 0 0 1 .848.004l1.26 1.272a.6.6 0 0 1-.852.844l-1.26-1.272a.6.6 0 0 1 .004-.848ZM18.57 18.55a.6.6 0 0 1 .848-.004l1.272 1.26a.6.6 0 0 1-.844.852l-1.272-1.26a.6.6 0 0 1-.004-.848ZM12 21.528a.6.6 0 0 1 .6.6V23.4a.6.6 0 1 1-1.2 0v-1.272a.6.6 0 0 1 .6-.6ZM12 0a.6.6 0 0 1 .6.6v1.272a.6.6 0 1 1-1.2 0V.6A.6.6 0 0 1 12 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes145 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessComplete(_a) {
  var _b = _a, {
    title = "Process Complete",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes145 ? sizes145[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
    Svgr145,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes145.medium,
      height: resolvedSize || sizes145.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessInDraft.tsx
var import_jsx_runtime147 = require("react/jsx-runtime");
var Svgr146 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime147.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime147.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime147.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M13.749 8.664a.249.249 0 0 0-.353 0l-4 4-.001.002a.248.248 0 0 0-.072.175v1.836h1.836c.066 0 .13-.027.177-.073l4-4a.25.25 0 0 0 0-.354l-1.587-1.586Zm-2.59 7.513H8.573a.75.75 0 0 1-.75-.75v-2.586c0-.462.183-.909.513-1.238h.001l3.999-4a1.749 1.749 0 0 1 2.474 0c0 .001 0 0 0 0l1.586 1.587a1.749 1.749 0 0 1 0 2.475", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime147.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M17.834 6.166A8.25 8.25 0 1 0 6.166 17.834 8.25 8.25 0 0 0 17.834 6.166Zm1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0Z", clipRule: "evenodd" })
  ] }));
};
var sizes146 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessInDraft(_a) {
  var _b = _a, {
    title = "Process In Draft",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes146 ? sizes146[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(
    Svgr146,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes146.medium,
      height: resolvedSize || sizes146.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessInProgress.tsx
var import_jsx_runtime148 = require("react/jsx-runtime");
var Svgr147 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime148.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime148.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime148.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M4.291 16.562a.75.75 0 0 1 1.026.268 6.29 6.29 0 0 0 1.298 1.583.75.75 0 1 1-.983 1.133 7.789 7.789 0 0 1-1.61-1.958.75.75 0 0 1 .27-1.026ZM3.278 9.766a.75.75 0 0 1 .58.888 5.093 5.093 0 0 0 0 2.093.75.75 0 1 1-1.467.307 6.593 6.593 0 0 1 0-2.708.75.75 0 0 1 .887-.58ZM7.405 4.236a.75.75 0 0 1-.18 1.046A6.877 6.877 0 0 0 5.601 6.89a.75.75 0 1 1-1.218-.875 8.377 8.377 0 0 1 1.975-1.959.75.75 0 0 1 1.046.18ZM10.366 2.372a9.775 9.775 0 1 1 0 19.256.775.775 0 0 1 .268-1.526 8.225 8.225 0 1 0 0-16.204.775.775 0 1 1-.268-1.526Z", clipRule: "evenodd" })
  ] }));
};
var sizes147 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessInProgress(_a) {
  var _b = _a, {
    title = "Process In Progress",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes147 ? sizes147[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
    Svgr147,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes147.medium,
      height: resolvedSize || sizes147.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessIncomplete.tsx
var import_jsx_runtime149 = require("react/jsx-runtime");
var Svgr148 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime149.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes148 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessIncomplete(_a) {
  var _b = _a, {
    title = "Process Incomplete",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes148 ? sizes148[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
    Svgr148,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes148.medium,
      height: resolvedSize || sizes148.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessNotQualified.tsx
var import_jsx_runtime150 = require("react/jsx-runtime");
var Svgr149 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime150.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime150.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime150.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12Zm6 0a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes149 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessNotQualified(_a) {
  var _b = _a, {
    title = "Process Not Qualified",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes149 ? sizes149[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(
    Svgr149,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes149.medium,
      height: resolvedSize || sizes149.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessNotStarted.tsx
var import_jsx_runtime151 = require("react/jsx-runtime");
var Svgr150 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime151.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10.727 2.332a9.835 9.835 0 0 1 2.546 0 .75.75 0 0 1-.194 1.488 8.335 8.335 0 0 0-2.158 0 .75.75 0 0 1-.194-1.488Zm-3.611 2.07a.75.75 0 0 1-.138 1.052 8.304 8.304 0 0 0-1.524 1.524.75.75 0 1 1-1.19-.914 9.803 9.803 0 0 1 1.8-1.8.75.75 0 0 1 1.052.138Zm9.768 0a.75.75 0 0 1 1.052-.137 9.807 9.807 0 0 1 1.8 1.799.75.75 0 0 1-1.19.914 8.303 8.303 0 0 0-1.524-1.524.75.75 0 0 1-.138-1.052Zm-13.71 5.679c.41.053.7.43.646.84a8.335 8.335 0 0 0 0 2.158.75.75 0 0 1-1.488.194 9.835 9.835 0 0 1 0-2.546.75.75 0 0 1 .841-.646Zm17.653 0a.75.75 0 0 1 .84.646 9.83 9.83 0 0 1 0 2.546.75.75 0 1 1-1.487-.194 8.335 8.335 0 0 0 0-2.158.75.75 0 0 1 .647-.84ZM4.402 16.884a.75.75 0 0 1 1.052.138c.44.572.952 1.085 1.524 1.524a.75.75 0 0 1-.914 1.19 9.807 9.807 0 0 1-1.8-1.8.75.75 0 0 1 .138-1.052Zm15.196 0a.75.75 0 0 1 .137 1.052 9.81 9.81 0 0 1-1.799 1.8.75.75 0 0 1-.914-1.19 8.302 8.302 0 0 0 1.524-1.524.75.75 0 0 1 1.052-.138Zm-9.517 3.943a.75.75 0 0 1 .84-.647 8.335 8.335 0 0 0 2.158 0 .75.75 0 0 1 .194 1.488 9.83 9.83 0 0 1-2.546 0 .75.75 0 0 1-.646-.841Z", clipRule: "evenodd" })
  ] }));
};
var sizes150 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessNotStarted(_a) {
  var _b = _a, {
    title = "Process Not Started",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes150 ? sizes150[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
    Svgr150,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes150.medium,
      height: resolvedSize || sizes150.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessPaused.tsx
var import_jsx_runtime152 = require("react/jsx-runtime");
var Svgr151 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime152.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime152.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime152.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M14 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM10 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime152.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75Zm0-1.5A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25Z", clipRule: "evenodd" })
  ] }));
};
var sizes151 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessPaused(_a) {
  var _b = _a, {
    title = "Process Paused",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes151 ? sizes151[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
    Svgr151,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes151.medium,
      height: resolvedSize || sizes151.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessProcessing.tsx
var import_jsx_runtime153 = require("react/jsx-runtime");
var Svgr152 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime153.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M8.25 8A.75.75 0 0 1 9 7.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 8ZM8.25 16a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M10 7.25a.75.75 0 0 1 .75.75v2a.25.25 0 0 0 .1.2l1.15.863 1.15-.863a.25.25 0 0 0 .1-.2V8a.75.75 0 0 1 1.5 0v2c0 .551-.26 1.07-.7 1.4l-1.6 1.2a.75.75 0 0 1-.9 0l-1.6-1.2a1.75 1.75 0 0 1-.7-1.4V8a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.55 11.4a.75.75 0 0 1 .9 0l1.6 1.2c.44.33.7.849.7 1.4v2a.75.75 0 0 1-1.5 0v-2a.25.25 0 0 0-.1-.2L12 12.937l-1.15.863a.25.25 0 0 0-.1.2v2a.75.75 0 0 1-1.5 0v-2c0-.551.26-1.07.7-1.4l1.6-1.2Z", clipRule: "evenodd" })
  ] }));
};
var sizes152 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessProcessing(_a) {
  var _b = _a, {
    title = "Processing",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes152 ? sizes152[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
    Svgr152,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes152.medium,
      height: resolvedSize || sizes152.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessReadyForReview.tsx
var import_jsx_runtime154 = require("react/jsx-runtime");
var Svgr153 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime154.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M15.298 11.291a.993.993 0 0 1 1.404 0l.007.007a.993.993 0 0 1 0 1.404l-.007.007a.993.993 0 0 1-1.404 0l-.007-.007a.993.993 0 0 1 0-1.404l.007-.007ZM11.38 11.374a.877.877 0 0 1 1.24 0l.006.006a.877.877 0 0 1 0 1.24l-.006.006a.877.877 0 0 1-1.24 0l-.006-.006a.877.877 0 0 1 0-1.24l.006-.006ZM7.47 11.465a.75.75 0 0 1 1.06 0l.005.005a.75.75 0 0 1 0 1.06l-.005.005a.75.75 0 0 1-1.06 0l-.005-.005a.75.75 0 0 1 0-1.06l.005-.005Z", clipRule: "evenodd" })
  ] }));
};
var sizes153 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessReadyForReview(_a) {
  var _b = _a, {
    title = "Process Ready for Review",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes153 ? sizes153[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
    Svgr153,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes153.medium,
      height: resolvedSize || sizes153.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusProcessWaiting.tsx
var import_jsx_runtime155 = require("react/jsx-runtime");
var Svgr154 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime155.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.25 3a.75.75 0 0 1 .75-.75 9.75 9.75 0 1 1-6.903 16.635.75.75 0 1 1 1.062-1.06A8.25 8.25 0 1 0 12 3.75a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("circle", { cx: 3.73, cy: 15.42, r: 0.8, fill: "currentcolor", fillRule: "evenodd", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M3.85 12.001a.8.8 0 1 1 0-.001m-1.5 0Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("circle", { cx: 3.75, cy: 8.576, r: 0.8, fill: "currentcolor", fillRule: "evenodd", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M6.237 5.106a.8.8 0 1 1-1.13 1.131.8.8 0 0 1 1.13-1.131ZM8.574 2.932a.8.8 0 1 1 .002 1.6.8.8 0 0 1-.002-1.6Zm-.699.8V3.73M10.648 12.602a.75.75 0 0 1 .75-.75h4.65a.75.75 0 0 1 0 1.5h-4.65a.75.75 0 0 1-.75-.75Z", clipRule: "evenodd" }),
    /* @__PURE__ */ (0, import_jsx_runtime155.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M11.398 6.25a.75.75 0 0 1 .75.75v5.602a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75Z", clipRule: "evenodd" })
  ] }));
};
var sizes154 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusProcessWaiting(_a) {
  var _b = _a, {
    title = "Process Waiting",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes154 ? sizes154[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(
    Svgr154,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes154.medium,
      height: resolvedSize || sizes154.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusStepComplete.tsx
var import_jsx_runtime156 = require("react/jsx-runtime");
var Svgr155 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime156.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime156.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime156.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime156.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime156.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes155 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusStepComplete(_a) {
  var _b = _a, {
    title = "Step Complete",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes155 ? sizes155[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
    Svgr155,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes155.medium,
      height: resolvedSize || sizes155.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusStepInDraft.tsx
var import_jsx_runtime157 = require("react/jsx-runtime");
var Svgr156 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime157.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime157.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime157.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime157.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes156 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusStepInDraft(_a) {
  var _b = _a, {
    title = "Step In Draft",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes156 ? sizes156[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
    Svgr156,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes156.medium,
      height: resolvedSize || sizes156.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusStepStarted.tsx
var import_jsx_runtime158 = require("react/jsx-runtime");
var Svgr157 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime158.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime158.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3" }),
    /* @__PURE__ */ (0, import_jsx_runtime158.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M21 18.013a3 3 0 0 1-3 3M3 6.013a3 3 0 0 1 3-3" }),
    /* @__PURE__ */ (0, import_jsx_runtime158.jsx)("path", { stroke: "#da0", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M3 6.013a3 3 0 0 1 3-3M6 21.013a3 3 0 0 1-3-3M18 3.013a3 3 0 0 1 3 3M3 13.638v1.25M3 9.138v1.25M21 10.388v-1.25M21 14.888v-1.25M13.625 21.013h1.25M9.125 21.013h1.25M10.375 3.013h-1.25M14.875 3.013h-1.25M12 13.263v-.25c0-.817.505-1.26 1.011-1.6.494-.333.989-.767.989-1.567a2 2 0 1 0-4 0M11.999 16.013a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" })
  ] }));
};
var sizes157 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusStepStarted(_a) {
  var _b = _a, {
    title = "Step Started",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes157 ? sizes157[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
    Svgr157,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes157.medium,
      height: resolvedSize || sizes157.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusSuccess.tsx
var import_jsx_runtime159 = require("react/jsx-runtime");
var Svgr158 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime159.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime159.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime159.jsx)("path", { stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m9 12 2.25 2.25 4.005-4.005M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" })
  ] }));
};
var sizes158 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusSuccess(_a) {
  var _b = _a, {
    title = "Success",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes158 ? sizes158[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
    Svgr158,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes158.medium,
      height: resolvedSize || sizes158.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusSuccessFilled.tsx
var import_jsx_runtime160 = require("react/jsx-runtime");
var Svgr159 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime160.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime160.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime160.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm3.785 8.526a.75.75 0 1 0-1.06-1.061l-3.475 3.474-1.72-1.72a.75.75 0 0 0-1.06 1.061l2.25 2.25a.75.75 0 0 0 1.06 0l4.005-4.004Z", clipRule: "evenodd" })
  ] }));
};
var sizes159 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusSuccessFilled(_a) {
  var _b = _a, {
    title = "Success",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes159 ? sizes159[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(
    Svgr159,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes159.medium,
      height: resolvedSize || sizes159.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusTip.tsx
var import_jsx_runtime161 = require("react/jsx-runtime");
var Svgr160 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("path", { fill: "currentcolor", d: "M12.001 2.2c-5.4 0-9.8 4.4-9.8 9.8s4.4 9.8 9.8 9.8 9.8-4.4 9.8-9.8-4.4-9.8-9.8-9.8Zm0 18c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime161.jsx)("path", { fill: "currentcolor", d: "M12.001 7.1c-1.5 0-2.8 1.2-2.8 2.8 0 .4.3.8.8.8s.8-.3.8-.8c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2c0 .4-.2.6-.7.9-.6.4-1.3 1.1-1.3 2.2v.2c0 .4.3.8.8.8s.8-.3.8-.8V13c0-.4.2-.6.7-1 .4-.2 1.3-.9 1.3-2.2 0-1.5-1.3-2.7-2.8-2.7ZM12.001 15.2c-.3 0-.5.1-.7.3-.2.2-.3.5-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" })
  ] }));
};
var sizes160 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusTip(_a) {
  var _b = _a, {
    title = "Tip",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes160 ? sizes160[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(
    Svgr160,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes160.medium,
      height: resolvedSize || sizes160.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusTipFilled.tsx
var import_jsx_runtime162 = require("react/jsx-runtime");
var Svgr161 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime162.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime162.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime162.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M12.001 21.8c5.412 0 9.8-4.388 9.8-9.8 0-5.413-4.387-9.8-9.8-9.8-5.413 0-9.8 4.387-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8Zm-2.8-11.9c0-1.6 1.3-2.8 2.8-2.8 1.5 0 2.8 1.2 2.8 2.7 0 1.3-.9 2-1.3 2.2-.5.4-.7.6-.7 1v.2c0 .5-.3.8-.8.8s-.8-.4-.8-.8V13c0-1.1.7-1.8 1.3-2.2.5-.3.7-.5.7-.9 0-.6-.6-1.2-1.2-1.2s-1.2.5-1.2 1.2c0 .5-.3.8-.8.8s-.8-.4-.8-.8Zm2.1 5.6c.2-.2.4-.3.7-.3.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1c0-.2.1-.5.3-.7Z", clipRule: "evenodd" })
  ] }));
};
var sizes161 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusTipFilled(_a) {
  var _b = _a, {
    title = "Tip",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes161 ? sizes161[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
    Svgr161,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes161.medium,
      height: resolvedSize || sizes161.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusWarning.tsx
var import_jsx_runtime163 = require("react/jsx-runtime");
var Svgr162 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime163.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)("path", { fill: "currentcolor", d: "M12 13.9c.4 0 .8-.3.8-.8V9.4c0-.4-.3-.8-.8-.8s-.7.4-.7.8v3.7c0 .4.3.8.7.8ZM12 15.4c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1Z" }),
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)("path", { fill: "currentcolor", d: "M22.3 17.2 14.7 3.8c-.6-1-1.6-1.6-2.7-1.6s-2.1.6-2.7 1.6L1.7 17.2c-.6 1-.5 2.1 0 3.1.6 1 1.6 1.5 2.7 1.5h15.3c1.1 0 2.1-.6 2.7-1.5.5-1 .5-2.2-.1-3.1ZM21 19.5c-.3.5-.8.8-1.4.8H4.3c-.6 0-1.1-.3-1.4-.8-.3-.5-.3-1.1 0-1.6l7.7-13.4c.3-.5.8-.8 1.4-.8.6 0 1.1.3 1.4.8L21 17.9c.3.5.3 1.1 0 1.6Z" })
  ] }));
};
var sizes162 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusWarning(_a) {
  var _b = _a, {
    title = "Warning",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes162 ? sizes162[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
    Svgr162,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes162.medium,
      height: resolvedSize || sizes162.medium
    }, otherOverrideProps)
  );
}

// .svgr-output/web/IconStatusWarningFilled.tsx
var import_jsx_runtime164 = require("react/jsx-runtime");
var Svgr163 = (_a) => {
  var _b = _a, {
    title,
    titleId
  } = _b, props = __objRest(_b, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime164.jsxs)("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", role: "img", "aria-labelledby": titleId }, props), { children: [
    title ? /* @__PURE__ */ (0, import_jsx_runtime164.jsx)("title", { id: titleId, children: title }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime164.jsx)("path", { fill: "currentcolor", fillRule: "evenodd", d: "M22.3 17.2 14.7 3.8c-.6-1-1.6-1.6-2.7-1.6s-2.1.6-2.7 1.6L1.7 17.2c-.6 1-.5 2.1 0 3.1.6 1 1.6 1.5 2.7 1.5h15.3c1.1 0 2.1-.6 2.7-1.5.5-1 .5-2.2-.1-3.1Zm-9.288-.796a1.006 1.006 0 1 1-2.012 0 1.006 1.006 0 0 1 2.012 0ZM12.8 13.1c0 .5-.4.8-.8.8s-.7-.4-.7-.8V9.4c0-.4.2-.8.7-.8.5 0 .8.4.8.8v3.7Z", clipRule: "evenodd" })
  ] }));
};
var sizes163 = {
  small: 16,
  medium: 24,
  large: 32
};
function IconStatusWarningFilled(_a) {
  var _b = _a, {
    title = "Warning",
    color,
    customColorOverride,
    size,
    customSizeOverride
  } = _b, otherOverrideProps = __objRest(_b, [
    "title",
    "color",
    "customColorOverride",
    "size",
    "customSizeOverride"
  ]);
  const { colors } = useIconsConfig();
  const resolvedColor = color && color in colors ? colors[color] : customColorOverride;
  const resolvedSize = size && size in sizes163 ? sizes163[size] : customSizeOverride;
  return /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(
    Svgr163,
    __spreadValues({
      title,
      color: resolvedColor || "currentcolor",
      width: resolvedSize || sizes163.medium,
      height: resolvedSize || sizes163.medium
    }, otherOverrideProps)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IconActionAdd,
  IconActionAddAttachment,
  IconActionAddFromSearch,
  IconActionAddImage,
  IconActionAddNote,
  IconActionArchiveItem,
  IconActionCallSupport,
  IconActionClear,
  IconActionCloseModal,
  IconActionClosePanel,
  IconActionCloseTable,
  IconActionCollapseSection,
  IconActionCopy,
  IconActionDatePicker,
  IconActionDelete,
  IconActionDownloadFile,
  IconActionDropdownExpand,
  IconActionEdit,
  IconActionExpandSection,
  IconActionFavorited,
  IconActionGenerateDocument,
  IconActionGoBack,
  IconActionGoToDetails,
  IconActionGoToNextItems,
  IconActionGoToNextPage,
  IconActionGoToPreviousItems,
  IconActionGoToPreviousPage,
  IconActionLocationPicker,
  IconActionLogin,
  IconActionLogout,
  IconActionMaskField,
  IconActionNotifications,
  IconActionNotificationsFilled,
  IconActionOpenInWindow,
  IconActionOpenInfo,
  IconActionOpenMessages,
  IconActionRated,
  IconActionReassignItem,
  IconActionRefer,
  IconActionRemove,
  IconActionReset,
  IconActionSaveToCloud,
  IconActionSearch,
  IconActionSelectListExpand,
  IconActionSendMessage,
  IconActionShareLink,
  IconActionShowFilters,
  IconActionShowMenu,
  IconActionShowOptions,
  IconActionShowPreview,
  IconActionStopProcess,
  IconActionUnfavorited,
  IconActionUnmaskField,
  IconActionUnrated,
  IconActionUserAvatar,
  IconActionViewAsCards,
  IconActionViewAsList,
  IconActionWatchInterview,
  IconDescriptiveActionItems,
  IconDescriptiveBenefits,
  IconDescriptiveBuilding,
  IconDescriptiveCalendar,
  IconDescriptiveClock,
  IconDescriptiveEducation,
  IconDescriptiveFacility,
  IconDescriptiveHealthSystem,
  IconDescriptiveLicense,
  IconDescriptiveLocation,
  IconDescriptiveMealBreak,
  IconDescriptiveNotes,
  IconDescriptiveOfferExtended,
  IconDescriptivePayRate,
  IconDescriptivePlacementHistory,
  IconDescriptiveQuicklySubmtted,
  IconDescriptiveReference,
  IconDescriptiveReminder,
  IconDescriptiveRestBreak,
  IconDescriptiveSecuredField,
  IconDescriptiveShiftType,
  IconDescriptiveShiftsList,
  IconDescriptiveSignature,
  IconDescriptiveStartDate,
  IconDescriptiveSupport,
  IconDescriptiveTechnology,
  IconDescriptiveToday,
  IconDescriptiveTopMatches,
  IconDescriptiveUnworkedType,
  IconDescriptiveWeather,
  IconDescriptiveWorkExperience,
  IconDescriptiveWorkType,
  IconFeature1stToApply,
  IconFeature1stToApplyFilled,
  IconFeatureAutoOffer,
  IconFeatureAutoOfferFilled,
  IconFeatureBoostedCampaign,
  IconFeatureCareerStarter,
  IconFeatureCareerStarterFilled,
  IconFeatureClosingSoon,
  IconFeatureClosingSoonFilled,
  IconFeatureEasyApply,
  IconFeatureEasyApplyFilled,
  IconFeatureExclusive,
  IconFeatureExclusiveFilled,
  IconFeatureLowCOLI,
  IconFeatureLowCOLIFilled,
  IconFeatureNearby,
  IconFeatureNearbyFilled,
  IconFeatureNew,
  IconFeatureNewItem,
  IconFeatureNewItemFilled,
  IconFeatureOneClick,
  IconFeatureOneClickFilled,
  IconFeaturePayRate,
  IconFeaturePayRateFilled,
  IconFeatureQuickOffer,
  IconFeatureQuickOfferFilled,
  IconFeatureSocialProof,
  IconFeatureSocialProofFilled,
  IconFeatureTopHospital,
  IconFeatureTopHospitalFilled,
  IconFeatureTopMatch,
  IconFeatureTopMatchFilled,
  IconNavigationHelp,
  IconNavigationHome,
  IconNavigationHomeFilled,
  IconNavigationMessages,
  IconNavigationMessagesFilled,
  IconNavigationNotes,
  IconNavigationNotesFilled,
  IconNavigationSettings,
  IconNavigationSupport,
  IconNavigationTimekeeping,
  IconNavigationTimekeepingFilled,
  IconSocialFacebook,
  IconSocialInstagram,
  IconSocialLinkedIn,
  IconSocialTiktok,
  IconSocialTwitter,
  IconStatusFail,
  IconStatusFailFilled,
  IconStatusGeneralNotification,
  IconStatusGeneralNotificationFilled,
  IconStatusInfo,
  IconStatusInfoFilled,
  IconStatusProcessComplete,
  IconStatusProcessInDraft,
  IconStatusProcessInProgress,
  IconStatusProcessIncomplete,
  IconStatusProcessNotQualified,
  IconStatusProcessNotStarted,
  IconStatusProcessPaused,
  IconStatusProcessProcessing,
  IconStatusProcessReadyForReview,
  IconStatusProcessWaiting,
  IconStatusStepComplete,
  IconStatusStepInDraft,
  IconStatusStepStarted,
  IconStatusSuccess,
  IconStatusSuccessFilled,
  IconStatusTip,
  IconStatusTipFilled,
  IconStatusWarning,
  IconStatusWarningFilled,
  IconsConfigProvider,
  useIconsConfig
});
/*! Generated by ℹ️ Icon Builder on Fri, 08 Sep 2023 05:35:49 GMT */
/*! See: https://github.com/NomadHealth/design-system/blob/main/icon-builder/README.md */
/*! Generated by ℹ️ Icon Builder on Fri, 08 Sep 2023 05:35:50 GMT */
/*! Generated by ℹ️ Icon Builder on Fri, 08 Sep 2023 05:35:46 GMT */
